
      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("lcSRC", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   v4.2.8+1e68dce6
 */ (function(global1, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    function objectOrFunction(x) {
        var type = typeof x;
        return x !== null && (type === "object" || type === "function");
    }
    function isFunction(x) {
        return typeof x === "function";
    }
    var _isArray = void 0;
    if (Array.isArray) _isArray = Array.isArray;
    else _isArray = function(x) {
        return Object.prototype.toString.call(x) === "[object Array]";
    };
    var isArray = _isArray;
    var len = 0;
    var vertxNext = void 0;
    var customSchedulerFn = void 0;
    var asap = function asap(callback, arg) {
        queue[len] = callback;
        queue[len + 1] = arg;
        len += 2;
        if (len === 2) {
            // If len is 2, that means that we need to schedule an async flush.
            // If additional callbacks are queued before the queue is flushed, they
            // will be processed by this flush that we are scheduling.
            if (customSchedulerFn) customSchedulerFn(flush);
            else scheduleFlush();
        }
    };
    function setScheduler(scheduleFn) {
        customSchedulerFn = scheduleFn;
    }
    function setAsap(asapFn) {
        asap = asapFn;
    }
    var browserWindow = typeof window !== "undefined" ? window : undefined;
    var browserGlobal = browserWindow || {};
    var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
    var isNode = typeof self === "undefined" && typeof $hPtJY !== "undefined" && ({}).toString.call($hPtJY) === "[object process]";
    // test for web worker but not in IE10
    var isWorker = typeof Uint8ClampedArray !== "undefined" && typeof importScripts !== "undefined" && typeof MessageChannel !== "undefined";
    // node
    function useNextTick() {
        // node version 0.10.x displays a deprecation warning when nextTick is used recursively
        // see https://github.com/cujojs/when/issues/410 for details
        return function() {
            return $hPtJY.nextTick(flush);
        };
    }
    // vertx
    function useVertxTimer() {
        if (typeof vertxNext !== "undefined") return function() {
            vertxNext(flush);
        };
        return useSetTimeout();
    }
    function useMutationObserver() {
        var iterations = 0;
        var observer = new BrowserMutationObserver(flush);
        var node = document.createTextNode("");
        observer.observe(node, {
            characterData: true
        });
        return function() {
            node.data = iterations = ++iterations % 2;
        };
    }
    // web worker
    function useMessageChannel() {
        var channel = new MessageChannel();
        channel.port1.onmessage = flush;
        return function() {
            return channel.port2.postMessage(0);
        };
    }
    function useSetTimeout() {
        // Store setTimeout reference so es6-promise will be unaffected by
        // other code modifying setTimeout (like sinon.useFakeTimers())
        var globalSetTimeout = setTimeout;
        return function() {
            return globalSetTimeout(flush, 1);
        };
    }
    var queue = new Array(1000);
    function flush() {
        for(var i = 0; i < len; i += 2){
            var callback = queue[i];
            var arg = queue[i + 1];
            callback(arg);
            queue[i] = undefined;
            queue[i + 1] = undefined;
        }
        len = 0;
    }
    function attemptVertx() {
        try {
            var vertx = Function("return this")().require("vertx");
            vertxNext = vertx.runOnLoop || vertx.runOnContext;
            return useVertxTimer();
        } catch (e) {
            return useSetTimeout();
        }
    }
    var scheduleFlush = void 0;
    // Decide what async method to use to triggering processing of queued callbacks:
    if (isNode) scheduleFlush = useNextTick();
    else if (BrowserMutationObserver) scheduleFlush = useMutationObserver();
    else if (isWorker) scheduleFlush = useMessageChannel();
    else if (browserWindow === undefined && true) scheduleFlush = attemptVertx();
    else scheduleFlush = useSetTimeout();
    function then(onFulfillment, onRejection) {
        var parent = this;
        var child = new this.constructor(noop);
        if (child[PROMISE_ID] === undefined) makePromise(child);
        var _state = parent._state;
        if (_state) {
            var callback = arguments[_state - 1];
            asap(function() {
                return invokeCallback(_state, child, callback, parent._result);
            });
        } else subscribe(parent, child, onFulfillment, onRejection);
        return child;
    }
    /**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/ function resolve$1(object) {
        /*jshint validthis:true */ var Constructor = this;
        if (object && typeof object === "object" && object.constructor === Constructor) return object;
        var promise = new Constructor(noop);
        resolve(promise, object);
        return promise;
    }
    var PROMISE_ID = Math.random().toString(36).substring(2);
    function noop() {}
    var PENDING = void 0;
    var FULFILLED = 1;
    var REJECTED = 2;
    function selfFulfillment() {
        return new TypeError("You cannot resolve a promise with itself");
    }
    function cannotReturnOwn() {
        return new TypeError("A promises callback cannot return that same promise.");
    }
    function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
        try {
            then$$1.call(value, fulfillmentHandler, rejectionHandler);
        } catch (e) {
            return e;
        }
    }
    function handleForeignThenable(promise, thenable, then$$1) {
        asap(function(promise) {
            var sealed = false;
            var error = tryThen(then$$1, thenable, function(value) {
                if (sealed) return;
                sealed = true;
                if (thenable !== value) resolve(promise, value);
                else fulfill(promise, value);
            }, function(reason) {
                if (sealed) return;
                sealed = true;
                reject(promise, reason);
            }, "Settle: " + (promise._label || " unknown promise"));
            if (!sealed && error) {
                sealed = true;
                reject(promise, error);
            }
        }, promise);
    }
    function handleOwnThenable(promise, thenable) {
        if (thenable._state === FULFILLED) fulfill(promise, thenable._result);
        else if (thenable._state === REJECTED) reject(promise, thenable._result);
        else subscribe(thenable, undefined, function(value) {
            return resolve(promise, value);
        }, function(reason) {
            return reject(promise, reason);
        });
    }
    function handleMaybeThenable(promise, maybeThenable, then$$1) {
        if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) handleOwnThenable(promise, maybeThenable);
        else {
            if (then$$1 === undefined) fulfill(promise, maybeThenable);
            else if (isFunction(then$$1)) handleForeignThenable(promise, maybeThenable, then$$1);
            else fulfill(promise, maybeThenable);
        }
    }
    function resolve(promise, value) {
        if (promise === value) reject(promise, selfFulfillment());
        else if (objectOrFunction(value)) {
            var then$$1 = void 0;
            try {
                then$$1 = value.then;
            } catch (error) {
                reject(promise, error);
                return;
            }
            handleMaybeThenable(promise, value, then$$1);
        } else fulfill(promise, value);
    }
    function publishRejection(promise) {
        if (promise._onerror) promise._onerror(promise._result);
        publish(promise);
    }
    function fulfill(promise, value) {
        if (promise._state !== PENDING) return;
        promise._result = value;
        promise._state = FULFILLED;
        if (promise._subscribers.length !== 0) asap(publish, promise);
    }
    function reject(promise, reason) {
        if (promise._state !== PENDING) return;
        promise._state = REJECTED;
        promise._result = reason;
        asap(publishRejection, promise);
    }
    function subscribe(parent, child, onFulfillment, onRejection) {
        var _subscribers = parent._subscribers;
        var length = _subscribers.length;
        parent._onerror = null;
        _subscribers[length] = child;
        _subscribers[length + FULFILLED] = onFulfillment;
        _subscribers[length + REJECTED] = onRejection;
        if (length === 0 && parent._state) asap(publish, parent);
    }
    function publish(promise) {
        var subscribers = promise._subscribers;
        var settled = promise._state;
        if (subscribers.length === 0) return;
        var child = void 0, callback = void 0, detail = promise._result;
        for(var i = 0; i < subscribers.length; i += 3){
            child = subscribers[i];
            callback = subscribers[i + settled];
            if (child) invokeCallback(settled, child, callback, detail);
            else callback(detail);
        }
        promise._subscribers.length = 0;
    }
    function invokeCallback(settled, promise, callback, detail) {
        var hasCallback = isFunction(callback), value = void 0, error = void 0, succeeded = true;
        if (hasCallback) {
            try {
                value = callback(detail);
            } catch (e) {
                succeeded = false;
                error = e;
            }
            if (promise === value) {
                reject(promise, cannotReturnOwn());
                return;
            }
        } else value = detail;
        if (promise._state !== PENDING) ;
        else if (hasCallback && succeeded) resolve(promise, value);
        else if (succeeded === false) reject(promise, error);
        else if (settled === FULFILLED) fulfill(promise, value);
        else if (settled === REJECTED) reject(promise, value);
    }
    function initializePromise(promise, resolver) {
        try {
            resolver(function resolvePromise(value) {
                resolve(promise, value);
            }, function rejectPromise(reason) {
                reject(promise, reason);
            });
        } catch (e) {
            reject(promise, e);
        }
    }
    var id = 0;
    function nextId() {
        return id++;
    }
    function makePromise(promise) {
        promise[PROMISE_ID] = id++;
        promise._state = undefined;
        promise._result = undefined;
        promise._subscribers = [];
    }
    function validationError() {
        return new Error("Array Methods must be provided an Array");
    }
    var Enumerator = function() {
        function Enumerator(Constructor, input) {
            this._instanceConstructor = Constructor;
            this.promise = new Constructor(noop);
            if (!this.promise[PROMISE_ID]) makePromise(this.promise);
            if (isArray(input)) {
                this.length = input.length;
                this._remaining = input.length;
                this._result = new Array(this.length);
                if (this.length === 0) fulfill(this.promise, this._result);
                else {
                    this.length = this.length || 0;
                    this._enumerate(input);
                    if (this._remaining === 0) fulfill(this.promise, this._result);
                }
            } else reject(this.promise, validationError());
        }
        Enumerator.prototype._enumerate = function _enumerate(input) {
            for(var i = 0; this._state === PENDING && i < input.length; i++)this._eachEntry(input[i], i);
        };
        Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
            var c = this._instanceConstructor;
            var resolve$$1 = c.resolve;
            if (resolve$$1 === resolve$1) {
                var _then = void 0;
                var error = void 0;
                var didError = false;
                try {
                    _then = entry.then;
                } catch (e) {
                    didError = true;
                    error = e;
                }
                if (_then === then && entry._state !== PENDING) this._settledAt(entry._state, i, entry._result);
                else if (typeof _then !== "function") {
                    this._remaining--;
                    this._result[i] = entry;
                } else if (c === Promise$1) {
                    var promise = new c(noop);
                    if (didError) reject(promise, error);
                    else handleMaybeThenable(promise, entry, _then);
                    this._willSettleAt(promise, i);
                } else this._willSettleAt(new c(function(resolve$$1) {
                    return resolve$$1(entry);
                }), i);
            } else this._willSettleAt(resolve$$1(entry), i);
        };
        Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
            var promise = this.promise;
            if (promise._state === PENDING) {
                this._remaining--;
                if (state === REJECTED) reject(promise, value);
                else this._result[i] = value;
            }
            if (this._remaining === 0) fulfill(promise, this._result);
        };
        Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
            var enumerator = this;
            subscribe(promise, undefined, function(value) {
                return enumerator._settledAt(FULFILLED, i, value);
            }, function(reason) {
                return enumerator._settledAt(REJECTED, i, reason);
            });
        };
        return Enumerator;
    }();
    /**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/ function all(entries) {
        return new Enumerator(this, entries).promise;
    }
    /**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/ function race(entries) {
        /*jshint validthis:true */ var Constructor = this;
        if (!isArray(entries)) return new Constructor(function(_, reject) {
            return reject(new TypeError("You must pass an array to race."));
        });
        else return new Constructor(function(resolve, reject) {
            var length = entries.length;
            for(var i = 0; i < length; i++)Constructor.resolve(entries[i]).then(resolve, reject);
        });
    }
    /**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/ function reject$1(reason) {
        /*jshint validthis:true */ var Constructor = this;
        var promise = new Constructor(noop);
        reject(promise, reason);
        return promise;
    }
    function needsResolver() {
        throw new TypeError("You must pass a resolver function as the first argument to the promise constructor");
    }
    function needsNew() {
        throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
    }
    /**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {Function} resolver
  Useful for tooling.
  @constructor
*/ var Promise$1 = function() {
        function Promise(resolver) {
            this[PROMISE_ID] = nextId();
            this._result = this._state = undefined;
            this._subscribers = [];
            if (noop !== resolver) {
                typeof resolver !== "function" && needsResolver();
                this instanceof Promise ? initializePromise(this, resolver) : needsNew();
            }
        }
        /**
  The primary way of interacting with a promise is through its `then` method,
  which registers callbacks to receive either a promise's eventual value or the
  reason why the promise cannot be fulfilled.
   ```js
  findUser().then(function(user){
    // user is available
  }, function(reason){
    // user is unavailable, and you are given the reason why
  });
  ```
   Chaining
  --------
   The return value of `then` is itself a promise.  This second, 'downstream'
  promise is resolved with the return value of the first promise's fulfillment
  or rejection handler, or rejected if the handler throws an exception.
   ```js
  findUser().then(function (user) {
    return user.name;
  }, function (reason) {
    return 'default name';
  }).then(function (userName) {
    // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
    // will be `'default name'`
  });
   findUser().then(function (user) {
    throw new Error('Found user, but still unhappy');
  }, function (reason) {
    throw new Error('`findUser` rejected and we're unhappy');
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
    // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
  });
  ```
  If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
   ```js
  findUser().then(function (user) {
    throw new PedagogicalException('Upstream error');
  }).then(function (value) {
    // never reached
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // The `PedgagocialException` is propagated all the way down to here
  });
  ```
   Assimilation
  ------------
   Sometimes the value you want to propagate to a downstream promise can only be
  retrieved asynchronously. This can be achieved by returning a promise in the
  fulfillment or rejection handler. The downstream promise will then be pending
  until the returned promise is settled. This is called *assimilation*.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // The user's comments are now available
  });
  ```
   If the assimliated promise rejects, then the downstream promise will also reject.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // If `findCommentsByAuthor` fulfills, we'll have the value here
  }, function (reason) {
    // If `findCommentsByAuthor` rejects, we'll have the reason here
  });
  ```
   Simple Example
  --------------
   Synchronous Example
   ```javascript
  let result;
   try {
    result = findResult();
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
  findResult(function(result, err){
    if (err) {
      // failure
    } else {
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findResult().then(function(result){
    // success
  }, function(reason){
    // failure
  });
  ```
   Advanced Example
  --------------
   Synchronous Example
   ```javascript
  let author, books;
   try {
    author = findAuthor();
    books  = findBooksByAuthor(author);
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
   function foundBooks(books) {
   }
   function failure(reason) {
   }
   findAuthor(function(author, err){
    if (err) {
      failure(err);
      // failure
    } else {
      try {
        findBoooksByAuthor(author, function(books, err) {
          if (err) {
            failure(err);
          } else {
            try {
              foundBooks(books);
            } catch(reason) {
              failure(reason);
            }
          }
        });
      } catch(error) {
        failure(err);
      }
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findAuthor().
    then(findBooksByAuthor).
    then(function(books){
      // found books
  }).catch(function(reason){
    // something went wrong
  });
  ```
   @method then
  @param {Function} onFulfilled
  @param {Function} onRejected
  Useful for tooling.
  @return {Promise}
  */ /**
  `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
  as the catch block of a try/catch statement.
  ```js
  function findAuthor(){
  throw new Error('couldn't find that author');
  }
  // synchronous
  try {
  findAuthor();
  } catch(reason) {
  // something went wrong
  }
  // async with promises
  findAuthor().catch(function(reason){
  // something went wrong
  });
  ```
  @method catch
  @param {Function} onRejection
  Useful for tooling.
  @return {Promise}
  */ Promise.prototype.catch = function _catch(onRejection) {
            return this.then(null, onRejection);
        };
        /**
    `finally` will be invoked regardless of the promise's fate just as native
    try/catch/finally behaves
  
    Synchronous example:
  
    ```js
    findAuthor() {
      if (Math.random() > 0.5) {
        throw new Error();
      }
      return new Author();
    }
  
    try {
      return findAuthor(); // succeed or fail
    } catch(error) {
      return findOtherAuther();
    } finally {
      // always runs
      // doesn't affect the return value
    }
    ```
  
    Asynchronous example:
  
    ```js
    findAuthor().catch(function(reason){
      return findOtherAuther();
    }).finally(function(){
      // author was either found, or not
    });
    ```
  
    @method finally
    @param {Function} callback
    @return {Promise}
  */ Promise.prototype.finally = function _finally(callback) {
            var promise = this;
            var constructor = promise.constructor;
            if (isFunction(callback)) return promise.then(function(value) {
                return constructor.resolve(callback()).then(function() {
                    return value;
                });
            }, function(reason) {
                return constructor.resolve(callback()).then(function() {
                    throw reason;
                });
            });
            return promise.then(callback, callback);
        };
        return Promise;
    }();
    Promise$1.prototype.then = then;
    Promise$1.all = all;
    Promise$1.race = race;
    Promise$1.resolve = resolve$1;
    Promise$1.reject = reject$1;
    Promise$1._setScheduler = setScheduler;
    Promise$1._setAsap = setAsap;
    Promise$1._asap = asap;
    /*global self*/ function polyfill() {
        var local = void 0;
        if (typeof $parcel$global !== "undefined") local = $parcel$global;
        else if (typeof self !== "undefined") local = self;
        else try {
            local = Function("return this")();
        } catch (e) {
            throw new Error("polyfill failed because global object is unavailable in this environment");
        }
        var P = local.Promise;
        if (P) {
            var promiseToString = null;
            try {
                promiseToString = Object.prototype.toString.call(P.resolve());
            } catch (e) {
            // silently ignored
            }
            if (promiseToString === "[object Promise]" && !P.cast) return;
        }
        local.Promise = Promise$1;
    }
    // Strange compat..
    Promise$1.polyfill = polyfill;
    Promise$1.Promise = Promise$1;
    return Promise$1;
});

});
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});


var $735dce6d90977bd4$exports = {};
// This file can be required in Browserify and Node.js for automatic polyfill
// To use it:  require('es6-promise/auto');
"use strict";

$735dce6d90977bd4$exports = (parcelRequire("lcSRC")).polyfill();


!function(e) {
    if (!e.hasInitialised) {
        var t = {
            escapeRegExp: function(e) {
                return e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
            },
            hasClass: function(e, t) {
                var i = " ";
                return 1 === e.nodeType && (i + e.className + i).replace(/[\n\t]/g, i).indexOf(i + t + i) >= 0;
            },
            addClass: function(e, t) {
                e.className += " " + t;
            },
            removeClass: function(e, t) {
                var i = new RegExp("\\b" + this.escapeRegExp(t) + "\\b");
                e.className = e.className.replace(i, "");
            },
            interpolateString: function(e, t) {
                return e.replace(/{{([a-z][a-z0-9\-_]*)}}/gi, function(e) {
                    return t(arguments[1]) || "";
                });
            },
            getCookie: function(e) {
                var t = ("; " + document.cookie).split("; " + e + "=");
                return t.length < 2 ? void 0 : t.pop().split(";").shift();
            },
            setCookie: function(e, t, i, n, o, s) {
                var r = new Date;
                r.setHours(r.getHours() + 24 * (i || 365));
                var a = [
                    e + "=" + t,
                    "expires=" + r.toUTCString(),
                    "path=" + (o || "/")
                ];
                n && a.push("domain=" + n), s && a.push("secure"), document.cookie = a.join(";");
            },
            deepExtend: function(e, t) {
                for(var i in t)t.hasOwnProperty(i) && (i in e && this.isPlainObject(e[i]) && this.isPlainObject(t[i]) ? this.deepExtend(e[i], t[i]) : e[i] = t[i]);
                return e;
            },
            throttle: function(e, t) {
                var i = !1;
                return function() {
                    i || (e.apply(this, arguments), i = !0, setTimeout(function() {
                        i = !1;
                    }, t));
                };
            },
            hash: function(e) {
                var t, i, n = 0;
                if (0 === e.length) return n;
                for(t = 0, i = e.length; t < i; ++t)n = (n << 5) - n + e.charCodeAt(t), n |= 0;
                return n;
            },
            normaliseHex: function(e) {
                return "#" == e[0] && (e = e.substr(1)), 3 == e.length && (e = e[0] + e[0] + e[1] + e[1] + e[2] + e[2]), e;
            },
            getContrast: function(e) {
                return e = this.normaliseHex(e), (299 * parseInt(e.substr(0, 2), 16) + 587 * parseInt(e.substr(2, 2), 16) + 114 * parseInt(e.substr(4, 2), 16)) / 1e3 >= 128 ? "#000" : "#fff";
            },
            getLuminance: function(e) {
                var t = parseInt(this.normaliseHex(e), 16), i = 38 + (t >> 16), n = 38 + (t >> 8 & 255), o = 38 + (255 & t);
                return "#" + (16777216 + 65536 * (i < 255 ? i < 1 ? 0 : i : 255) + 256 * (n < 255 ? n < 1 ? 0 : n : 255) + (o < 255 ? o < 1 ? 0 : o : 255)).toString(16).slice(1);
            },
            isMobile: function() {
                return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
            },
            isPlainObject: function(e) {
                return "object" == typeof e && null !== e && e.constructor == Object;
            },
            traverseDOMPath: function(e, i) {
                return e && e.parentNode ? t.hasClass(e, i) ? e : this.traverseDOMPath(e.parentNode, i) : null;
            }
        };
        e.status = {
            deny: "deny",
            allow: "allow",
            dismiss: "dismiss"
        }, e.transitionEnd = function() {
            var e = document.createElement("div"), t = {
                t: "transitionend",
                OT: "oTransitionEnd",
                msT: "MSTransitionEnd",
                MozT: "transitionend",
                WebkitT: "webkitTransitionEnd"
            };
            for(var i in t)if (t.hasOwnProperty(i) && void 0 !== e.style[i + "ransition"]) return t[i];
            return "";
        }(), e.hasTransition = !!e.transitionEnd;
        var i = Object.keys(e.status).map(t.escapeRegExp);
        e.customStyles = {}, e.Popup = function() {
            var n = {
                enabled: !0,
                container: null,
                cookie: {
                    name: "cookieconsent_status",
                    path: "/",
                    domain: "",
                    expiryDays: 365,
                    secure: !1
                },
                onPopupOpen: function() {},
                onPopupClose: function() {},
                onInitialise: function(e) {},
                onStatusChange: function(e, t) {},
                onRevokeChoice: function() {},
                onNoCookieLaw: function(e, t) {},
                content: {
                    header: "Cookies used on the website!",
                    message: "This website uses cookies to ensure you get the best experience on our website.",
                    dismiss: "Got it!",
                    allow: "Allow cookies",
                    deny: "Decline",
                    link: "Learn more",
                    href: "https://www.cookiesandyou.com",
                    close: "&#x274c;",
                    target: "_blank",
                    policy: "Cookie Policy"
                },
                elements: {
                    header: '<span class="cc-header">{{header}}</span>&nbsp;',
                    message: '<span id="cookieconsent:desc" class="cc-message">{{message}}</span>',
                    messagelink: '<span id="cookieconsent:desc" class="cc-message">{{message}} <a aria-label="learn more about cookies" role=button tabindex="0" class="cc-link" href="{{href}}" rel="noopener noreferrer nofollow" target="{{target}}">{{link}}</a></span>',
                    dismiss: '<a aria-label="dismiss cookie message" role=button tabindex="0" class="cc-btn cc-dismiss">{{dismiss}}</a>',
                    allow: '<a aria-label="allow cookies" role=button tabindex="0"  class="cc-btn cc-allow">{{allow}}</a>',
                    deny: '<a aria-label="deny cookies" role=button tabindex="0" class="cc-btn cc-deny">{{deny}}</a>',
                    link: '<a aria-label="learn more about cookies" role=button tabindex="0" class="cc-link" href="{{href}}" rel="noopener noreferrer nofollow" target="{{target}}">{{link}}</a>',
                    close: '<span aria-label="dismiss cookie message" role=button tabindex="0" class="cc-close">{{close}}</span>'
                },
                window: '<div role="dialog" aria-live="polite" aria-label="cookieconsent" aria-describedby="cookieconsent:desc" class="cc-window {{classes}}"><!--googleoff: all-->{{children}}<!--googleon: all--></div>',
                revokeBtn: '<div class="cc-revoke {{classes}}">{{policy}}</div>',
                compliance: {
                    info: '<div class="cc-compliance">{{dismiss}}</div>',
                    "opt-in": '<div class="cc-compliance cc-highlight">{{deny}}{{allow}}</div>',
                    "opt-out": '<div class="cc-compliance cc-highlight">{{deny}}{{allow}}</div>'
                },
                type: "info",
                layouts: {
                    basic: "{{messagelink}}{{compliance}}",
                    "basic-close": "{{messagelink}}{{compliance}}{{close}}",
                    "basic-header": "{{header}}{{message}}{{link}}{{compliance}}"
                },
                layout: "basic",
                position: "bottom",
                theme: "block",
                static: !1,
                palette: null,
                revokable: !1,
                animateRevokable: !0,
                showLink: !0,
                dismissOnScroll: !1,
                dismissOnTimeout: !1,
                dismissOnWindowClick: !1,
                ignoreClicksFrom: [
                    "cc-revoke",
                    "cc-btn"
                ],
                autoOpen: !0,
                autoAttach: !0,
                whitelistPage: [],
                blacklistPage: [],
                overrideHTML: null
            };
            function o() {
                this.initialise.apply(this, arguments);
            }
            function s(e) {
                this.openingTimeout = null, t.removeClass(e, "cc-invisible");
            }
            function r(t) {
                t.style.display = "none", t.removeEventListener(e.transitionEnd, this.afterTransition), this.afterTransition = null;
            }
            function a() {
                var e = this.options.position.split("-"), t = [];
                return e.forEach(function(e) {
                    t.push("cc-" + e);
                }), t;
            }
            function c(n) {
                var o = this.options, s = document.createElement("div"), r = o.container && 1 === o.container.nodeType ? o.container : document.body;
                s.innerHTML = n;
                var a = s.children[0];
                return a.style.display = "none", t.hasClass(a, "cc-window") && e.hasTransition && t.addClass(a, "cc-invisible"), this.onButtonClick = (function(n) {
                    var o = t.traverseDOMPath(n.target, "cc-btn") || n.target;
                    if (t.hasClass(o, "cc-btn")) {
                        var s = o.className.match(new RegExp("\\bcc-(" + i.join("|") + ")\\b")), r = s && s[1] || !1;
                        r && (this.setStatus(r), this.close(!0));
                    }
                    t.hasClass(o, "cc-close") && (this.setStatus(e.status.dismiss), this.close(!0));
                    t.hasClass(o, "cc-revoke") && this.revokeChoice();
                }).bind(this), a.addEventListener("click", this.onButtonClick), o.autoAttach && (r.firstChild ? r.insertBefore(a, r.firstChild) : r.appendChild(a)), a;
            }
            function l(e) {
                return "000000" == (e = t.normaliseHex(e)) ? "#222" : t.getLuminance(e);
            }
            function u(e, t) {
                for(var i = 0, n = e.length; i < n; ++i){
                    var o = e[i];
                    if (o instanceof RegExp && o.test(t) || "string" == typeof o && o.length && o === t) return !0;
                }
                return !1;
            }
            return o.prototype.initialise = function(i) {
                this.options && this.destroy(), t.deepExtend(this.options = {}, n), t.isPlainObject(i) && t.deepExtend(this.options, i), (function() {
                    var t = this.options.onInitialise.bind(this);
                    if (!window.navigator.cookieEnabled) return t(e.status.deny), !0;
                    if (window.CookiesOK || window.navigator.CookiesOK) return t(e.status.allow), !0;
                    var i = Object.keys(e.status), n = this.getStatus(), o = i.indexOf(n) >= 0;
                    o && t(n);
                    return o;
                }).call(this) && (this.options.enabled = !1), u(this.options.blacklistPage, location.pathname) && (this.options.enabled = !1), u(this.options.whitelistPage, location.pathname) && (this.options.enabled = !0);
                var o = this.options.window.replace("{{classes}}", (function() {
                    var i = this.options, n = "top" == i.position || "bottom" == i.position ? "banner" : "floating";
                    t.isMobile() && (n = "floating");
                    var o = [
                        "cc-" + n,
                        "cc-type-" + i.type,
                        "cc-theme-" + i.theme
                    ];
                    i.static && o.push("cc-static");
                    o.push.apply(o, a.call(this));
                    (function(i) {
                        var n = t.hash(JSON.stringify(i)), o = "cc-color-override-" + n, s = t.isPlainObject(i);
                        this.customStyleSelector = s ? o : null, s && function(i, n, o) {
                            if (e.customStyles[i]) return void ++e.customStyles[i].references;
                            var s = {}, r = n.popup, a = n.button, c = n.highlight;
                            r && (r.text = r.text ? r.text : t.getContrast(r.background), r.link = r.link ? r.link : r.text, s[o + ".cc-window"] = [
                                "color: " + r.text,
                                "background-color: " + r.background
                            ], s[o + ".cc-revoke"] = [
                                "color: " + r.text,
                                "background-color: " + r.background
                            ], s[o + " .cc-link," + o + " .cc-link:active," + o + " .cc-link:visited"] = [
                                "color: " + r.link
                            ], a && (a.text = a.text ? a.text : t.getContrast(a.background), a.border = a.border ? a.border : "transparent", s[o + " .cc-btn"] = [
                                "color: " + a.text,
                                "border-color: " + a.border,
                                "background-color: " + a.background
                            ], a.padding && s[o + " .cc-btn"].push("padding: " + a.padding), "transparent" != a.background && (s[o + " .cc-btn:hover, " + o + " .cc-btn:focus"] = [
                                "background-color: " + (a.hover || l(a.background))
                            ]), c ? (c.text = c.text ? c.text : t.getContrast(c.background), c.border = c.border ? c.border : "transparent", s[o + " .cc-highlight .cc-btn:first-child"] = [
                                "color: " + c.text,
                                "border-color: " + c.border,
                                "background-color: " + c.background
                            ]) : s[o + " .cc-highlight .cc-btn:first-child"] = [
                                "color: " + r.text
                            ]));
                            var u = document.createElement("style");
                            document.head.appendChild(u), e.customStyles[i] = {
                                references: 1,
                                element: u.sheet
                            };
                            var h = -1;
                            for(var p in s)s.hasOwnProperty(p) && u.sheet.insertRule(p + "{" + s[p].join(";") + "}", ++h);
                        }(n, i, "." + o);
                        return s;
                    }).call(this, this.options.palette);
                    this.customStyleSelector && o.push(this.customStyleSelector);
                    return o;
                }).call(this).join(" ")).replace("{{children}}", (function() {
                    var e = {}, i = this.options;
                    i.showLink || (i.elements.link = "", i.elements.messagelink = i.elements.message);
                    Object.keys(i.elements).forEach(function(n) {
                        e[n] = t.interpolateString(i.elements[n], function(e) {
                            var t = i.content[e];
                            return e && "string" == typeof t && t.length ? t : "";
                        });
                    });
                    var n = i.compliance[i.type];
                    n || (n = i.compliance.info);
                    e.compliance = t.interpolateString(n, function(t) {
                        return e[t];
                    });
                    var o = i.layouts[i.layout];
                    o || (o = i.layouts.basic);
                    return t.interpolateString(o, function(t) {
                        return e[t];
                    });
                }).call(this)), s = this.options.overrideHTML;
                if ("string" == typeof s && s.length && (o = s), this.options.static) {
                    var r = c.call(this, '<div class="cc-grower">' + o + "</div>");
                    r.style.display = "", this.element = r.firstChild, this.element.style.display = "none", t.addClass(this.element, "cc-invisible");
                } else this.element = c.call(this, o);
                (function() {
                    var i = this.setStatus.bind(this), n = this.close.bind(this), o = this.options.dismissOnTimeout;
                    "number" == typeof o && o >= 0 && (this.dismissTimeout = window.setTimeout(function() {
                        i(e.status.dismiss), n(!0);
                    }, Math.floor(o)));
                    var s = this.options.dismissOnScroll;
                    if ("number" == typeof s && s >= 0) {
                        var r = function(t) {
                            window.pageYOffset > Math.floor(s) && (i(e.status.dismiss), n(!0), window.removeEventListener("scroll", r), this.onWindowScroll = null);
                        };
                        this.options.enabled && (this.onWindowScroll = r, window.addEventListener("scroll", r));
                    }
                    var a = this.options.dismissOnWindowClick, c = this.options.ignoreClicksFrom;
                    if (a) {
                        var l = (function(o) {
                            for(var s = !1, r = o.path.length, a = c.length, u = 0; u < r; u++)if (!s) for(var h = 0; h < a; h++)s || (s = t.hasClass(o.path[u], c[h]));
                            s || (i(e.status.dismiss), n(!0), window.removeEventListener("click", l), window.removeEventListener("touchend", l), this.onWindowClick = null);
                        }).bind(this);
                        this.options.enabled && (this.onWindowClick = l, window.addEventListener("click", l), window.addEventListener("touchend", l));
                    }
                }).call(this), (function() {
                    "info" != this.options.type && (this.options.revokable = !0);
                    t.isMobile() && (this.options.animateRevokable = !1);
                    if (this.options.revokable) {
                        var e = a.call(this);
                        this.options.animateRevokable && e.push("cc-animate"), this.customStyleSelector && e.push(this.customStyleSelector);
                        var i = this.options.revokeBtn.replace("{{classes}}", e.join(" ")).replace("{{policy}}", this.options.content.policy);
                        this.revokeBtn = c.call(this, i);
                        var n = this.revokeBtn;
                        if (this.options.animateRevokable) {
                            var o = t.throttle(function(e) {
                                var i = !1, o = window.innerHeight - 20;
                                t.hasClass(n, "cc-top") && e.clientY < 20 && (i = !0), t.hasClass(n, "cc-bottom") && e.clientY > o && (i = !0), i ? t.hasClass(n, "cc-active") || t.addClass(n, "cc-active") : t.hasClass(n, "cc-active") && t.removeClass(n, "cc-active");
                            }, 200);
                            this.onMouseMove = o, window.addEventListener("mousemove", o);
                        }
                    }
                }).call(this), this.options.autoOpen && this.autoOpen();
            }, o.prototype.destroy = function() {
                this.onButtonClick && this.element && (this.element.removeEventListener("click", this.onButtonClick), this.onButtonClick = null), this.dismissTimeout && (clearTimeout(this.dismissTimeout), this.dismissTimeout = null), this.onWindowScroll && (window.removeEventListener("scroll", this.onWindowScroll), this.onWindowScroll = null), this.onWindowClick && (window.removeEventListener("click", this.onWindowClick), this.onWindowClick = null), this.onMouseMove && (window.removeEventListener("mousemove", this.onMouseMove), this.onMouseMove = null), this.element && this.element.parentNode && this.element.parentNode.removeChild(this.element), this.element = null, this.revokeBtn && this.revokeBtn.parentNode && this.revokeBtn.parentNode.removeChild(this.revokeBtn), this.revokeBtn = null, function(i) {
                    if (t.isPlainObject(i)) {
                        var n = t.hash(JSON.stringify(i)), o = e.customStyles[n];
                        if (o && !--o.references) {
                            var s = o.element.ownerNode;
                            s && s.parentNode && s.parentNode.removeChild(s), e.customStyles[n] = null;
                        }
                    }
                }(this.options.palette), this.options = null;
            }, o.prototype.open = function(t) {
                if (this.element) return this.isOpen() || (e.hasTransition ? this.fadeIn() : this.element.style.display = "", this.options.revokable && this.toggleRevokeButton(), this.options.onPopupOpen.call(this)), this;
            }, o.prototype.close = function(t) {
                if (this.element) return this.isOpen() && (e.hasTransition ? this.fadeOut() : this.element.style.display = "none", t && this.options.revokable && this.toggleRevokeButton(!0), this.options.onPopupClose.call(this)), this;
            }, o.prototype.fadeIn = function() {
                var i = this.element;
                if (e.hasTransition && i && (this.afterTransition && r.call(this, i), t.hasClass(i, "cc-invisible"))) {
                    if (i.style.display = "", this.options.static) {
                        var n = this.element.clientHeight;
                        this.element.parentNode.style.maxHeight = n + "px";
                    }
                    this.openingTimeout = setTimeout(s.bind(this, i), 20);
                }
            }, o.prototype.fadeOut = function() {
                var i = this.element;
                e.hasTransition && i && (this.openingTimeout && (clearTimeout(this.openingTimeout), s.bind(this, i)), t.hasClass(i, "cc-invisible") || (this.options.static && (this.element.parentNode.style.maxHeight = ""), this.afterTransition = r.bind(this, i), i.addEventListener(e.transitionEnd, this.afterTransition), t.addClass(i, "cc-invisible")));
            }, o.prototype.isOpen = function() {
                return this.element && "" == this.element.style.display && (!e.hasTransition || !t.hasClass(this.element, "cc-invisible"));
            }, o.prototype.toggleRevokeButton = function(e) {
                this.revokeBtn && (this.revokeBtn.style.display = e ? "" : "none");
            }, o.prototype.revokeChoice = function(e) {
                this.options.enabled = !0, this.clearStatus(), this.options.onRevokeChoice.call(this), e || this.autoOpen();
            }, o.prototype.hasAnswered = function(t) {
                return Object.keys(e.status).indexOf(this.getStatus()) >= 0;
            }, o.prototype.hasConsented = function(t) {
                var i = this.getStatus();
                return i == e.status.allow || i == e.status.dismiss;
            }, o.prototype.autoOpen = function(e) {
                !this.hasAnswered() && this.options.enabled ? this.open() : this.hasAnswered() && this.options.revokable && this.toggleRevokeButton(!0);
            }, o.prototype.setStatus = function(i) {
                var n = this.options.cookie, o = t.getCookie(n.name), s = Object.keys(e.status).indexOf(o) >= 0;
                Object.keys(e.status).indexOf(i) >= 0 ? (t.setCookie(n.name, i, n.expiryDays, n.domain, n.path, n.secure), this.options.onStatusChange.call(this, i, s)) : this.clearStatus();
            }, o.prototype.getStatus = function() {
                return t.getCookie(this.options.cookie.name);
            }, o.prototype.clearStatus = function() {
                var e = this.options.cookie;
                t.setCookie(e.name, "", -1, e.domain, e.path);
            }, o;
        }(), e.Location = function() {
            var e = {
                timeout: 5e3,
                services: [
                    "ipinfo"
                ],
                serviceDefinitions: {
                    ipinfo: function() {
                        return {
                            url: "//ipinfo.io",
                            headers: [
                                "Accept: application/json"
                            ],
                            callback: function(e, t) {
                                try {
                                    var i = JSON.parse(t);
                                    return i.error ? s(i) : {
                                        code: i.country
                                    };
                                } catch (e) {
                                    return s({
                                        error: "Invalid response (" + e + ")"
                                    });
                                }
                            }
                        };
                    },
                    ipinfodb: function(e) {
                        return {
                            url: "//api.ipinfodb.com/v3/ip-country/?key={api_key}&format=json&callback={callback}",
                            isScript: !0,
                            callback: function(e, t) {
                                try {
                                    var i = JSON.parse(t);
                                    return "ERROR" == i.statusCode ? s({
                                        error: i.statusMessage
                                    }) : {
                                        code: i.countryCode
                                    };
                                } catch (e) {
                                    return s({
                                        error: "Invalid response (" + e + ")"
                                    });
                                }
                            }
                        };
                    },
                    maxmind: function() {
                        return {
                            url: "//js.maxmind.com/js/apis/geoip2/v2.1/geoip2.js",
                            isScript: !0,
                            callback: function(e) {
                                window.geoip2 ? geoip2.country(function(t) {
                                    try {
                                        e({
                                            code: t.country.iso_code
                                        });
                                    } catch (t) {
                                        e(s(t));
                                    }
                                }, function(t) {
                                    e(s(t));
                                }) : e(new Error("Unexpected response format. The downloaded script should have exported `geoip2` to the global scope"));
                            }
                        };
                    }
                }
            };
            function i(i) {
                t.deepExtend(this.options = {}, e), t.isPlainObject(i) && t.deepExtend(this.options, i), this.currentServiceIndex = -1;
            }
            function n(e, t, i) {
                var n, o = document.createElement("script");
                o.type = "text/" + (e.type || "javascript"), o.src = e.src || e, o.async = !1, o.onreadystatechange = o.onload = function() {
                    var e = o.readyState;
                    clearTimeout(n), t.done || e && !/loaded|complete/.test(e) || (t.done = !0, t(), o.onreadystatechange = o.onload = null);
                }, document.body.appendChild(o), n = setTimeout(function() {
                    t.done = !0, t(), o.onreadystatechange = o.onload = null;
                }, i);
            }
            function o(e, t, i, n, o) {
                var s = new (window.XMLHttpRequest || window.ActiveXObject)("MSXML2.XMLHTTP.3.0");
                if (s.open(n ? "POST" : "GET", e, 1), s.setRequestHeader("Content-type", "application/x-www-form-urlencoded"), Array.isArray(o)) for(var r = 0, a = o.length; r < a; ++r){
                    var c = o[r].split(":", 2);
                    s.setRequestHeader(c[0].replace(/^\s+|\s+$/g, ""), c[1].replace(/^\s+|\s+$/g, ""));
                }
                "function" == typeof t && (s.onreadystatechange = function() {
                    s.readyState > 3 && t(s);
                }), s.send(n);
            }
            function s(e) {
                return new Error("Error [" + (e.code || "UNKNOWN") + "]: " + e.error);
            }
            return i.prototype.getNextService = function() {
                var e;
                do e = this.getServiceByIdx(++this.currentServiceIndex);
                while (this.currentServiceIndex < this.options.services.length && !e);
                return e;
            }, i.prototype.getServiceByIdx = function(e) {
                var i = this.options.services[e];
                if ("function" == typeof i) {
                    var n = i();
                    return n.name && t.deepExtend(n, this.options.serviceDefinitions[n.name](n)), n;
                }
                return "string" == typeof i ? this.options.serviceDefinitions[i]() : t.isPlainObject(i) ? this.options.serviceDefinitions[i.name](i) : null;
            }, i.prototype.locate = function(e, t) {
                var i = this.getNextService();
                i ? (this.callbackComplete = e, this.callbackError = t, this.runService(i, this.runNextServiceOnError.bind(this))) : t(new Error("No services to run"));
            }, i.prototype.setupUrl = function(e) {
                var t = this.getCurrentServiceOpts();
                return e.url.replace(/\{(.*?)\}/g, function(i, n) {
                    if ("callback" === n) {
                        var o = "callback" + Date.now();
                        return window[o] = function(t) {
                            e.__JSONP_DATA = JSON.stringify(t);
                        }, o;
                    }
                    if (n in t.interpolateUrl) return t.interpolateUrl[n];
                });
            }, i.prototype.runService = function(e, t) {
                var i = this;
                e && e.url && e.callback && (e.isScript ? n : o)(this.setupUrl(e), function(n) {
                    var o = n ? n.responseText : "";
                    e.__JSONP_DATA && (o = e.__JSONP_DATA, delete e.__JSONP_DATA), i.runServiceCallback.call(i, t, e, o);
                }, this.options.timeout, e.data, e.headers);
            }, i.prototype.runServiceCallback = function(e, t, i) {
                var n = this, o = t.callback(function(t) {
                    o || n.onServiceResult.call(n, e, t);
                }, i);
                o && this.onServiceResult.call(this, e, o);
            }, i.prototype.onServiceResult = function(e, t) {
                t instanceof Error || t && t.error ? e.call(this, t, null) : e.call(this, null, t);
            }, i.prototype.runNextServiceOnError = function(e, t) {
                if (e) {
                    this.logError(e);
                    var i = this.getNextService();
                    i ? this.runService(i, this.runNextServiceOnError.bind(this)) : this.completeService.call(this, this.callbackError, new Error("All services failed"));
                } else this.completeService.call(this, this.callbackComplete, t);
            }, i.prototype.getCurrentServiceOpts = function() {
                var e = this.options.services[this.currentServiceIndex];
                return "string" == typeof e ? {
                    name: e
                } : "function" == typeof e ? e() : t.isPlainObject(e) ? e : {};
            }, i.prototype.completeService = function(e, t) {
                this.currentServiceIndex = -1, e && e(t);
            }, i.prototype.logError = function(e) {
                var t = this.currentServiceIndex, i = this.getServiceByIdx(t);
                console.warn("The service[" + t + "] (" + i.url + ") responded with the following error", e);
            }, i;
        }(), e.Law = function() {
            var e = {
                regionalLaw: !0,
                hasLaw: [
                    "AT",
                    "BE",
                    "BG",
                    "HR",
                    "CZ",
                    "CY",
                    "DK",
                    "EE",
                    "FI",
                    "FR",
                    "DE",
                    "EL",
                    "HU",
                    "IE",
                    "IT",
                    "LV",
                    "LT",
                    "LU",
                    "MT",
                    "NL",
                    "PL",
                    "PT",
                    "SK",
                    "ES",
                    "SE",
                    "GB",
                    "UK",
                    "GR",
                    "EU"
                ],
                revokable: [
                    "HR",
                    "CY",
                    "DK",
                    "EE",
                    "FR",
                    "DE",
                    "LV",
                    "LT",
                    "NL",
                    "PT",
                    "ES"
                ],
                explicitAction: [
                    "HR",
                    "IT",
                    "ES"
                ]
            };
            function i(e) {
                this.initialise.apply(this, arguments);
            }
            return i.prototype.initialise = function(i) {
                t.deepExtend(this.options = {}, e), t.isPlainObject(i) && t.deepExtend(this.options, i);
            }, i.prototype.get = function(e) {
                var t = this.options;
                return {
                    hasLaw: t.hasLaw.indexOf(e) >= 0,
                    revokable: t.revokable.indexOf(e) >= 0,
                    explicitAction: t.explicitAction.indexOf(e) >= 0
                };
            }, i.prototype.applyLaw = function(e, t) {
                var i = this.get(t);
                return i.hasLaw || (e.enabled = !1, "function" == typeof e.onNoCookieLaw && e.onNoCookieLaw(t, i)), this.options.regionalLaw && (i.revokable && (e.revokable = !0), i.explicitAction && (e.dismissOnScroll = !1, e.dismissOnTimeout = !1)), e;
            }, i;
        }(), e.initialise = function(i, n, o) {
            var s = new e.Law(i.law);
            n || (n = function() {}), o || (o = function() {});
            var r = Object.keys(e.status), a = t.getCookie("cookieconsent_status");
            r.indexOf(a) >= 0 ? n(new e.Popup(i)) : e.getCountryCode(i, function(t) {
                delete i.law, delete i.location, t.code && (i = s.applyLaw(i, t.code)), n(new e.Popup(i));
            }, function(t) {
                delete i.law, delete i.location, o(t, new e.Popup(i));
            });
        }, e.getCountryCode = function(t, i, n) {
            t.law && t.law.countryCode ? i({
                code: t.law.countryCode
            }) : t.location ? new e.Location(t.location).locate(function(e) {
                i(e || {});
            }, n) : i({});
        }, e.utils = t, e.hasInitialised = !0, window.cookieconsent = e;
    }
}(window.cookieconsent || {});


var $300c07af15a0d4e3$exports = {};
(function(window1, document1) {
    "use strict";
    /*
     * 1. Check if the browser supports `position: sticky` natively or is too old to run the polyfill.
     *    If either of these is the case set `seppuku` flag. It will be checked later to disable key features
     *    of the polyfill, but the API will remain functional to avoid breaking things.
     */ var _createClass = function() {
        function defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        return function(Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    var seppuku = false;
    var isWindowDefined = typeof window1 !== "undefined";
    // The polyfill can’t function properly without `window` or `window.getComputedStyle`.
    if (!isWindowDefined || !window1.getComputedStyle) seppuku = true;
    else (function() {
        var testNode = document1.createElement("div");
        if ([
            "",
            "-webkit-",
            "-moz-",
            "-ms-"
        ].some(function(prefix) {
            try {
                testNode.style.position = prefix + "sticky";
            } catch (e) {}
            return testNode.style.position != "";
        })) seppuku = true;
    })();
    /*
     * 2. “Global” vars used across the polyfill
     */ var isInitialized = false;
    // Check if Shadow Root constructor exists to make further checks simpler
    var shadowRootExists = typeof ShadowRoot !== "undefined";
    // Last saved scroll position
    var scroll = {
        top: null,
        left: null
    };
    // Array of created Sticky instances
    var stickies = [];
    /*
     * 3. Utility functions
     */ function extend(targetObj, sourceObject) {
        for(var key in sourceObject)if (sourceObject.hasOwnProperty(key)) targetObj[key] = sourceObject[key];
    }
    function parseNumeric(val) {
        return parseFloat(val) || 0;
    }
    function getDocOffsetTop(node) {
        var docOffsetTop = 0;
        while(node){
            docOffsetTop += node.offsetTop;
            node = node.offsetParent;
        }
        return docOffsetTop;
    }
    /*
     * 4. Sticky class
     */ var Sticky = function() {
        function Sticky(node) {
            _classCallCheck(this, Sticky);
            if (!(node instanceof HTMLElement)) throw new Error("First argument must be HTMLElement");
            if (stickies.some(function(sticky) {
                return sticky._node === node;
            })) throw new Error("Stickyfill is already applied to this node");
            this._node = node;
            this._stickyMode = null;
            this._active = false;
            stickies.push(this);
            this.refresh();
        }
        _createClass(Sticky, [
            {
                key: "refresh",
                value: function refresh() {
                    if (seppuku || this._removed) return;
                    if (this._active) this._deactivate();
                    var node = this._node;
                    /*
                 * 1. Save node computed props
                 */ var nodeComputedStyle = getComputedStyle(node);
                    var nodeComputedProps = {
                        position: nodeComputedStyle.position,
                        top: nodeComputedStyle.top,
                        display: nodeComputedStyle.display,
                        marginTop: nodeComputedStyle.marginTop,
                        marginBottom: nodeComputedStyle.marginBottom,
                        marginLeft: nodeComputedStyle.marginLeft,
                        marginRight: nodeComputedStyle.marginRight,
                        cssFloat: nodeComputedStyle.cssFloat
                    };
                    /*
                 * 2. Check if the node can be activated
                 */ if (isNaN(parseFloat(nodeComputedProps.top)) || nodeComputedProps.display == "table-cell" || nodeComputedProps.display == "none") return;
                    this._active = true;
                    /*
                 * 3. Check if the current node position is `sticky`. If it is, it means that the browser supports sticky positioning,
                 *    but the polyfill was force-enabled. We set the node’s position to `static` before continuing, so that the node
                 *    is in it’s initial position when we gather its params.
                 */ var originalPosition = node.style.position;
                    if (nodeComputedStyle.position == "sticky" || nodeComputedStyle.position == "-webkit-sticky") node.style.position = "static";
                    /*
                 * 4. Get necessary node parameters
                 */ var referenceNode = node.parentNode;
                    var parentNode = shadowRootExists && referenceNode instanceof ShadowRoot ? referenceNode.host : referenceNode;
                    var nodeWinOffset = node.getBoundingClientRect();
                    var parentWinOffset = parentNode.getBoundingClientRect();
                    var parentComputedStyle = getComputedStyle(parentNode);
                    this._parent = {
                        node: parentNode,
                        styles: {
                            position: parentNode.style.position
                        },
                        offsetHeight: parentNode.offsetHeight
                    };
                    this._offsetToWindow = {
                        left: nodeWinOffset.left,
                        right: document1.documentElement.clientWidth - nodeWinOffset.right
                    };
                    this._offsetToParent = {
                        top: nodeWinOffset.top - parentWinOffset.top - parseNumeric(parentComputedStyle.borderTopWidth),
                        left: nodeWinOffset.left - parentWinOffset.left - parseNumeric(parentComputedStyle.borderLeftWidth),
                        right: -nodeWinOffset.right + parentWinOffset.right - parseNumeric(parentComputedStyle.borderRightWidth)
                    };
                    this._styles = {
                        position: originalPosition,
                        top: node.style.top,
                        bottom: node.style.bottom,
                        left: node.style.left,
                        right: node.style.right,
                        width: node.style.width,
                        marginTop: node.style.marginTop,
                        marginLeft: node.style.marginLeft,
                        marginRight: node.style.marginRight
                    };
                    var nodeTopValue = parseNumeric(nodeComputedProps.top);
                    this._limits = {
                        start: nodeWinOffset.top + window1.pageYOffset - nodeTopValue,
                        end: parentWinOffset.top + window1.pageYOffset + parentNode.offsetHeight - parseNumeric(parentComputedStyle.borderBottomWidth) - node.offsetHeight - nodeTopValue - parseNumeric(nodeComputedProps.marginBottom)
                    };
                    /*
                 * 5. Ensure that the node will be positioned relatively to the parent node
                 */ var parentPosition = parentComputedStyle.position;
                    if (parentPosition != "absolute" && parentPosition != "relative") parentNode.style.position = "relative";
                    /*
                 * 6. Recalc node position.
                 *    It’s important to do this before clone injection to avoid scrolling bug in Chrome.
                 */ this._recalcPosition();
                    /*
                 * 7. Create a clone
                 */ var clone = this._clone = {};
                    clone.node = document1.createElement("div");
                    // Apply styles to the clone
                    extend(clone.node.style, {
                        width: nodeWinOffset.right - nodeWinOffset.left + "px",
                        height: nodeWinOffset.bottom - nodeWinOffset.top + "px",
                        marginTop: nodeComputedProps.marginTop,
                        marginBottom: nodeComputedProps.marginBottom,
                        marginLeft: nodeComputedProps.marginLeft,
                        marginRight: nodeComputedProps.marginRight,
                        cssFloat: nodeComputedProps.cssFloat,
                        padding: 0,
                        border: 0,
                        borderSpacing: 0,
                        fontSize: "1em",
                        position: "static"
                    });
                    referenceNode.insertBefore(clone.node, node);
                    clone.docOffsetTop = getDocOffsetTop(clone.node);
                }
            },
            {
                key: "_recalcPosition",
                value: function _recalcPosition() {
                    if (!this._active || this._removed) return;
                    var stickyMode = scroll.top <= this._limits.start ? "start" : scroll.top >= this._limits.end ? "end" : "middle";
                    if (this._stickyMode == stickyMode) return;
                    switch(stickyMode){
                        case "start":
                            extend(this._node.style, {
                                position: "absolute",
                                left: this._offsetToParent.left + "px",
                                right: this._offsetToParent.right + "px",
                                top: this._offsetToParent.top + "px",
                                bottom: "auto",
                                width: "auto",
                                marginLeft: 0,
                                marginRight: 0,
                                marginTop: 0
                            });
                            break;
                        case "middle":
                            extend(this._node.style, {
                                position: "fixed",
                                left: this._offsetToWindow.left + "px",
                                right: this._offsetToWindow.right + "px",
                                top: this._styles.top,
                                bottom: "auto",
                                width: "auto",
                                marginLeft: 0,
                                marginRight: 0,
                                marginTop: 0
                            });
                            break;
                        case "end":
                            extend(this._node.style, {
                                position: "absolute",
                                left: this._offsetToParent.left + "px",
                                right: this._offsetToParent.right + "px",
                                top: "auto",
                                bottom: 0,
                                width: "auto",
                                marginLeft: 0,
                                marginRight: 0
                            });
                            break;
                    }
                    this._stickyMode = stickyMode;
                }
            },
            {
                key: "_fastCheck",
                value: function _fastCheck() {
                    if (!this._active || this._removed) return;
                    if (Math.abs(getDocOffsetTop(this._clone.node) - this._clone.docOffsetTop) > 1 || Math.abs(this._parent.node.offsetHeight - this._parent.offsetHeight) > 1) this.refresh();
                }
            },
            {
                key: "_deactivate",
                value: function _deactivate() {
                    var _this = this;
                    if (!this._active || this._removed) return;
                    this._clone.node.parentNode.removeChild(this._clone.node);
                    delete this._clone;
                    extend(this._node.style, this._styles);
                    delete this._styles;
                    // Check whether element’s parent node is used by other stickies.
                    // If not, restore parent node’s styles.
                    if (!stickies.some(function(sticky) {
                        return sticky !== _this && sticky._parent && sticky._parent.node === _this._parent.node;
                    })) extend(this._parent.node.style, this._parent.styles);
                    delete this._parent;
                    this._stickyMode = null;
                    this._active = false;
                    delete this._offsetToWindow;
                    delete this._offsetToParent;
                    delete this._limits;
                }
            },
            {
                key: "remove",
                value: function remove() {
                    var _this2 = this;
                    this._deactivate();
                    stickies.some(function(sticky, index) {
                        if (sticky._node === _this2._node) {
                            stickies.splice(index, 1);
                            return true;
                        }
                    });
                    this._removed = true;
                }
            }
        ]);
        return Sticky;
    }();
    /*
     * 5. Stickyfill API
     */ var Stickyfill = {
        stickies: stickies,
        Sticky: Sticky,
        forceSticky: function forceSticky() {
            seppuku = false;
            init();
            this.refreshAll();
        },
        addOne: function addOne(node) {
            // Check whether it’s a node
            if (!(node instanceof HTMLElement)) {
                // Maybe it’s a node list of some sort?
                // Take first node from the list then
                if (node.length && node[0]) node = node[0];
                else return;
            }
            // Check if Stickyfill is already applied to the node
            // and return existing sticky
            for(var i = 0; i < stickies.length; i++){
                if (stickies[i]._node === node) return stickies[i];
            }
            // Create and return new sticky
            return new Sticky(node);
        },
        add: function add(nodeList) {
            // If it’s a node make an array of one node
            if (nodeList instanceof HTMLElement) nodeList = [
                nodeList
            ];
            // Check if the argument is an iterable of some sort
            if (!nodeList.length) return;
            // Add every element as a sticky and return an array of created Sticky instances
            var addedStickies = [];
            var _loop = function _loop(i) {
                var node = nodeList[i];
                // If it’s not an HTMLElement – create an empty element to preserve 1-to-1
                // correlation with input list
                if (!(node instanceof HTMLElement)) {
                    addedStickies.push(void 0);
                    return "continue";
                }
                // If Stickyfill is already applied to the node
                // add existing sticky
                if (stickies.some(function(sticky) {
                    if (sticky._node === node) {
                        addedStickies.push(sticky);
                        return true;
                    }
                })) return "continue";
                // Create and add new sticky
                addedStickies.push(new Sticky(node));
            };
            for(var i = 0; i < nodeList.length; i++){
                var _ret2 = _loop(i);
                if (_ret2 === "continue") continue;
            }
            return addedStickies;
        },
        refreshAll: function refreshAll() {
            stickies.forEach(function(sticky) {
                return sticky.refresh();
            });
        },
        removeOne: function removeOne(node) {
            // Check whether it’s a node
            if (!(node instanceof HTMLElement)) {
                // Maybe it’s a node list of some sort?
                // Take first node from the list then
                if (node.length && node[0]) node = node[0];
                else return;
            }
            // Remove the stickies bound to the nodes in the list
            stickies.some(function(sticky) {
                if (sticky._node === node) {
                    sticky.remove();
                    return true;
                }
            });
        },
        remove: function remove(nodeList) {
            // If it’s a node make an array of one node
            if (nodeList instanceof HTMLElement) nodeList = [
                nodeList
            ];
            // Check if the argument is an iterable of some sort
            if (!nodeList.length) return;
            // Remove the stickies bound to the nodes in the list
            var _loop2 = function _loop2(i) {
                var node = nodeList[i];
                stickies.some(function(sticky) {
                    if (sticky._node === node) {
                        sticky.remove();
                        return true;
                    }
                });
            };
            for(var i = 0; i < nodeList.length; i++)_loop2(i);
        },
        removeAll: function removeAll() {
            while(stickies.length)stickies[0].remove();
        }
    };
    /*
     * 6. Setup events (unless the polyfill was disabled)
     */ function init() {
        if (isInitialized) return;
        isInitialized = true;
        // Watch for scroll position changes and trigger recalc/refresh if needed
        function checkScroll() {
            if (window1.pageXOffset != scroll.left) {
                scroll.top = window1.pageYOffset;
                scroll.left = window1.pageXOffset;
                Stickyfill.refreshAll();
            } else if (window1.pageYOffset != scroll.top) {
                scroll.top = window1.pageYOffset;
                scroll.left = window1.pageXOffset;
                // recalc position for all stickies
                stickies.forEach(function(sticky) {
                    return sticky._recalcPosition();
                });
            }
        }
        checkScroll();
        window1.addEventListener("scroll", checkScroll);
        // Watch for window resizes and device orientation changes and trigger refresh
        window1.addEventListener("resize", Stickyfill.refreshAll);
        window1.addEventListener("orientationchange", Stickyfill.refreshAll);
        //Fast dirty check for layout changes every 500ms
        var fastCheckTimer = void 0;
        function startFastCheckTimer() {
            fastCheckTimer = setInterval(function() {
                stickies.forEach(function(sticky) {
                    return sticky._fastCheck();
                });
            }, 500);
        }
        function stopFastCheckTimer() {
            clearInterval(fastCheckTimer);
        }
        var docHiddenKey = void 0;
        var visibilityChangeEventName = void 0;
        if ("hidden" in document1) {
            docHiddenKey = "hidden";
            visibilityChangeEventName = "visibilitychange";
        } else if ("webkitHidden" in document1) {
            docHiddenKey = "webkitHidden";
            visibilityChangeEventName = "webkitvisibilitychange";
        }
        if (visibilityChangeEventName) {
            if (!document1[docHiddenKey]) startFastCheckTimer();
            document1.addEventListener(visibilityChangeEventName, function() {
                if (document1[docHiddenKey]) stopFastCheckTimer();
                else startFastCheckTimer();
            });
        } else startFastCheckTimer();
    }
    if (!seppuku) init();
    /*
     * 7. Expose Stickyfill
     */ if (0, $300c07af15a0d4e3$exports) $300c07af15a0d4e3$exports = Stickyfill;
    else if (isWindowDefined) window1.Stickyfill = Stickyfill;
})(window, document);


var $069407aaccc90e9d$exports = {};
/*! npm.im/object-fit-images 3.2.4 */ "use strict";
var $069407aaccc90e9d$var$OFI = "bfred-it:object-fit-images";
var $069407aaccc90e9d$var$propRegex = /(object-fit|object-position)\s*:\s*([-.\w\s%]+)/g;
var $069407aaccc90e9d$var$testImg = typeof Image === "undefined" ? {
    style: {
        "object-position": 1
    }
} : new Image();
var $069407aaccc90e9d$var$supportsObjectFit = "object-fit" in $069407aaccc90e9d$var$testImg.style;
var $069407aaccc90e9d$var$supportsObjectPosition = "object-position" in $069407aaccc90e9d$var$testImg.style;
var $069407aaccc90e9d$var$supportsOFI = "background-size" in $069407aaccc90e9d$var$testImg.style;
var $069407aaccc90e9d$var$supportsCurrentSrc = typeof $069407aaccc90e9d$var$testImg.currentSrc === "string";
var $069407aaccc90e9d$var$nativeGetAttribute = $069407aaccc90e9d$var$testImg.getAttribute;
var $069407aaccc90e9d$var$nativeSetAttribute = $069407aaccc90e9d$var$testImg.setAttribute;
var $069407aaccc90e9d$var$autoModeEnabled = false;
function $069407aaccc90e9d$var$createPlaceholder(w, h) {
    return "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='" + w + "' height='" + h + "'%3E%3C/svg%3E";
}
function $069407aaccc90e9d$var$polyfillCurrentSrc(el) {
    if (el.srcset && !$069407aaccc90e9d$var$supportsCurrentSrc && window.picturefill) {
        var pf = window.picturefill._;
        // parse srcset with picturefill where currentSrc isn't available
        if (!el[pf.ns] || !el[pf.ns].evaled) // force synchronous srcset parsing
        pf.fillImg(el, {
            reselect: true
        });
        if (!el[pf.ns].curSrc) {
            // force picturefill to parse srcset
            el[pf.ns].supported = false;
            pf.fillImg(el, {
                reselect: true
            });
        }
        // retrieve parsed currentSrc, if any
        el.currentSrc = el[pf.ns].curSrc || el.src;
    }
}
function $069407aaccc90e9d$var$getStyle(el) {
    var style = getComputedStyle(el).fontFamily;
    var parsed;
    var props = {};
    while((parsed = $069407aaccc90e9d$var$propRegex.exec(style)) !== null)props[parsed[1]] = parsed[2];
    return props;
}
function $069407aaccc90e9d$var$setPlaceholder(img, width, height) {
    // Default: fill width, no height
    var placeholder = $069407aaccc90e9d$var$createPlaceholder(width || 1, height || 0);
    // Only set placeholder if it's different
    if ($069407aaccc90e9d$var$nativeGetAttribute.call(img, "src") !== placeholder) $069407aaccc90e9d$var$nativeSetAttribute.call(img, "src", placeholder);
}
function $069407aaccc90e9d$var$onImageReady(img, callback) {
    // naturalWidth is only available when the image headers are loaded,
    // this loop will poll it every 100ms.
    if (img.naturalWidth) callback(img);
    else setTimeout($069407aaccc90e9d$var$onImageReady, 100, img, callback);
}
function $069407aaccc90e9d$var$fixOne(el) {
    var style = $069407aaccc90e9d$var$getStyle(el);
    var ofi = el[$069407aaccc90e9d$var$OFI];
    style["object-fit"] = style["object-fit"] || "fill"; // default value
    // Avoid running where unnecessary, unless OFI had already done its deed
    if (!ofi.img) {
        // fill is the default behavior so no action is necessary
        if (style["object-fit"] === "fill") return;
        // Where object-fit is supported and object-position isn't (Safari < 10)
        if (!ofi.skipTest && // unless user wants to apply regardless of browser support
        $069407aaccc90e9d$var$supportsObjectFit && // if browser already supports object-fit
        !style["object-position"] // unless object-position is used
        ) return;
    }
    // keep a clone in memory while resetting the original to a blank
    if (!ofi.img) {
        ofi.img = new Image(el.width, el.height);
        ofi.img.srcset = $069407aaccc90e9d$var$nativeGetAttribute.call(el, "data-ofi-srcset") || el.srcset;
        ofi.img.src = $069407aaccc90e9d$var$nativeGetAttribute.call(el, "data-ofi-src") || el.src;
        // preserve for any future cloneNode calls
        // https://github.com/bfred-it/object-fit-images/issues/53
        $069407aaccc90e9d$var$nativeSetAttribute.call(el, "data-ofi-src", el.src);
        if (el.srcset) $069407aaccc90e9d$var$nativeSetAttribute.call(el, "data-ofi-srcset", el.srcset);
        $069407aaccc90e9d$var$setPlaceholder(el, el.naturalWidth || el.width, el.naturalHeight || el.height);
        // remove srcset because it overrides src
        if (el.srcset) el.srcset = "";
        try {
            $069407aaccc90e9d$var$keepSrcUsable(el);
        } catch (err) {
            if (window.console) console.warn("https://bit.ly/ofi-old-browser");
        }
    }
    $069407aaccc90e9d$var$polyfillCurrentSrc(ofi.img);
    el.style.backgroundImage = 'url("' + (ofi.img.currentSrc || ofi.img.src).replace(/"/g, '\\"') + '")';
    el.style.backgroundPosition = style["object-position"] || "center";
    el.style.backgroundRepeat = "no-repeat";
    el.style.backgroundOrigin = "content-box";
    if (/scale-down/.test(style["object-fit"])) $069407aaccc90e9d$var$onImageReady(ofi.img, function() {
        if (ofi.img.naturalWidth > el.width || ofi.img.naturalHeight > el.height) el.style.backgroundSize = "contain";
        else el.style.backgroundSize = "auto";
    });
    else el.style.backgroundSize = style["object-fit"].replace("none", "auto").replace("fill", "100% 100%");
    $069407aaccc90e9d$var$onImageReady(ofi.img, function(img) {
        $069407aaccc90e9d$var$setPlaceholder(el, img.naturalWidth, img.naturalHeight);
    });
}
function $069407aaccc90e9d$var$keepSrcUsable(el) {
    var descriptors = {
        get: function get(prop) {
            return el[$069407aaccc90e9d$var$OFI].img[prop ? prop : "src"];
        },
        set: function set(value, prop) {
            el[$069407aaccc90e9d$var$OFI].img[prop ? prop : "src"] = value;
            $069407aaccc90e9d$var$nativeSetAttribute.call(el, "data-ofi-" + prop, value); // preserve for any future cloneNode
            $069407aaccc90e9d$var$fixOne(el);
            return value;
        }
    };
    Object.defineProperty(el, "src", descriptors);
    Object.defineProperty(el, "currentSrc", {
        get: function() {
            return descriptors.get("currentSrc");
        }
    });
    Object.defineProperty(el, "srcset", {
        get: function() {
            return descriptors.get("srcset");
        },
        set: function(ss) {
            return descriptors.set(ss, "srcset");
        }
    });
}
function $069407aaccc90e9d$var$hijackAttributes() {
    function getOfiImageMaybe(el, name) {
        return el[$069407aaccc90e9d$var$OFI] && el[$069407aaccc90e9d$var$OFI].img && (name === "src" || name === "srcset") ? el[$069407aaccc90e9d$var$OFI].img : el;
    }
    if (!$069407aaccc90e9d$var$supportsObjectPosition) {
        HTMLImageElement.prototype.getAttribute = function(name) {
            return $069407aaccc90e9d$var$nativeGetAttribute.call(getOfiImageMaybe(this, name), name);
        };
        HTMLImageElement.prototype.setAttribute = function(name, value) {
            return $069407aaccc90e9d$var$nativeSetAttribute.call(getOfiImageMaybe(this, name), name, String(value));
        };
    }
}
function $069407aaccc90e9d$var$fix(imgs, opts) {
    var startAutoMode = !$069407aaccc90e9d$var$autoModeEnabled && !imgs;
    opts = opts || {};
    imgs = imgs || "img";
    if ($069407aaccc90e9d$var$supportsObjectPosition && !opts.skipTest || !$069407aaccc90e9d$var$supportsOFI) return false;
    // use imgs as a selector or just select all images
    if (imgs === "img") imgs = document.getElementsByTagName("img");
    else if (typeof imgs === "string") imgs = document.querySelectorAll(imgs);
    else if (!("length" in imgs)) imgs = [
        imgs
    ];
    // apply fix to all
    for(var i = 0; i < imgs.length; i++){
        imgs[i][$069407aaccc90e9d$var$OFI] = imgs[i][$069407aaccc90e9d$var$OFI] || {
            skipTest: opts.skipTest
        };
        $069407aaccc90e9d$var$fixOne(imgs[i]);
    }
    if (startAutoMode) {
        document.body.addEventListener("load", function(e) {
            if (e.target.tagName === "IMG") $069407aaccc90e9d$var$fix(e.target, {
                skipTest: opts.skipTest
            });
        }, true);
        $069407aaccc90e9d$var$autoModeEnabled = true;
        imgs = "img"; // reset to a generic selector for watchMQ
    }
    // if requested, watch media queries for object-fit change
    if (opts.watchMQ) window.addEventListener("resize", $069407aaccc90e9d$var$fix.bind(null, imgs, {
        skipTest: opts.skipTest
    }));
}
$069407aaccc90e9d$var$fix.supportsObjectFit = $069407aaccc90e9d$var$supportsObjectFit;
$069407aaccc90e9d$var$fix.supportsObjectPosition = $069407aaccc90e9d$var$supportsObjectPosition;
$069407aaccc90e9d$var$hijackAttributes();
$069407aaccc90e9d$exports = $069407aaccc90e9d$var$fix;


/*!
 * lightgallery | 2.7.2 | September 20th 2023
 * http://www.lightgalleryjs.com/
 * Copyright (c) 2020 Sachin Neravath;
 * @license GPLv3
 */ /*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $68e3467541a0efeb$var$__assign = function() {
    $68e3467541a0efeb$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $68e3467541a0efeb$var$__assign.apply(this, arguments);
};
function $68e3467541a0efeb$var$__spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
/**
 * List of lightGallery events
 * All events should be documented here
 * Below interfaces are used to build the website documentations
 * */ var $68e3467541a0efeb$var$lGEvents = {
    afterAppendSlide: "lgAfterAppendSlide",
    init: "lgInit",
    hasVideo: "lgHasVideo",
    containerResize: "lgContainerResize",
    updateSlides: "lgUpdateSlides",
    afterAppendSubHtml: "lgAfterAppendSubHtml",
    beforeOpen: "lgBeforeOpen",
    afterOpen: "lgAfterOpen",
    slideItemLoad: "lgSlideItemLoad",
    beforeSlide: "lgBeforeSlide",
    afterSlide: "lgAfterSlide",
    posterClick: "lgPosterClick",
    dragStart: "lgDragStart",
    dragMove: "lgDragMove",
    dragEnd: "lgDragEnd",
    beforeNextSlide: "lgBeforeNextSlide",
    beforePrevSlide: "lgBeforePrevSlide",
    beforeClose: "lgBeforeClose",
    afterClose: "lgAfterClose",
    rotateLeft: "lgRotateLeft",
    rotateRight: "lgRotateRight",
    flipHorizontal: "lgFlipHorizontal",
    flipVertical: "lgFlipVertical",
    autoplay: "lgAutoplay",
    autoplayStart: "lgAutoplayStart",
    autoplayStop: "lgAutoplayStop"
};
var $68e3467541a0efeb$var$lightGalleryCoreSettings = {
    mode: "lg-slide",
    easing: "ease",
    speed: 400,
    licenseKey: "0000-0000-000-0000",
    height: "100%",
    width: "100%",
    addClass: "",
    startClass: "lg-start-zoom",
    backdropDuration: 300,
    container: "",
    startAnimationDuration: 400,
    zoomFromOrigin: true,
    hideBarsDelay: 0,
    showBarsAfter: 10000,
    slideDelay: 0,
    supportLegacyBrowser: true,
    allowMediaOverlap: false,
    videoMaxSize: "1280-720",
    loadYouTubePoster: true,
    defaultCaptionHeight: 0,
    ariaLabelledby: "",
    ariaDescribedby: "",
    resetScrollPosition: true,
    hideScrollbar: false,
    closable: true,
    swipeToClose: true,
    closeOnTap: true,
    showCloseIcon: true,
    showMaximizeIcon: false,
    loop: true,
    escKey: true,
    keyPress: true,
    trapFocus: true,
    controls: true,
    slideEndAnimation: true,
    hideControlOnEnd: false,
    mousewheel: false,
    getCaptionFromTitleOrAlt: true,
    appendSubHtmlTo: ".lg-sub-html",
    subHtmlSelectorRelative: false,
    preload: 2,
    numberOfSlideItemsInDom: 10,
    selector: "",
    selectWithin: "",
    nextHtml: "",
    prevHtml: "",
    index: 0,
    iframeWidth: "100%",
    iframeHeight: "100%",
    iframeMaxWidth: "100%",
    iframeMaxHeight: "100%",
    download: true,
    counter: true,
    appendCounterTo: ".lg-toolbar",
    swipeThreshold: 50,
    enableSwipe: true,
    enableDrag: true,
    dynamic: false,
    dynamicEl: [],
    extraProps: [],
    exThumbImage: "",
    isMobile: undefined,
    mobileSettings: {
        controls: false,
        showCloseIcon: false,
        download: false
    },
    plugins: [],
    strings: {
        closeGallery: "Close gallery",
        toggleMaximize: "Toggle maximize",
        previousSlide: "Previous slide",
        nextSlide: "Next slide",
        download: "Download",
        playVideo: "Play video",
        mediaLoadingFailed: "Oops... Failed to load content..."
    }
};
function $68e3467541a0efeb$var$initLgPolyfills() {
    (function() {
        if (typeof window.CustomEvent === "function") return false;
        function CustomEvent1(event, params) {
            params = params || {
                bubbles: false,
                cancelable: false,
                detail: null
            };
            var evt = document.createEvent("CustomEvent");
            evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
            return evt;
        }
        window.CustomEvent = CustomEvent1;
    })();
    (function() {
        if (!Element.prototype.matches) Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
    })();
}
var $68e3467541a0efeb$var$lgQuery = /** @class */ function() {
    function lgQuery(selector) {
        this.cssVenderPrefixes = [
            "TransitionDuration",
            "TransitionTimingFunction",
            "Transform",
            "Transition"
        ];
        this.selector = this._getSelector(selector);
        this.firstElement = this._getFirstEl();
        return this;
    }
    lgQuery.generateUUID = function() {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
            var r = Math.random() * 16 | 0, v = c == "x" ? r : r & 0x3 | 0x8;
            return v.toString(16);
        });
    };
    lgQuery.prototype._getSelector = function(selector, context) {
        if (context === void 0) context = document;
        if (typeof selector !== "string") return selector;
        context = context || document;
        var fl = selector.substring(0, 1);
        if (fl === "#") return context.querySelector(selector);
        else return context.querySelectorAll(selector);
    };
    lgQuery.prototype._each = function(func) {
        if (!this.selector) return this;
        if (this.selector.length !== undefined) [].forEach.call(this.selector, func);
        else func(this.selector, 0);
        return this;
    };
    lgQuery.prototype._setCssVendorPrefix = function(el, cssProperty, value) {
        // prettier-ignore
        var property = cssProperty.replace(/-([a-z])/gi, function(s, group1) {
            return group1.toUpperCase();
        });
        if (this.cssVenderPrefixes.indexOf(property) !== -1) {
            el.style[property.charAt(0).toLowerCase() + property.slice(1)] = value;
            el.style["webkit" + property] = value;
            el.style["moz" + property] = value;
            el.style["ms" + property] = value;
            el.style["o" + property] = value;
        } else el.style[property] = value;
    };
    lgQuery.prototype._getFirstEl = function() {
        if (this.selector && this.selector.length !== undefined) return this.selector[0];
        else return this.selector;
    };
    lgQuery.prototype.isEventMatched = function(event, eventName) {
        var eventNamespace = eventName.split(".");
        return event.split(".").filter(function(e) {
            return e;
        }).every(function(e) {
            return eventNamespace.indexOf(e) !== -1;
        });
    };
    lgQuery.prototype.attr = function(attr, value) {
        if (value === undefined) {
            if (!this.firstElement) return "";
            return this.firstElement.getAttribute(attr);
        }
        this._each(function(el) {
            el.setAttribute(attr, value);
        });
        return this;
    };
    lgQuery.prototype.find = function(selector) {
        return $68e3467541a0efeb$var$$LG(this._getSelector(selector, this.selector));
    };
    lgQuery.prototype.first = function() {
        if (this.selector && this.selector.length !== undefined) return $68e3467541a0efeb$var$$LG(this.selector[0]);
        else return $68e3467541a0efeb$var$$LG(this.selector);
    };
    lgQuery.prototype.eq = function(index) {
        return $68e3467541a0efeb$var$$LG(this.selector[index]);
    };
    lgQuery.prototype.parent = function() {
        return $68e3467541a0efeb$var$$LG(this.selector.parentElement);
    };
    lgQuery.prototype.get = function() {
        return this._getFirstEl();
    };
    lgQuery.prototype.removeAttr = function(attributes) {
        var attrs = attributes.split(" ");
        this._each(function(el) {
            attrs.forEach(function(attr) {
                return el.removeAttribute(attr);
            });
        });
        return this;
    };
    lgQuery.prototype.wrap = function(className) {
        if (!this.firstElement) return this;
        var wrapper = document.createElement("div");
        wrapper.className = className;
        this.firstElement.parentNode.insertBefore(wrapper, this.firstElement);
        this.firstElement.parentNode.removeChild(this.firstElement);
        wrapper.appendChild(this.firstElement);
        return this;
    };
    lgQuery.prototype.addClass = function(classNames) {
        if (classNames === void 0) classNames = "";
        this._each(function(el) {
            // IE doesn't support multiple arguments
            classNames.split(" ").forEach(function(className) {
                if (className) el.classList.add(className);
            });
        });
        return this;
    };
    lgQuery.prototype.removeClass = function(classNames) {
        this._each(function(el) {
            // IE doesn't support multiple arguments
            classNames.split(" ").forEach(function(className) {
                if (className) el.classList.remove(className);
            });
        });
        return this;
    };
    lgQuery.prototype.hasClass = function(className) {
        if (!this.firstElement) return false;
        return this.firstElement.classList.contains(className);
    };
    lgQuery.prototype.hasAttribute = function(attribute) {
        if (!this.firstElement) return false;
        return this.firstElement.hasAttribute(attribute);
    };
    lgQuery.prototype.toggleClass = function(className) {
        if (!this.firstElement) return this;
        if (this.hasClass(className)) this.removeClass(className);
        else this.addClass(className);
        return this;
    };
    lgQuery.prototype.css = function(property, value) {
        var _this = this;
        this._each(function(el) {
            _this._setCssVendorPrefix(el, property, value);
        });
        return this;
    };
    // Need to pass separate namespaces for separate elements
    lgQuery.prototype.on = function(events, listener) {
        var _this = this;
        if (!this.selector) return this;
        events.split(" ").forEach(function(event) {
            if (!Array.isArray(lgQuery.eventListeners[event])) lgQuery.eventListeners[event] = [];
            lgQuery.eventListeners[event].push(listener);
            _this.selector.addEventListener(event.split(".")[0], listener);
        });
        return this;
    };
    // @todo - test this
    lgQuery.prototype.once = function(event, listener) {
        var _this = this;
        this.on(event, function() {
            _this.off(event);
            listener(event);
        });
        return this;
    };
    lgQuery.prototype.off = function(event) {
        var _this = this;
        if (!this.selector) return this;
        Object.keys(lgQuery.eventListeners).forEach(function(eventName) {
            if (_this.isEventMatched(event, eventName)) {
                lgQuery.eventListeners[eventName].forEach(function(listener) {
                    _this.selector.removeEventListener(eventName.split(".")[0], listener);
                });
                lgQuery.eventListeners[eventName] = [];
            }
        });
        return this;
    };
    lgQuery.prototype.trigger = function(event, detail) {
        if (!this.firstElement) return this;
        var customEvent = new CustomEvent(event.split(".")[0], {
            detail: detail || null
        });
        this.firstElement.dispatchEvent(customEvent);
        return this;
    };
    // Does not support IE
    lgQuery.prototype.load = function(url) {
        var _this = this;
        fetch(url).then(function(res) {
            return res.text();
        }).then(function(html) {
            _this.selector.innerHTML = html;
        });
        return this;
    };
    lgQuery.prototype.html = function(html) {
        if (html === undefined) {
            if (!this.firstElement) return "";
            return this.firstElement.innerHTML;
        }
        this._each(function(el) {
            el.innerHTML = html;
        });
        return this;
    };
    lgQuery.prototype.append = function(html) {
        this._each(function(el) {
            if (typeof html === "string") el.insertAdjacentHTML("beforeend", html);
            else el.appendChild(html);
        });
        return this;
    };
    lgQuery.prototype.prepend = function(html) {
        this._each(function(el) {
            el.insertAdjacentHTML("afterbegin", html);
        });
        return this;
    };
    lgQuery.prototype.remove = function() {
        this._each(function(el) {
            el.parentNode.removeChild(el);
        });
        return this;
    };
    lgQuery.prototype.empty = function() {
        this._each(function(el) {
            el.innerHTML = "";
        });
        return this;
    };
    lgQuery.prototype.scrollTop = function(scrollTop) {
        if (scrollTop !== undefined) {
            document.body.scrollTop = scrollTop;
            document.documentElement.scrollTop = scrollTop;
            return this;
        } else return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    };
    lgQuery.prototype.scrollLeft = function(scrollLeft) {
        if (scrollLeft !== undefined) {
            document.body.scrollLeft = scrollLeft;
            document.documentElement.scrollLeft = scrollLeft;
            return this;
        } else return window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0;
    };
    lgQuery.prototype.offset = function() {
        if (!this.firstElement) return {
            left: 0,
            top: 0
        };
        var rect = this.firstElement.getBoundingClientRect();
        var bodyMarginLeft = $68e3467541a0efeb$var$$LG("body").style().marginLeft;
        // Minus body margin - https://stackoverflow.com/questions/30711548/is-getboundingclientrect-left-returning-a-wrong-value
        return {
            left: rect.left - parseFloat(bodyMarginLeft) + this.scrollLeft(),
            top: rect.top + this.scrollTop()
        };
    };
    lgQuery.prototype.style = function() {
        if (!this.firstElement) return {};
        return this.firstElement.currentStyle || window.getComputedStyle(this.firstElement);
    };
    // Width without padding and border even if box-sizing is used.
    lgQuery.prototype.width = function() {
        var style = this.style();
        return this.firstElement.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
    };
    // Height without padding and border even if box-sizing is used.
    lgQuery.prototype.height = function() {
        var style = this.style();
        return this.firstElement.clientHeight - parseFloat(style.paddingTop) - parseFloat(style.paddingBottom);
    };
    lgQuery.eventListeners = {};
    return lgQuery;
}();
function $68e3467541a0efeb$var$$LG(selector) {
    $68e3467541a0efeb$var$initLgPolyfills();
    return new $68e3467541a0efeb$var$lgQuery(selector);
}
var $68e3467541a0efeb$var$defaultDynamicOptions = [
    "src",
    "sources",
    "subHtml",
    "subHtmlUrl",
    "html",
    "video",
    "poster",
    "slideName",
    "responsive",
    "srcset",
    "sizes",
    "iframe",
    "downloadUrl",
    "download",
    "width",
    "facebookShareUrl",
    "tweetText",
    "iframeTitle",
    "twitterShareUrl",
    "pinterestShareUrl",
    "pinterestText",
    "fbHtml",
    "disqusIdentifier",
    "disqusUrl"
];
// Convert html data-attribute to camalcase
function $68e3467541a0efeb$var$convertToData(attr) {
    // FInd a way for lgsize
    if (attr === "href") return "src";
    attr = attr.replace("data-", "");
    attr = attr.charAt(0).toLowerCase() + attr.slice(1);
    attr = attr.replace(/-([a-z])/g, function(g) {
        return g[1].toUpperCase();
    });
    return attr;
}
var $68e3467541a0efeb$var$utils = {
    /**
     * get possible width and height from the lgSize attribute. Used for ZoomFromOrigin option
     */ getSize: function(el, container, spacing, defaultLgSize) {
        if (spacing === void 0) spacing = 0;
        var LGel = $68e3467541a0efeb$var$$LG(el);
        var lgSize = LGel.attr("data-lg-size") || defaultLgSize;
        if (!lgSize) return;
        var isResponsiveSizes = lgSize.split(",");
        // if at-least two viewport sizes are available
        if (isResponsiveSizes[1]) {
            var wWidth = window.innerWidth;
            for(var i = 0; i < isResponsiveSizes.length; i++){
                var size_1 = isResponsiveSizes[i];
                var responsiveWidth = parseInt(size_1.split("-")[2], 10);
                if (responsiveWidth > wWidth) {
                    lgSize = size_1;
                    break;
                }
                // take last item as last option
                if (i === isResponsiveSizes.length - 1) lgSize = size_1;
            }
        }
        var size = lgSize.split("-");
        var width = parseInt(size[0], 10);
        var height = parseInt(size[1], 10);
        var cWidth = container.width();
        var cHeight = container.height() - spacing;
        var maxWidth = Math.min(cWidth, width);
        var maxHeight = Math.min(cHeight, height);
        var ratio = Math.min(maxWidth / width, maxHeight / height);
        return {
            width: width * ratio,
            height: height * ratio
        };
    },
    /**
     * @desc Get transform value based on the imageSize. Used for ZoomFromOrigin option
     * @param {jQuery Element}
     * @returns {String} Transform CSS string
     */ getTransform: function(el, container, top, bottom, imageSize) {
        if (!imageSize) return;
        var LGel = $68e3467541a0efeb$var$$LG(el).find("img").first();
        if (!LGel.get()) return;
        var containerRect = container.get().getBoundingClientRect();
        var wWidth = containerRect.width;
        // using innerWidth to include mobile safari bottom bar
        var wHeight = container.height() - (top + bottom);
        var elWidth = LGel.width();
        var elHeight = LGel.height();
        var elStyle = LGel.style();
        var x = (wWidth - elWidth) / 2 - LGel.offset().left + (parseFloat(elStyle.paddingLeft) || 0) + (parseFloat(elStyle.borderLeft) || 0) + $68e3467541a0efeb$var$$LG(window).scrollLeft() + containerRect.left;
        var y = (wHeight - elHeight) / 2 - LGel.offset().top + (parseFloat(elStyle.paddingTop) || 0) + (parseFloat(elStyle.borderTop) || 0) + $68e3467541a0efeb$var$$LG(window).scrollTop() + top;
        var scX = elWidth / imageSize.width;
        var scY = elHeight / imageSize.height;
        var transform = "translate3d(" + (x *= -1) + "px, " + (y *= -1) + "px, 0) scale3d(" + scX + ", " + scY + ", 1)";
        return transform;
    },
    getIframeMarkup: function(iframeWidth, iframeHeight, iframeMaxWidth, iframeMaxHeight, src, iframeTitle) {
        var title = iframeTitle ? 'title="' + iframeTitle + '"' : "";
        return '<div class="lg-video-cont lg-has-iframe" style="width:' + iframeWidth + "; max-width:" + iframeMaxWidth + "; height: " + iframeHeight + "; max-height:" + iframeMaxHeight + '">\n                    <iframe class="lg-object" frameborder="0" ' + title + ' src="' + src + '"  allowfullscreen="true"></iframe>\n                </div>';
    },
    getImgMarkup: function(index, src, altAttr, srcset, sizes, sources) {
        var srcsetAttr = srcset ? 'srcset="' + srcset + '"' : "";
        var sizesAttr = sizes ? 'sizes="' + sizes + '"' : "";
        var imgMarkup = "<img " + altAttr + " " + srcsetAttr + "  " + sizesAttr + ' class="lg-object lg-image" data-index="' + index + '" src="' + src + '" />';
        var sourceTag = "";
        if (sources) {
            var sourceObj = typeof sources === "string" ? JSON.parse(sources) : sources;
            sourceTag = sourceObj.map(function(source) {
                var attrs = "";
                Object.keys(source).forEach(function(key) {
                    // Do not remove the first space as it is required to separate the attributes
                    attrs += " " + key + '="' + source[key] + '"';
                });
                return "<source " + attrs + "></source>";
            });
        }
        return "" + sourceTag + imgMarkup;
    },
    // Get src from responsive src
    getResponsiveSrc: function(srcItms) {
        var rsWidth = [];
        var rsSrc = [];
        var src = "";
        for(var i = 0; i < srcItms.length; i++){
            var _src = srcItms[i].split(" ");
            // Manage empty space
            if (_src[0] === "") _src.splice(0, 1);
            rsSrc.push(_src[0]);
            rsWidth.push(_src[1]);
        }
        var wWidth = window.innerWidth;
        for(var j = 0; j < rsWidth.length; j++)if (parseInt(rsWidth[j], 10) > wWidth) {
            src = rsSrc[j];
            break;
        }
        return src;
    },
    isImageLoaded: function(img) {
        if (!img) return false;
        // During the onload event, IE correctly identifies any images that
        // weren’t downloaded as not complete. Others should too. Gecko-based
        // browsers act like NS4 in that they report this incorrectly.
        if (!img.complete) return false;
        // However, they do have two very useful properties: naturalWidth and
        // naturalHeight. These give the true size of the image. If it failed
        // to load, either of these should be zero.
        if (img.naturalWidth === 0) return false;
        // No other way of checking: assume it’s ok.
        return true;
    },
    getVideoPosterMarkup: function(_poster, dummyImg, videoContStyle, playVideoString, _isVideo) {
        var videoClass = "";
        if (_isVideo && _isVideo.youtube) videoClass = "lg-has-youtube";
        else if (_isVideo && _isVideo.vimeo) videoClass = "lg-has-vimeo";
        else videoClass = "lg-has-html5";
        return '<div class="lg-video-cont ' + videoClass + '" style="' + videoContStyle + '">\n                <div class="lg-video-play-button">\n                <svg\n                    viewBox="0 0 20 20"\n                    preserveAspectRatio="xMidYMid"\n                    focusable="false"\n                    aria-labelledby="' + playVideoString + '"\n                    role="img"\n                    class="lg-video-play-icon"\n                >\n                    <title>' + playVideoString + '</title>\n                    <polygon class="lg-video-play-icon-inner" points="1,0 20,10 1,20"></polygon>\n                </svg>\n                <svg class="lg-video-play-icon-bg" viewBox="0 0 50 50" focusable="false">\n                    <circle cx="50%" cy="50%" r="20"></circle></svg>\n                <svg class="lg-video-play-icon-circle" viewBox="0 0 50 50" focusable="false">\n                    <circle cx="50%" cy="50%" r="20"></circle>\n                </svg>\n            </div>\n            ' + (dummyImg || "") + '\n            <img class="lg-object lg-video-poster" src="' + _poster + '" />\n        </div>';
    },
    getFocusableElements: function(container) {
        var elements = container.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
        var visibleElements = [].filter.call(elements, function(element) {
            var style = window.getComputedStyle(element);
            return style.display !== "none" && style.visibility !== "hidden";
        });
        return visibleElements;
    },
    /**
     * @desc Create dynamic elements array from gallery items when dynamic option is false
     * It helps to avoid frequent DOM interaction
     * and avoid multiple checks for dynamic elments
     *
     * @returns {Array} dynamicEl
     */ getDynamicOptions: function(items, extraProps, getCaptionFromTitleOrAlt, exThumbImage) {
        var dynamicElements = [];
        var availableDynamicOptions = $68e3467541a0efeb$var$__spreadArrays($68e3467541a0efeb$var$defaultDynamicOptions, extraProps);
        [].forEach.call(items, function(item) {
            var dynamicEl = {};
            for(var i = 0; i < item.attributes.length; i++){
                var attr = item.attributes[i];
                if (attr.specified) {
                    var dynamicAttr = $68e3467541a0efeb$var$convertToData(attr.name);
                    var label = "";
                    if (availableDynamicOptions.indexOf(dynamicAttr) > -1) label = dynamicAttr;
                    if (label) dynamicEl[label] = attr.value;
                }
            }
            var currentItem = $68e3467541a0efeb$var$$LG(item);
            var alt = currentItem.find("img").first().attr("alt");
            var title = currentItem.attr("title");
            var thumb = exThumbImage ? currentItem.attr(exThumbImage) : currentItem.find("img").first().attr("src");
            dynamicEl.thumb = thumb;
            if (getCaptionFromTitleOrAlt && !dynamicEl.subHtml) dynamicEl.subHtml = title || alt || "";
            dynamicEl.alt = alt || title || "";
            dynamicElements.push(dynamicEl);
        });
        return dynamicElements;
    },
    isMobile: function() {
        return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    },
    /**
     * @desc Check the given src is video
     * @param {String} src
     * @return {Object} video type
     * Ex:{ youtube  :  ["//www.youtube.com/watch?v=c0asJgSyxcY", "c0asJgSyxcY"] }
     *
     * @todo - this information can be moved to dynamicEl to avoid frequent calls
     */ isVideo: function(src, isHTML5VIdeo, index) {
        if (!src) {
            if (isHTML5VIdeo) return {
                html5: true
            };
            else {
                console.error("lightGallery :- data-src is not provided on slide item " + (index + 1) + ". Please make sure the selector property is properly configured. More info - https://www.lightgalleryjs.com/demos/html-markup/");
                return;
            }
        }
        var youtube = src.match(/\/\/(?:www\.)?youtu(?:\.be|be\.com|be-nocookie\.com)\/(?:watch\?v=|embed\/)?([a-z0-9\-\_\%]+)([\&|?][\S]*)*/i);
        var vimeo = src.match(/\/\/(?:www\.)?(?:player\.)?vimeo.com\/(?:video\/)?([0-9a-z\-_]+)(.*)?/i);
        var wistia = src.match(/https?:\/\/(.+)?(wistia\.com|wi\.st)\/(medias|embed)\/([0-9a-z\-_]+)(.*)/);
        if (youtube) return {
            youtube: youtube
        };
        else if (vimeo) return {
            vimeo: vimeo
        };
        else if (wistia) return {
            wistia: wistia
        };
    }
};
// @ref - https://stackoverflow.com/questions/3971841/how-to-resize-images-proportionally-keeping-the-aspect-ratio
// @ref - https://2ality.com/2017/04/setting-up-multi-platform-packages.html
// Unique id for each gallery
var $68e3467541a0efeb$var$lgId = 0;
var $68e3467541a0efeb$var$LightGallery = /** @class */ function() {
    function LightGallery(element, options) {
        this.lgOpened = false;
        this.index = 0;
        // lightGallery modules
        this.plugins = [];
        // false when lightGallery load first slide content;
        this.lGalleryOn = false;
        // True when a slide animation is in progress
        this.lgBusy = false;
        this.currentItemsInDom = [];
        // Scroll top value before lightGallery is opened
        this.prevScrollTop = 0;
        this.bodyPaddingRight = 0;
        this.isDummyImageRemoved = false;
        this.dragOrSwipeEnabled = false;
        this.mediaContainerPosition = {
            top: 0,
            bottom: 0
        };
        if (!element) return this;
        $68e3467541a0efeb$var$lgId++;
        this.lgId = $68e3467541a0efeb$var$lgId;
        this.el = element;
        this.LGel = $68e3467541a0efeb$var$$LG(element);
        this.generateSettings(options);
        this.buildModules();
        // When using dynamic mode, ensure dynamicEl is an array
        if (this.settings.dynamic && this.settings.dynamicEl !== undefined && !Array.isArray(this.settings.dynamicEl)) throw "When using dynamic mode, you must also define dynamicEl as an Array.";
        this.galleryItems = this.getItems();
        this.normalizeSettings();
        // Gallery items
        this.init();
        this.validateLicense();
        return this;
    }
    LightGallery.prototype.generateSettings = function(options) {
        // lightGallery settings
        this.settings = $68e3467541a0efeb$var$__assign($68e3467541a0efeb$var$__assign({}, $68e3467541a0efeb$var$lightGalleryCoreSettings), options);
        if (this.settings.isMobile && typeof this.settings.isMobile === "function" ? this.settings.isMobile() : $68e3467541a0efeb$var$utils.isMobile()) {
            var mobileSettings = $68e3467541a0efeb$var$__assign($68e3467541a0efeb$var$__assign({}, this.settings.mobileSettings), this.settings.mobileSettings);
            this.settings = $68e3467541a0efeb$var$__assign($68e3467541a0efeb$var$__assign({}, this.settings), mobileSettings);
        }
    };
    LightGallery.prototype.normalizeSettings = function() {
        if (this.settings.slideEndAnimation) this.settings.hideControlOnEnd = false;
        if (!this.settings.closable) this.settings.swipeToClose = false;
        // And reset it on close to get the correct value next time
        this.zoomFromOrigin = this.settings.zoomFromOrigin;
        // At the moment, Zoom from image doesn't support dynamic options
        // @todo add zoomFromOrigin support for dynamic images
        if (this.settings.dynamic) this.zoomFromOrigin = false;
        if (!this.settings.container) this.settings.container = document.body;
        // settings.preload should not be grater than $item.length
        this.settings.preload = Math.min(this.settings.preload, this.galleryItems.length);
    };
    LightGallery.prototype.init = function() {
        var _this = this;
        this.addSlideVideoInfo(this.galleryItems);
        this.buildStructure();
        this.LGel.trigger($68e3467541a0efeb$var$lGEvents.init, {
            instance: this
        });
        if (this.settings.keyPress) this.keyPress();
        setTimeout(function() {
            _this.enableDrag();
            _this.enableSwipe();
            _this.triggerPosterClick();
        }, 50);
        this.arrow();
        if (this.settings.mousewheel) this.mousewheel();
        if (!this.settings.dynamic) this.openGalleryOnItemClick();
    };
    LightGallery.prototype.openGalleryOnItemClick = function() {
        var _this = this;
        var _loop_1 = function(index) {
            var element = this_1.items[index];
            var $element = $68e3467541a0efeb$var$$LG(element);
            // Using different namespace for click because click event should not unbind if selector is same object('this')
            // @todo manage all event listners - should have namespace that represent element
            var uuid = $68e3467541a0efeb$var$lgQuery.generateUUID();
            $element.attr("data-lg-id", uuid).on("click.lgcustom-item-" + uuid, function(e) {
                e.preventDefault();
                var currentItemIndex = _this.settings.index || index;
                _this.openGallery(currentItemIndex, element);
            });
        };
        var this_1 = this;
        // Using for loop instead of using bubbling as the items can be any html element.
        for(var index = 0; index < this.items.length; index++)_loop_1(index);
    };
    /**
     * Module constructor
     * Modules are build incrementally.
     * Gallery should be opened only once all the modules are initialized.
     * use moduleBuildTimeout to make sure this
     */ LightGallery.prototype.buildModules = function() {
        var _this = this;
        this.settings.plugins.forEach(function(plugin) {
            _this.plugins.push(new plugin(_this, $68e3467541a0efeb$var$$LG));
        });
    };
    LightGallery.prototype.validateLicense = function() {
        if (!this.settings.licenseKey) console.error("Please provide a valid license key");
        else if (this.settings.licenseKey === "0000-0000-000-0000") console.warn("lightGallery: " + this.settings.licenseKey + " license key is not valid for production use");
    };
    LightGallery.prototype.getSlideItem = function(index) {
        return $68e3467541a0efeb$var$$LG(this.getSlideItemId(index));
    };
    LightGallery.prototype.getSlideItemId = function(index) {
        return "#lg-item-" + this.lgId + "-" + index;
    };
    LightGallery.prototype.getIdName = function(id) {
        return id + "-" + this.lgId;
    };
    LightGallery.prototype.getElementById = function(id) {
        return $68e3467541a0efeb$var$$LG("#" + this.getIdName(id));
    };
    LightGallery.prototype.manageSingleSlideClassName = function() {
        if (this.galleryItems.length < 2) this.outer.addClass("lg-single-item");
        else this.outer.removeClass("lg-single-item");
    };
    LightGallery.prototype.buildStructure = function() {
        var _this = this;
        var container = this.$container && this.$container.get();
        if (container) return;
        var controls = "";
        var subHtmlCont = "";
        // Create controls
        if (this.settings.controls) controls = '<button type="button" id="' + this.getIdName("lg-prev") + '" aria-label="' + this.settings.strings["previousSlide"] + '" class="lg-prev lg-icon"> ' + this.settings.prevHtml + ' </button>\n                <button type="button" id="' + this.getIdName("lg-next") + '" aria-label="' + this.settings.strings["nextSlide"] + '" class="lg-next lg-icon"> ' + this.settings.nextHtml + " </button>";
        if (this.settings.appendSubHtmlTo !== ".lg-item") subHtmlCont = '<div class="lg-sub-html" role="status" aria-live="polite"></div>';
        var addClasses = "";
        if (this.settings.allowMediaOverlap) // Do not remove space before last single quote
        addClasses += "lg-media-overlap ";
        var ariaLabelledby = this.settings.ariaLabelledby ? 'aria-labelledby="' + this.settings.ariaLabelledby + '"' : "";
        var ariaDescribedby = this.settings.ariaDescribedby ? 'aria-describedby="' + this.settings.ariaDescribedby + '"' : "";
        var containerClassName = "lg-container " + this.settings.addClass + " " + (document.body !== this.settings.container ? "lg-inline" : "");
        var closeIcon = this.settings.closable && this.settings.showCloseIcon ? '<button type="button" aria-label="' + this.settings.strings["closeGallery"] + '" id="' + this.getIdName("lg-close") + '" class="lg-close lg-icon"></button>' : "";
        var maximizeIcon = this.settings.showMaximizeIcon ? '<button type="button" aria-label="' + this.settings.strings["toggleMaximize"] + '" id="' + this.getIdName("lg-maximize") + '" class="lg-maximize lg-icon"></button>' : "";
        var template = '\n        <div class="' + containerClassName + '" id="' + this.getIdName("lg-container") + '" tabindex="-1" aria-modal="true" ' + ariaLabelledby + " " + ariaDescribedby + ' role="dialog"\n        >\n            <div id="' + this.getIdName("lg-backdrop") + '" class="lg-backdrop"></div>\n\n            <div id="' + this.getIdName("lg-outer") + '" class="lg-outer lg-use-css3 lg-css3 lg-hide-items ' + addClasses + ' ">\n\n              <div id="' + this.getIdName("lg-content") + '" class="lg-content">\n                <div id="' + this.getIdName("lg-inner") + '" class="lg-inner">\n                </div>\n                ' + controls + '\n              </div>\n                <div id="' + this.getIdName("lg-toolbar") + '" class="lg-toolbar lg-group">\n                    ' + maximizeIcon + "\n                    " + closeIcon + "\n                    </div>\n                    " + (this.settings.appendSubHtmlTo === ".lg-outer" ? subHtmlCont : "") + '\n                <div id="' + this.getIdName("lg-components") + '" class="lg-components">\n                    ' + (this.settings.appendSubHtmlTo === ".lg-sub-html" ? subHtmlCont : "") + "\n                </div>\n            </div>\n        </div>\n        ";
        $68e3467541a0efeb$var$$LG(this.settings.container).append(template);
        if (document.body !== this.settings.container) $68e3467541a0efeb$var$$LG(this.settings.container).css("position", "relative");
        this.outer = this.getElementById("lg-outer");
        this.$lgComponents = this.getElementById("lg-components");
        this.$backdrop = this.getElementById("lg-backdrop");
        this.$container = this.getElementById("lg-container");
        this.$inner = this.getElementById("lg-inner");
        this.$content = this.getElementById("lg-content");
        this.$toolbar = this.getElementById("lg-toolbar");
        this.$backdrop.css("transition-duration", this.settings.backdropDuration + "ms");
        var outerClassNames = this.settings.mode + " ";
        this.manageSingleSlideClassName();
        if (this.settings.enableDrag) outerClassNames += "lg-grab ";
        this.outer.addClass(outerClassNames);
        this.$inner.css("transition-timing-function", this.settings.easing);
        this.$inner.css("transition-duration", this.settings.speed + "ms");
        if (this.settings.download) this.$toolbar.append('<a id="' + this.getIdName("lg-download") + '" target="_blank" rel="noopener" aria-label="' + this.settings.strings["download"] + '" download class="lg-download lg-icon"></a>');
        this.counter();
        $68e3467541a0efeb$var$$LG(window).on("resize.lg.global" + this.lgId + " orientationchange.lg.global" + this.lgId, function() {
            _this.refreshOnResize();
        });
        this.hideBars();
        this.manageCloseGallery();
        this.toggleMaximize();
        this.initModules();
    };
    LightGallery.prototype.refreshOnResize = function() {
        if (this.lgOpened) {
            var currentGalleryItem = this.galleryItems[this.index];
            var __slideVideoInfo = currentGalleryItem.__slideVideoInfo;
            this.mediaContainerPosition = this.getMediaContainerPosition();
            var _a = this.mediaContainerPosition, top_1 = _a.top, bottom = _a.bottom;
            this.currentImageSize = $68e3467541a0efeb$var$utils.getSize(this.items[this.index], this.outer, top_1 + bottom, __slideVideoInfo && this.settings.videoMaxSize);
            if (__slideVideoInfo) this.resizeVideoSlide(this.index, this.currentImageSize);
            if (this.zoomFromOrigin && !this.isDummyImageRemoved) {
                var imgStyle = this.getDummyImgStyles(this.currentImageSize);
                this.outer.find(".lg-current .lg-dummy-img").first().attr("style", imgStyle);
            }
            this.LGel.trigger($68e3467541a0efeb$var$lGEvents.containerResize);
        }
    };
    LightGallery.prototype.resizeVideoSlide = function(index, imageSize) {
        var lgVideoStyle = this.getVideoContStyle(imageSize);
        var currentSlide = this.getSlideItem(index);
        currentSlide.find(".lg-video-cont").attr("style", lgVideoStyle);
    };
    /**
     * Update slides dynamically.
     * Add, edit or delete slides dynamically when lightGallery is opened.
     * Modify the current gallery items and pass it via updateSlides method
     * @note
     * - Do not mutate existing lightGallery items directly.
     * - Always pass new list of gallery items
     * - You need to take care of thumbnails outside the gallery if any
     * - user this method only if you want to update slides when the gallery is opened. Otherwise, use `refresh()` method.
     * @param items Gallery items
     * @param index After the update operation, which slide gallery should navigate to
     * @category lGPublicMethods
     * @example
     * const plugin = lightGallery();
     *
     * // Adding slides dynamically
     * let galleryItems = [
     * // Access existing lightGallery items
     * // galleryItems are automatically generated internally from the gallery HTML markup
     * // or directly from galleryItems when dynamic gallery is used
     *   ...plugin.galleryItems,
     *     ...[
     *       {
     *         src: 'img/img-1.png',
     *           thumb: 'img/thumb1.png',
     *         },
     *     ],
     *   ];
     *   plugin.updateSlides(
     *     galleryItems,
     *     plugin.index,
     *   );
     *
     *
     * // Remove slides dynamically
     * galleryItems = JSON.parse(
     *   JSON.stringify(updateSlideInstance.galleryItems),
     * );
     * galleryItems.shift();
     * updateSlideInstance.updateSlides(galleryItems, 1);
     * @see <a href="/demos/update-slides/">Demo</a>
     */ LightGallery.prototype.updateSlides = function(items, index) {
        if (this.index > items.length - 1) this.index = items.length - 1;
        if (items.length === 1) this.index = 0;
        if (!items.length) {
            this.closeGallery();
            return;
        }
        var currentSrc = this.galleryItems[index].src;
        this.galleryItems = items;
        this.updateControls();
        this.$inner.empty();
        this.currentItemsInDom = [];
        var _index = 0;
        // Find the current index based on source value of the slide
        this.galleryItems.some(function(galleryItem, itemIndex) {
            if (galleryItem.src === currentSrc) {
                _index = itemIndex;
                return true;
            }
            return false;
        });
        this.currentItemsInDom = this.organizeSlideItems(_index, -1);
        this.loadContent(_index, true);
        this.getSlideItem(_index).addClass("lg-current");
        this.index = _index;
        this.updateCurrentCounter(_index);
        this.LGel.trigger($68e3467541a0efeb$var$lGEvents.updateSlides);
    };
    // Get gallery items based on multiple conditions
    LightGallery.prototype.getItems = function() {
        // Gallery items
        this.items = [];
        if (!this.settings.dynamic) {
            if (this.settings.selector === "this") this.items.push(this.el);
            else if (this.settings.selector) {
                if (typeof this.settings.selector === "string") {
                    if (this.settings.selectWithin) {
                        var selectWithin = $68e3467541a0efeb$var$$LG(this.settings.selectWithin);
                        this.items = selectWithin.find(this.settings.selector).get();
                    } else this.items = this.el.querySelectorAll(this.settings.selector);
                } else this.items = this.settings.selector;
            } else this.items = this.el.children;
            return $68e3467541a0efeb$var$utils.getDynamicOptions(this.items, this.settings.extraProps, this.settings.getCaptionFromTitleOrAlt, this.settings.exThumbImage);
        } else return this.settings.dynamicEl || [];
    };
    LightGallery.prototype.shouldHideScrollbar = function() {
        return this.settings.hideScrollbar && document.body === this.settings.container;
    };
    LightGallery.prototype.hideScrollbar = function() {
        if (!this.shouldHideScrollbar()) return;
        this.bodyPaddingRight = parseFloat($68e3467541a0efeb$var$$LG("body").style().paddingRight);
        var bodyRect = document.documentElement.getBoundingClientRect();
        var scrollbarWidth = window.innerWidth - bodyRect.width;
        $68e3467541a0efeb$var$$LG(document.body).css("padding-right", scrollbarWidth + this.bodyPaddingRight + "px");
        $68e3467541a0efeb$var$$LG(document.body).addClass("lg-overlay-open");
    };
    LightGallery.prototype.resetScrollBar = function() {
        if (!this.shouldHideScrollbar()) return;
        $68e3467541a0efeb$var$$LG(document.body).css("padding-right", this.bodyPaddingRight + "px");
        $68e3467541a0efeb$var$$LG(document.body).removeClass("lg-overlay-open");
    };
    /**
     * Open lightGallery.
     * Open gallery with specific slide by passing index of the slide as parameter.
     * @category lGPublicMethods
     * @param {Number} index  - index of the slide
     * @param {HTMLElement} element - Which image lightGallery should zoom from
     *
     * @example
     * const $dynamicGallery = document.getElementById('dynamic-gallery-demo');
     * const dynamicGallery = lightGallery($dynamicGallery, {
     *     dynamic: true,
     *     dynamicEl: [
     *         {
     *              src: 'img/1.jpg',
     *              thumb: 'img/thumb-1.jpg',
     *              subHtml: '<h4>Image 1 title</h4><p>Image 1 descriptions.</p>',
     *         },
     *         ...
     *     ],
     * });
     * $dynamicGallery.addEventListener('click', function () {
     *     // Starts with third item.(Optional).
     *     // This is useful if you want use dynamic mode with
     *     // custom thumbnails (thumbnails outside gallery),
     *     dynamicGallery.openGallery(2);
     * });
     *
     */ LightGallery.prototype.openGallery = function(index, element) {
        var _this = this;
        if (index === void 0) index = this.settings.index;
        // prevent accidental double execution
        if (this.lgOpened) return;
        this.lgOpened = true;
        this.outer.removeClass("lg-hide-items");
        this.hideScrollbar();
        // Add display block, but still has opacity 0
        this.$container.addClass("lg-show");
        var itemsToBeInsertedToDom = this.getItemsToBeInsertedToDom(index, index);
        this.currentItemsInDom = itemsToBeInsertedToDom;
        var items = "";
        itemsToBeInsertedToDom.forEach(function(item) {
            items = items + ('<div id="' + item + '" class="lg-item"></div>');
        });
        this.$inner.append(items);
        this.addHtml(index);
        var transform = "";
        this.mediaContainerPosition = this.getMediaContainerPosition();
        var _a = this.mediaContainerPosition, top = _a.top, bottom = _a.bottom;
        if (!this.settings.allowMediaOverlap) this.setMediaContainerPosition(top, bottom);
        var __slideVideoInfo = this.galleryItems[index].__slideVideoInfo;
        if (this.zoomFromOrigin && element) {
            this.currentImageSize = $68e3467541a0efeb$var$utils.getSize(element, this.outer, top + bottom, __slideVideoInfo && this.settings.videoMaxSize);
            transform = $68e3467541a0efeb$var$utils.getTransform(element, this.outer, top, bottom, this.currentImageSize);
        }
        if (!this.zoomFromOrigin || !transform) {
            this.outer.addClass(this.settings.startClass);
            this.getSlideItem(index).removeClass("lg-complete");
        }
        var timeout = this.settings.zoomFromOrigin ? 100 : this.settings.backdropDuration;
        setTimeout(function() {
            _this.outer.addClass("lg-components-open");
        }, timeout);
        this.index = index;
        this.LGel.trigger($68e3467541a0efeb$var$lGEvents.beforeOpen);
        // add class lg-current to remove initial transition
        this.getSlideItem(index).addClass("lg-current");
        this.lGalleryOn = false;
        // Store the current scroll top value to scroll back after closing the gallery..
        this.prevScrollTop = $68e3467541a0efeb$var$$LG(window).scrollTop();
        setTimeout(function() {
            // Need to check both zoomFromOrigin and transform values as we need to set set the
            // default opening animation if user missed to add the lg-size attribute
            if (_this.zoomFromOrigin && transform) {
                var currentSlide_1 = _this.getSlideItem(index);
                currentSlide_1.css("transform", transform);
                setTimeout(function() {
                    currentSlide_1.addClass("lg-start-progress lg-start-end-progress").css("transition-duration", _this.settings.startAnimationDuration + "ms");
                    _this.outer.addClass("lg-zoom-from-image");
                });
                setTimeout(function() {
                    currentSlide_1.css("transform", "translate3d(0, 0, 0)");
                }, 100);
            }
            setTimeout(function() {
                _this.$backdrop.addClass("in");
                _this.$container.addClass("lg-show-in");
            }, 10);
            setTimeout(function() {
                if (_this.settings.trapFocus && document.body === _this.settings.container) _this.trapFocus();
            }, _this.settings.backdropDuration + 50);
            // lg-visible class resets gallery opacity to 1
            if (!_this.zoomFromOrigin || !transform) setTimeout(function() {
                _this.outer.addClass("lg-visible");
            }, _this.settings.backdropDuration);
            // initiate slide function
            _this.slide(index, false, false, false);
            _this.LGel.trigger($68e3467541a0efeb$var$lGEvents.afterOpen);
        });
        if (document.body === this.settings.container) $68e3467541a0efeb$var$$LG("html").addClass("lg-on");
    };
    /**
     * Note - Changing the position of the media on every slide transition creates a flickering effect.
     * Therefore, The height of the caption is calculated dynamically, only once based on the first slide caption.
     * if you have dynamic captions for each media,
     * you can provide an appropriate height for the captions via allowMediaOverlap option
     */ LightGallery.prototype.getMediaContainerPosition = function() {
        if (this.settings.allowMediaOverlap) return {
            top: 0,
            bottom: 0
        };
        var top = this.$toolbar.get().clientHeight || 0;
        var subHtml = this.outer.find(".lg-components .lg-sub-html").get();
        var captionHeight = this.settings.defaultCaptionHeight || subHtml && subHtml.clientHeight || 0;
        var thumbContainer = this.outer.find(".lg-thumb-outer").get();
        var thumbHeight = thumbContainer ? thumbContainer.clientHeight : 0;
        var bottom = thumbHeight + captionHeight;
        return {
            top: top,
            bottom: bottom
        };
    };
    LightGallery.prototype.setMediaContainerPosition = function(top, bottom) {
        if (top === void 0) top = 0;
        if (bottom === void 0) bottom = 0;
        this.$content.css("top", top + "px").css("bottom", bottom + "px");
    };
    LightGallery.prototype.hideBars = function() {
        var _this = this;
        // Hide controllers if mouse doesn't move for some period
        setTimeout(function() {
            _this.outer.removeClass("lg-hide-items");
            if (_this.settings.hideBarsDelay > 0) {
                _this.outer.on("mousemove.lg click.lg touchstart.lg", function() {
                    _this.outer.removeClass("lg-hide-items");
                    clearTimeout(_this.hideBarTimeout);
                    // Timeout will be cleared on each slide movement also
                    _this.hideBarTimeout = setTimeout(function() {
                        _this.outer.addClass("lg-hide-items");
                    }, _this.settings.hideBarsDelay);
                });
                _this.outer.trigger("mousemove.lg");
            }
        }, this.settings.showBarsAfter);
    };
    LightGallery.prototype.initPictureFill = function($img) {
        if (this.settings.supportLegacyBrowser) try {
            picturefill({
                elements: [
                    $img.get()
                ]
            });
        } catch (e) {
            console.warn("lightGallery :- If you want srcset or picture tag to be supported for older browser please include picturefil javascript library in your document.");
        }
    };
    /**
     *  @desc Create image counter
     *  Ex: 1/10
     */ LightGallery.prototype.counter = function() {
        if (this.settings.counter) {
            var counterHtml = '<div class="lg-counter" role="status" aria-live="polite">\n                <span id="' + this.getIdName("lg-counter-current") + '" class="lg-counter-current">' + (this.index + 1) + ' </span> /\n                <span id="' + this.getIdName("lg-counter-all") + '" class="lg-counter-all">' + this.galleryItems.length + " </span></div>";
            this.outer.find(this.settings.appendCounterTo).append(counterHtml);
        }
    };
    /**
     *  @desc add sub-html into the slide
     *  @param {Number} index - index of the slide
     */ LightGallery.prototype.addHtml = function(index) {
        var subHtml;
        var subHtmlUrl;
        if (this.galleryItems[index].subHtmlUrl) subHtmlUrl = this.galleryItems[index].subHtmlUrl;
        else subHtml = this.galleryItems[index].subHtml;
        if (!subHtmlUrl) {
            if (subHtml) {
                // get first letter of sub-html
                // if first letter starts with . or # get the html form the jQuery object
                var fL = subHtml.substring(0, 1);
                if (fL === "." || fL === "#") {
                    if (this.settings.subHtmlSelectorRelative && !this.settings.dynamic) subHtml = $68e3467541a0efeb$var$$LG(this.items).eq(index).find(subHtml).first().html();
                    else subHtml = $68e3467541a0efeb$var$$LG(subHtml).first().html();
                }
            } else subHtml = "";
        }
        if (this.settings.appendSubHtmlTo !== ".lg-item") {
            if (subHtmlUrl) this.outer.find(".lg-sub-html").load(subHtmlUrl);
            else this.outer.find(".lg-sub-html").html(subHtml);
        } else {
            var currentSlide = $68e3467541a0efeb$var$$LG(this.getSlideItemId(index));
            if (subHtmlUrl) currentSlide.load(subHtmlUrl);
            else currentSlide.append('<div class="lg-sub-html">' + subHtml + "</div>");
        }
        // Add lg-empty-html class if title doesn't exist
        if (typeof subHtml !== "undefined" && subHtml !== null) {
            if (subHtml === "") this.outer.find(this.settings.appendSubHtmlTo).addClass("lg-empty-html");
            else this.outer.find(this.settings.appendSubHtmlTo).removeClass("lg-empty-html");
        }
        this.LGel.trigger($68e3467541a0efeb$var$lGEvents.afterAppendSubHtml, {
            index: index
        });
    };
    /**
     *  @desc Preload slides
     *  @param {Number} index - index of the slide
     * @todo preload not working for the first slide, Also, should work for the first and last slide as well
     */ LightGallery.prototype.preload = function(index) {
        for(var i = 1; i <= this.settings.preload; i++){
            if (i >= this.galleryItems.length - index) break;
            this.loadContent(index + i, false);
        }
        for(var j = 1; j <= this.settings.preload; j++){
            if (index - j < 0) break;
            this.loadContent(index - j, false);
        }
    };
    LightGallery.prototype.getDummyImgStyles = function(imageSize) {
        if (!imageSize) return "";
        return "width:" + imageSize.width + "px;\n                margin-left: -" + imageSize.width / 2 + "px;\n                margin-top: -" + imageSize.height / 2 + "px;\n                height:" + imageSize.height + "px";
    };
    LightGallery.prototype.getVideoContStyle = function(imageSize) {
        if (!imageSize) return "";
        return "width:" + imageSize.width + "px;\n                height:" + imageSize.height + "px";
    };
    LightGallery.prototype.getDummyImageContent = function($currentSlide, index, alt) {
        var $currentItem;
        if (!this.settings.dynamic) $currentItem = $68e3467541a0efeb$var$$LG(this.items).eq(index);
        if ($currentItem) {
            var _dummyImgSrc = void 0;
            if (!this.settings.exThumbImage) _dummyImgSrc = $currentItem.find("img").first().attr("src");
            else _dummyImgSrc = $currentItem.attr(this.settings.exThumbImage);
            if (!_dummyImgSrc) return "";
            var imgStyle = this.getDummyImgStyles(this.currentImageSize);
            var dummyImgContent = "<img " + alt + ' style="' + imgStyle + '" class="lg-dummy-img" src="' + _dummyImgSrc + '" />';
            $currentSlide.addClass("lg-first-slide");
            this.outer.addClass("lg-first-slide-loading");
            return dummyImgContent;
        }
        return "";
    };
    LightGallery.prototype.setImgMarkup = function(src, $currentSlide, index) {
        var currentGalleryItem = this.galleryItems[index];
        var alt = currentGalleryItem.alt, srcset = currentGalleryItem.srcset, sizes = currentGalleryItem.sizes, sources = currentGalleryItem.sources;
        // Use the thumbnail as dummy image which will be resized to actual image size and
        // displayed on top of actual image
        var imgContent = "";
        var altAttr = alt ? 'alt="' + alt + '"' : "";
        if (this.isFirstSlideWithZoomAnimation()) imgContent = this.getDummyImageContent($currentSlide, index, altAttr);
        else imgContent = $68e3467541a0efeb$var$utils.getImgMarkup(index, src, altAttr, srcset, sizes, sources);
        var imgMarkup = '<picture class="lg-img-wrap"> ' + imgContent + "</picture>";
        $currentSlide.prepend(imgMarkup);
    };
    LightGallery.prototype.onSlideObjectLoad = function($slide, isHTML5VideoWithoutPoster, onLoad, onError) {
        var mediaObject = $slide.find(".lg-object").first();
        if ($68e3467541a0efeb$var$utils.isImageLoaded(mediaObject.get()) || isHTML5VideoWithoutPoster) onLoad();
        else {
            mediaObject.on("load.lg error.lg", function() {
                onLoad && onLoad();
            });
            mediaObject.on("error.lg", function() {
                onError && onError();
            });
        }
    };
    /**
     *
     * @param $el Current slide item
     * @param index
     * @param delay Delay is 0 except first time
     * @param speed Speed is same as delay, except it is 0 if gallery is opened via hash plugin
     * @param isFirstSlide
     */ LightGallery.prototype.onLgObjectLoad = function(currentSlide, index, delay, speed, isFirstSlide, isHTML5VideoWithoutPoster) {
        var _this = this;
        this.onSlideObjectLoad(currentSlide, isHTML5VideoWithoutPoster, function() {
            _this.triggerSlideItemLoad(currentSlide, index, delay, speed, isFirstSlide);
        }, function() {
            currentSlide.addClass("lg-complete lg-complete_");
            currentSlide.html('<span class="lg-error-msg">' + _this.settings.strings["mediaLoadingFailed"] + "</span>");
        });
    };
    LightGallery.prototype.triggerSlideItemLoad = function($currentSlide, index, delay, speed, isFirstSlide) {
        var _this = this;
        var currentGalleryItem = this.galleryItems[index];
        // Adding delay for video slides without poster for better performance and user experience
        // Videos should start playing once once the gallery is completely loaded
        var _speed = isFirstSlide && this.getSlideType(currentGalleryItem) === "video" && !currentGalleryItem.poster ? speed : 0;
        setTimeout(function() {
            $currentSlide.addClass("lg-complete lg-complete_");
            _this.LGel.trigger($68e3467541a0efeb$var$lGEvents.slideItemLoad, {
                index: index,
                delay: delay || 0,
                isFirstSlide: isFirstSlide
            });
        }, _speed);
    };
    LightGallery.prototype.isFirstSlideWithZoomAnimation = function() {
        return !!(!this.lGalleryOn && this.zoomFromOrigin && this.currentImageSize);
    };
    // Add video slideInfo
    LightGallery.prototype.addSlideVideoInfo = function(items) {
        var _this = this;
        items.forEach(function(element, index) {
            element.__slideVideoInfo = $68e3467541a0efeb$var$utils.isVideo(element.src, !!element.video, index);
            if (element.__slideVideoInfo && _this.settings.loadYouTubePoster && !element.poster && element.__slideVideoInfo.youtube) element.poster = "//img.youtube.com/vi/" + element.__slideVideoInfo.youtube[1] + "/maxresdefault.jpg";
        });
    };
    /**
     *  Load slide content into slide.
     *  This is used to load content into slides that is not visible too
     *  @param {Number} index - index of the slide.
     *  @param {Boolean} rec - if true call loadcontent() function again.
     */ LightGallery.prototype.loadContent = function(index, rec) {
        var _this = this;
        var currentGalleryItem = this.galleryItems[index];
        var $currentSlide = $68e3467541a0efeb$var$$LG(this.getSlideItemId(index));
        var poster = currentGalleryItem.poster, srcset = currentGalleryItem.srcset, sizes = currentGalleryItem.sizes, sources = currentGalleryItem.sources;
        var src = currentGalleryItem.src;
        var video = currentGalleryItem.video;
        var _html5Video = video && typeof video === "string" ? JSON.parse(video) : video;
        if (currentGalleryItem.responsive) {
            var srcDyItms = currentGalleryItem.responsive.split(",");
            src = $68e3467541a0efeb$var$utils.getResponsiveSrc(srcDyItms) || src;
        }
        var videoInfo = currentGalleryItem.__slideVideoInfo;
        var lgVideoStyle = "";
        var iframe = !!currentGalleryItem.iframe;
        var isFirstSlide = !this.lGalleryOn;
        // delay for adding complete class. it is 0 except first time.
        var delay = 0;
        if (isFirstSlide) {
            if (this.zoomFromOrigin && this.currentImageSize) delay = this.settings.startAnimationDuration + 10;
            else delay = this.settings.backdropDuration + 10;
        }
        if (!$currentSlide.hasClass("lg-loaded")) {
            if (videoInfo) {
                var _a = this.mediaContainerPosition, top_2 = _a.top, bottom = _a.bottom;
                var videoSize = $68e3467541a0efeb$var$utils.getSize(this.items[index], this.outer, top_2 + bottom, videoInfo && this.settings.videoMaxSize);
                lgVideoStyle = this.getVideoContStyle(videoSize);
            }
            if (iframe) {
                var markup = $68e3467541a0efeb$var$utils.getIframeMarkup(this.settings.iframeWidth, this.settings.iframeHeight, this.settings.iframeMaxWidth, this.settings.iframeMaxHeight, src, currentGalleryItem.iframeTitle);
                $currentSlide.prepend(markup);
            } else if (poster) {
                var dummyImg = "";
                var hasStartAnimation = isFirstSlide && this.zoomFromOrigin && this.currentImageSize;
                if (hasStartAnimation) dummyImg = this.getDummyImageContent($currentSlide, index, "");
                var markup = $68e3467541a0efeb$var$utils.getVideoPosterMarkup(poster, dummyImg || "", lgVideoStyle, this.settings.strings["playVideo"], videoInfo);
                $currentSlide.prepend(markup);
            } else if (videoInfo) {
                var markup = '<div class="lg-video-cont " style="' + lgVideoStyle + '"></div>';
                $currentSlide.prepend(markup);
            } else {
                this.setImgMarkup(src, $currentSlide, index);
                if (srcset || sources) {
                    var $img = $currentSlide.find(".lg-object");
                    this.initPictureFill($img);
                }
            }
            if (poster || videoInfo) this.LGel.trigger($68e3467541a0efeb$var$lGEvents.hasVideo, {
                index: index,
                src: src,
                html5Video: _html5Video,
                hasPoster: !!poster
            });
            this.LGel.trigger($68e3467541a0efeb$var$lGEvents.afterAppendSlide, {
                index: index
            });
            if (this.lGalleryOn && this.settings.appendSubHtmlTo === ".lg-item") this.addHtml(index);
        }
        // For first time add some delay for displaying the start animation.
        var _speed = 0;
        // Do not change the delay value because it is required for zoom plugin.
        // If gallery opened from direct url (hash) speed value should be 0
        if (delay && !$68e3467541a0efeb$var$$LG(document.body).hasClass("lg-from-hash")) _speed = delay;
        // Only for first slide and zoomFromOrigin is enabled
        if (this.isFirstSlideWithZoomAnimation()) {
            setTimeout(function() {
                $currentSlide.removeClass("lg-start-end-progress lg-start-progress").removeAttr("style");
            }, this.settings.startAnimationDuration + 100);
            if (!$currentSlide.hasClass("lg-loaded")) setTimeout(function() {
                if (_this.getSlideType(currentGalleryItem) === "image") {
                    var alt = currentGalleryItem.alt;
                    var altAttr = alt ? 'alt="' + alt + '"' : "";
                    $currentSlide.find(".lg-img-wrap").append($68e3467541a0efeb$var$utils.getImgMarkup(index, src, altAttr, srcset, sizes, currentGalleryItem.sources));
                    if (srcset || sources) {
                        var $img = $currentSlide.find(".lg-object");
                        _this.initPictureFill($img);
                    }
                }
                if (_this.getSlideType(currentGalleryItem) === "image" || _this.getSlideType(currentGalleryItem) === "video" && poster) {
                    _this.onLgObjectLoad($currentSlide, index, delay, _speed, true, false);
                    // load remaining slides once the slide is completely loaded
                    _this.onSlideObjectLoad($currentSlide, !!(videoInfo && videoInfo.html5 && !poster), function() {
                        _this.loadContentOnFirstSlideLoad(index, $currentSlide, _speed);
                    }, function() {
                        _this.loadContentOnFirstSlideLoad(index, $currentSlide, _speed);
                    });
                }
            }, this.settings.startAnimationDuration + 100);
        }
        // SLide content has been added to dom
        $currentSlide.addClass("lg-loaded");
        if (!this.isFirstSlideWithZoomAnimation() || this.getSlideType(currentGalleryItem) === "video" && !poster) this.onLgObjectLoad($currentSlide, index, delay, _speed, isFirstSlide, !!(videoInfo && videoInfo.html5 && !poster));
        // When gallery is opened once content is loaded (second time) need to add lg-complete class for css styling
        if ((!this.zoomFromOrigin || !this.currentImageSize) && $currentSlide.hasClass("lg-complete_") && !this.lGalleryOn) setTimeout(function() {
            $currentSlide.addClass("lg-complete");
        }, this.settings.backdropDuration);
        // Content loaded
        // Need to set lGalleryOn before calling preload function
        this.lGalleryOn = true;
        if (rec === true) {
            if (!$currentSlide.hasClass("lg-complete_")) $currentSlide.find(".lg-object").first().on("load.lg error.lg", function() {
                _this.preload(index);
            });
            else this.preload(index);
        }
    };
    /**
     * @desc Remove dummy image content and load next slides
     * Called only for the first time if zoomFromOrigin animation is enabled
     * @param index
     * @param $currentSlide
     * @param speed
     */ LightGallery.prototype.loadContentOnFirstSlideLoad = function(index, $currentSlide, speed) {
        var _this = this;
        setTimeout(function() {
            $currentSlide.find(".lg-dummy-img").remove();
            $currentSlide.removeClass("lg-first-slide");
            _this.outer.removeClass("lg-first-slide-loading");
            _this.isDummyImageRemoved = true;
            _this.preload(index);
        }, speed + 300);
    };
    LightGallery.prototype.getItemsToBeInsertedToDom = function(index, prevIndex, numberOfItems) {
        var _this = this;
        if (numberOfItems === void 0) numberOfItems = 0;
        var itemsToBeInsertedToDom = [];
        // Minimum 2 items should be there
        var possibleNumberOfItems = Math.max(numberOfItems, 3);
        possibleNumberOfItems = Math.min(possibleNumberOfItems, this.galleryItems.length);
        var prevIndexItem = "lg-item-" + this.lgId + "-" + prevIndex;
        if (this.galleryItems.length <= 3) {
            this.galleryItems.forEach(function(_element, index) {
                itemsToBeInsertedToDom.push("lg-item-" + _this.lgId + "-" + index);
            });
            return itemsToBeInsertedToDom;
        }
        if (index < (this.galleryItems.length - 1) / 2) {
            for(var idx = index; idx > index - possibleNumberOfItems / 2 && idx >= 0; idx--)itemsToBeInsertedToDom.push("lg-item-" + this.lgId + "-" + idx);
            var numberOfExistingItems = itemsToBeInsertedToDom.length;
            for(var idx = 0; idx < possibleNumberOfItems - numberOfExistingItems; idx++)itemsToBeInsertedToDom.push("lg-item-" + this.lgId + "-" + (index + idx + 1));
        } else {
            for(var idx = index; idx <= this.galleryItems.length - 1 && idx < index + possibleNumberOfItems / 2; idx++)itemsToBeInsertedToDom.push("lg-item-" + this.lgId + "-" + idx);
            var numberOfExistingItems = itemsToBeInsertedToDom.length;
            for(var idx = 0; idx < possibleNumberOfItems - numberOfExistingItems; idx++)itemsToBeInsertedToDom.push("lg-item-" + this.lgId + "-" + (index - idx - 1));
        }
        if (this.settings.loop) {
            if (index === this.galleryItems.length - 1) itemsToBeInsertedToDom.push("lg-item-" + this.lgId + "-" + 0);
            else if (index === 0) itemsToBeInsertedToDom.push("lg-item-" + this.lgId + "-" + (this.galleryItems.length - 1));
        }
        if (itemsToBeInsertedToDom.indexOf(prevIndexItem) === -1) itemsToBeInsertedToDom.push("lg-item-" + this.lgId + "-" + prevIndex);
        return itemsToBeInsertedToDom;
    };
    LightGallery.prototype.organizeSlideItems = function(index, prevIndex) {
        var _this = this;
        var itemsToBeInsertedToDom = this.getItemsToBeInsertedToDom(index, prevIndex, this.settings.numberOfSlideItemsInDom);
        itemsToBeInsertedToDom.forEach(function(item) {
            if (_this.currentItemsInDom.indexOf(item) === -1) _this.$inner.append('<div id="' + item + '" class="lg-item"></div>');
        });
        this.currentItemsInDom.forEach(function(item) {
            if (itemsToBeInsertedToDom.indexOf(item) === -1) $68e3467541a0efeb$var$$LG("#" + item).remove();
        });
        return itemsToBeInsertedToDom;
    };
    /**
     * Get previous index of the slide
     */ LightGallery.prototype.getPreviousSlideIndex = function() {
        var prevIndex = 0;
        try {
            var currentItemId = this.outer.find(".lg-current").first().attr("id");
            prevIndex = parseInt(currentItemId.split("-")[3]) || 0;
        } catch (error) {
            prevIndex = 0;
        }
        return prevIndex;
    };
    LightGallery.prototype.setDownloadValue = function(index) {
        if (this.settings.download) {
            var currentGalleryItem = this.galleryItems[index];
            var hideDownloadBtn = currentGalleryItem.downloadUrl === false || currentGalleryItem.downloadUrl === "false";
            if (hideDownloadBtn) this.outer.addClass("lg-hide-download");
            else {
                var $download = this.getElementById("lg-download");
                this.outer.removeClass("lg-hide-download");
                $download.attr("href", currentGalleryItem.downloadUrl || currentGalleryItem.src);
                if (currentGalleryItem.download) $download.attr("download", currentGalleryItem.download);
            }
        }
    };
    LightGallery.prototype.makeSlideAnimation = function(direction, currentSlideItem, previousSlideItem) {
        var _this = this;
        if (this.lGalleryOn) previousSlideItem.addClass("lg-slide-progress");
        setTimeout(function() {
            // remove all transitions
            _this.outer.addClass("lg-no-trans");
            _this.outer.find(".lg-item").removeClass("lg-prev-slide lg-next-slide");
            if (direction === "prev") {
                //prevslide
                currentSlideItem.addClass("lg-prev-slide");
                previousSlideItem.addClass("lg-next-slide");
            } else {
                // next slide
                currentSlideItem.addClass("lg-next-slide");
                previousSlideItem.addClass("lg-prev-slide");
            }
            // give 50 ms for browser to add/remove class
            setTimeout(function() {
                _this.outer.find(".lg-item").removeClass("lg-current");
                currentSlideItem.addClass("lg-current");
                // reset all transitions
                _this.outer.removeClass("lg-no-trans");
            }, 50);
        }, this.lGalleryOn ? this.settings.slideDelay : 0);
    };
    /**
     * Goto a specific slide.
     * @param {Number} index - index of the slide
     * @param {Boolean} fromTouch - true if slide function called via touch event or mouse drag
     * @param {Boolean} fromThumb - true if slide function called via thumbnail click
     * @param {String} direction - Direction of the slide(next/prev)
     * @category lGPublicMethods
     * @example
     *  const plugin = lightGallery();
     *  // to go to 3rd slide
     *  plugin.slide(2);
     *
     */ LightGallery.prototype.slide = function(index, fromTouch, fromThumb, direction) {
        var _this = this;
        var prevIndex = this.getPreviousSlideIndex();
        this.currentItemsInDom = this.organizeSlideItems(index, prevIndex);
        // Prevent multiple call, Required for hsh plugin
        if (this.lGalleryOn && prevIndex === index) return;
        var numberOfGalleryItems = this.galleryItems.length;
        if (!this.lgBusy) {
            if (this.settings.counter) this.updateCurrentCounter(index);
            var currentSlideItem = this.getSlideItem(index);
            var previousSlideItem_1 = this.getSlideItem(prevIndex);
            var currentGalleryItem = this.galleryItems[index];
            var videoInfo = currentGalleryItem.__slideVideoInfo;
            this.outer.attr("data-lg-slide-type", this.getSlideType(currentGalleryItem));
            this.setDownloadValue(index);
            if (videoInfo) {
                var _a = this.mediaContainerPosition, top_3 = _a.top, bottom = _a.bottom;
                var videoSize = $68e3467541a0efeb$var$utils.getSize(this.items[index], this.outer, top_3 + bottom, videoInfo && this.settings.videoMaxSize);
                this.resizeVideoSlide(index, videoSize);
            }
            this.LGel.trigger($68e3467541a0efeb$var$lGEvents.beforeSlide, {
                prevIndex: prevIndex,
                index: index,
                fromTouch: !!fromTouch,
                fromThumb: !!fromThumb
            });
            this.lgBusy = true;
            clearTimeout(this.hideBarTimeout);
            this.arrowDisable(index);
            if (!direction) {
                if (index < prevIndex) direction = "prev";
                else if (index > prevIndex) direction = "next";
            }
            if (!fromTouch) this.makeSlideAnimation(direction, currentSlideItem, previousSlideItem_1);
            else {
                this.outer.find(".lg-item").removeClass("lg-prev-slide lg-current lg-next-slide");
                var touchPrev = void 0;
                var touchNext = void 0;
                if (numberOfGalleryItems > 2) {
                    touchPrev = index - 1;
                    touchNext = index + 1;
                    if (index === 0 && prevIndex === numberOfGalleryItems - 1) {
                        // next slide
                        touchNext = 0;
                        touchPrev = numberOfGalleryItems - 1;
                    } else if (index === numberOfGalleryItems - 1 && prevIndex === 0) {
                        // prev slide
                        touchNext = 0;
                        touchPrev = numberOfGalleryItems - 1;
                    }
                } else {
                    touchPrev = 0;
                    touchNext = 1;
                }
                if (direction === "prev") this.getSlideItem(touchNext).addClass("lg-next-slide");
                else this.getSlideItem(touchPrev).addClass("lg-prev-slide");
                currentSlideItem.addClass("lg-current");
            }
            // Do not put load content in set timeout as it needs to load immediately when the gallery is opened
            if (!this.lGalleryOn) this.loadContent(index, true);
            else setTimeout(function() {
                _this.loadContent(index, true);
                // Add title if this.settings.appendSubHtmlTo === lg-sub-html
                if (_this.settings.appendSubHtmlTo !== ".lg-item") _this.addHtml(index);
            }, this.settings.speed + 50 + (fromTouch ? 0 : this.settings.slideDelay));
            setTimeout(function() {
                _this.lgBusy = false;
                previousSlideItem_1.removeClass("lg-slide-progress");
                _this.LGel.trigger($68e3467541a0efeb$var$lGEvents.afterSlide, {
                    prevIndex: prevIndex,
                    index: index,
                    fromTouch: fromTouch,
                    fromThumb: fromThumb
                });
            }, (this.lGalleryOn ? this.settings.speed + 100 : 100) + (fromTouch ? 0 : this.settings.slideDelay));
        }
        this.index = index;
    };
    LightGallery.prototype.updateCurrentCounter = function(index) {
        this.getElementById("lg-counter-current").html(index + 1 + "");
    };
    LightGallery.prototype.updateCounterTotal = function() {
        this.getElementById("lg-counter-all").html(this.galleryItems.length + "");
    };
    LightGallery.prototype.getSlideType = function(item) {
        if (item.__slideVideoInfo) return "video";
        else if (item.iframe) return "iframe";
        else return "image";
    };
    LightGallery.prototype.touchMove = function(startCoords, endCoords, e) {
        var distanceX = endCoords.pageX - startCoords.pageX;
        var distanceY = endCoords.pageY - startCoords.pageY;
        var allowSwipe = false;
        if (this.swipeDirection) allowSwipe = true;
        else {
            if (Math.abs(distanceX) > 15) {
                this.swipeDirection = "horizontal";
                allowSwipe = true;
            } else if (Math.abs(distanceY) > 15) {
                this.swipeDirection = "vertical";
                allowSwipe = true;
            }
        }
        if (!allowSwipe) return;
        var $currentSlide = this.getSlideItem(this.index);
        if (this.swipeDirection === "horizontal") {
            e === null || e === void 0 || e.preventDefault();
            // reset opacity and transition duration
            this.outer.addClass("lg-dragging");
            // move current slide
            this.setTranslate($currentSlide, distanceX, 0);
            // move next and prev slide with current slide
            var width = $currentSlide.get().offsetWidth;
            var slideWidthAmount = width * 15 / 100;
            var gutter = slideWidthAmount - Math.abs(distanceX * 10 / 100);
            this.setTranslate(this.outer.find(".lg-prev-slide").first(), -width + distanceX - gutter, 0);
            this.setTranslate(this.outer.find(".lg-next-slide").first(), width + distanceX + gutter, 0);
        } else if (this.swipeDirection === "vertical") {
            if (this.settings.swipeToClose) {
                e === null || e === void 0 || e.preventDefault();
                this.$container.addClass("lg-dragging-vertical");
                var opacity = 1 - Math.abs(distanceY) / window.innerHeight;
                this.$backdrop.css("opacity", opacity);
                var scale = 1 - Math.abs(distanceY) / (window.innerWidth * 2);
                this.setTranslate($currentSlide, 0, distanceY, scale, scale);
                if (Math.abs(distanceY) > 100) this.outer.addClass("lg-hide-items").removeClass("lg-components-open");
            }
        }
    };
    LightGallery.prototype.touchEnd = function(endCoords, startCoords, event) {
        var _this = this;
        var distance;
        // keep slide animation for any mode while dragg/swipe
        if (this.settings.mode !== "lg-slide") this.outer.addClass("lg-slide");
        // set transition duration
        setTimeout(function() {
            _this.$container.removeClass("lg-dragging-vertical");
            _this.outer.removeClass("lg-dragging lg-hide-items").addClass("lg-components-open");
            var triggerClick = true;
            if (_this.swipeDirection === "horizontal") {
                distance = endCoords.pageX - startCoords.pageX;
                var distanceAbs = Math.abs(endCoords.pageX - startCoords.pageX);
                if (distance < 0 && distanceAbs > _this.settings.swipeThreshold) {
                    _this.goToNextSlide(true);
                    triggerClick = false;
                } else if (distance > 0 && distanceAbs > _this.settings.swipeThreshold) {
                    _this.goToPrevSlide(true);
                    triggerClick = false;
                }
            } else if (_this.swipeDirection === "vertical") {
                distance = Math.abs(endCoords.pageY - startCoords.pageY);
                if (_this.settings.closable && _this.settings.swipeToClose && distance > 100) {
                    _this.closeGallery();
                    return;
                } else _this.$backdrop.css("opacity", 1);
            }
            _this.outer.find(".lg-item").removeAttr("style");
            if (triggerClick && Math.abs(endCoords.pageX - startCoords.pageX) < 5) {
                // Trigger click if distance is less than 5 pix
                var target = $68e3467541a0efeb$var$$LG(event.target);
                if (_this.isPosterElement(target)) _this.LGel.trigger($68e3467541a0efeb$var$lGEvents.posterClick);
            }
            _this.swipeDirection = undefined;
        });
        // remove slide class once drag/swipe is completed if mode is not slide
        setTimeout(function() {
            if (!_this.outer.hasClass("lg-dragging") && _this.settings.mode !== "lg-slide") _this.outer.removeClass("lg-slide");
        }, this.settings.speed + 100);
    };
    LightGallery.prototype.enableSwipe = function() {
        var _this = this;
        var startCoords = {};
        var endCoords = {};
        var isMoved = false;
        var isSwiping = false;
        if (this.settings.enableSwipe) {
            this.$inner.on("touchstart.lg", function(e) {
                _this.dragOrSwipeEnabled = true;
                var $item = _this.getSlideItem(_this.index);
                if (($68e3467541a0efeb$var$$LG(e.target).hasClass("lg-item") || $item.get().contains(e.target)) && !_this.outer.hasClass("lg-zoomed") && !_this.lgBusy && e.touches.length === 1) {
                    isSwiping = true;
                    _this.touchAction = "swipe";
                    _this.manageSwipeClass();
                    startCoords = {
                        pageX: e.touches[0].pageX,
                        pageY: e.touches[0].pageY
                    };
                }
            });
            this.$inner.on("touchmove.lg", function(e) {
                if (isSwiping && _this.touchAction === "swipe" && e.touches.length === 1) {
                    endCoords = {
                        pageX: e.touches[0].pageX,
                        pageY: e.touches[0].pageY
                    };
                    _this.touchMove(startCoords, endCoords, e);
                    isMoved = true;
                }
            });
            this.$inner.on("touchend.lg", function(event) {
                if (_this.touchAction === "swipe") {
                    if (isMoved) {
                        isMoved = false;
                        _this.touchEnd(endCoords, startCoords, event);
                    } else if (isSwiping) {
                        var target = $68e3467541a0efeb$var$$LG(event.target);
                        if (_this.isPosterElement(target)) _this.LGel.trigger($68e3467541a0efeb$var$lGEvents.posterClick);
                    }
                    _this.touchAction = undefined;
                    isSwiping = false;
                }
            });
        }
    };
    LightGallery.prototype.enableDrag = function() {
        var _this = this;
        var startCoords = {};
        var endCoords = {};
        var isDraging = false;
        var isMoved = false;
        if (this.settings.enableDrag) {
            this.outer.on("mousedown.lg", function(e) {
                _this.dragOrSwipeEnabled = true;
                var $item = _this.getSlideItem(_this.index);
                if ($68e3467541a0efeb$var$$LG(e.target).hasClass("lg-item") || $item.get().contains(e.target)) {
                    if (!_this.outer.hasClass("lg-zoomed") && !_this.lgBusy) {
                        e.preventDefault();
                        if (!_this.lgBusy) {
                            _this.manageSwipeClass();
                            startCoords = {
                                pageX: e.pageX,
                                pageY: e.pageY
                            };
                            isDraging = true;
                            // ** Fix for webkit cursor issue https://code.google.com/p/chromium/issues/detail?id=26723
                            _this.outer.get().scrollLeft += 1;
                            _this.outer.get().scrollLeft -= 1;
                            // *
                            _this.outer.removeClass("lg-grab").addClass("lg-grabbing");
                            _this.LGel.trigger($68e3467541a0efeb$var$lGEvents.dragStart);
                        }
                    }
                }
            });
            $68e3467541a0efeb$var$$LG(window).on("mousemove.lg.global" + this.lgId, function(e) {
                if (isDraging && _this.lgOpened) {
                    isMoved = true;
                    endCoords = {
                        pageX: e.pageX,
                        pageY: e.pageY
                    };
                    _this.touchMove(startCoords, endCoords);
                    _this.LGel.trigger($68e3467541a0efeb$var$lGEvents.dragMove);
                }
            });
            $68e3467541a0efeb$var$$LG(window).on("mouseup.lg.global" + this.lgId, function(event) {
                if (!_this.lgOpened) return;
                var target = $68e3467541a0efeb$var$$LG(event.target);
                if (isMoved) {
                    isMoved = false;
                    _this.touchEnd(endCoords, startCoords, event);
                    _this.LGel.trigger($68e3467541a0efeb$var$lGEvents.dragEnd);
                } else if (_this.isPosterElement(target)) _this.LGel.trigger($68e3467541a0efeb$var$lGEvents.posterClick);
                // Prevent execution on click
                if (isDraging) {
                    isDraging = false;
                    _this.outer.removeClass("lg-grabbing").addClass("lg-grab");
                }
            });
        }
    };
    LightGallery.prototype.triggerPosterClick = function() {
        var _this = this;
        this.$inner.on("click.lg", function(event) {
            if (!_this.dragOrSwipeEnabled && _this.isPosterElement($68e3467541a0efeb$var$$LG(event.target))) _this.LGel.trigger($68e3467541a0efeb$var$lGEvents.posterClick);
        });
    };
    LightGallery.prototype.manageSwipeClass = function() {
        var _touchNext = this.index + 1;
        var _touchPrev = this.index - 1;
        if (this.settings.loop && this.galleryItems.length > 2) {
            if (this.index === 0) _touchPrev = this.galleryItems.length - 1;
            else if (this.index === this.galleryItems.length - 1) _touchNext = 0;
        }
        this.outer.find(".lg-item").removeClass("lg-next-slide lg-prev-slide");
        if (_touchPrev > -1) this.getSlideItem(_touchPrev).addClass("lg-prev-slide");
        this.getSlideItem(_touchNext).addClass("lg-next-slide");
    };
    /**
     * Go to next slide
     * @param {Boolean} fromTouch - true if slide function called via touch event
     * @category lGPublicMethods
     * @example
     *  const plugin = lightGallery();
     *  plugin.goToNextSlide();
     * @see <a href="/demos/methods/">Demo</a>
     */ LightGallery.prototype.goToNextSlide = function(fromTouch) {
        var _this = this;
        var _loop = this.settings.loop;
        if (fromTouch && this.galleryItems.length < 3) _loop = false;
        if (!this.lgBusy) {
            if (this.index + 1 < this.galleryItems.length) {
                this.index++;
                this.LGel.trigger($68e3467541a0efeb$var$lGEvents.beforeNextSlide, {
                    index: this.index
                });
                this.slide(this.index, !!fromTouch, false, "next");
            } else {
                if (_loop) {
                    this.index = 0;
                    this.LGel.trigger($68e3467541a0efeb$var$lGEvents.beforeNextSlide, {
                        index: this.index
                    });
                    this.slide(this.index, !!fromTouch, false, "next");
                } else if (this.settings.slideEndAnimation && !fromTouch) {
                    this.outer.addClass("lg-right-end");
                    setTimeout(function() {
                        _this.outer.removeClass("lg-right-end");
                    }, 400);
                }
            }
        }
    };
    /**
     * Go to previous slides
     * @param {Boolean} fromTouch - true if slide function called via touch event
     * @category lGPublicMethods
     * @example
     *  const plugin = lightGallery({});
     *  plugin.goToPrevSlide();
     * @see <a href="/demos/methods/">Demo</a>
     *
     */ LightGallery.prototype.goToPrevSlide = function(fromTouch) {
        var _this = this;
        var _loop = this.settings.loop;
        if (fromTouch && this.galleryItems.length < 3) _loop = false;
        if (!this.lgBusy) {
            if (this.index > 0) {
                this.index--;
                this.LGel.trigger($68e3467541a0efeb$var$lGEvents.beforePrevSlide, {
                    index: this.index,
                    fromTouch: fromTouch
                });
                this.slide(this.index, !!fromTouch, false, "prev");
            } else {
                if (_loop) {
                    this.index = this.galleryItems.length - 1;
                    this.LGel.trigger($68e3467541a0efeb$var$lGEvents.beforePrevSlide, {
                        index: this.index,
                        fromTouch: fromTouch
                    });
                    this.slide(this.index, !!fromTouch, false, "prev");
                } else if (this.settings.slideEndAnimation && !fromTouch) {
                    this.outer.addClass("lg-left-end");
                    setTimeout(function() {
                        _this.outer.removeClass("lg-left-end");
                    }, 400);
                }
            }
        }
    };
    LightGallery.prototype.keyPress = function() {
        var _this = this;
        $68e3467541a0efeb$var$$LG(window).on("keydown.lg.global" + this.lgId, function(e) {
            if (_this.lgOpened && _this.settings.escKey === true && e.keyCode === 27) {
                e.preventDefault();
                if (_this.settings.allowMediaOverlap && _this.outer.hasClass("lg-can-toggle") && _this.outer.hasClass("lg-components-open")) _this.outer.removeClass("lg-components-open");
                else _this.closeGallery();
            }
            if (_this.lgOpened && _this.galleryItems.length > 1) {
                if (e.keyCode === 37) {
                    e.preventDefault();
                    _this.goToPrevSlide();
                }
                if (e.keyCode === 39) {
                    e.preventDefault();
                    _this.goToNextSlide();
                }
            }
        });
    };
    LightGallery.prototype.arrow = function() {
        var _this = this;
        this.getElementById("lg-prev").on("click.lg", function() {
            _this.goToPrevSlide();
        });
        this.getElementById("lg-next").on("click.lg", function() {
            _this.goToNextSlide();
        });
    };
    LightGallery.prototype.arrowDisable = function(index) {
        // Disable arrows if settings.hideControlOnEnd is true
        if (!this.settings.loop && this.settings.hideControlOnEnd) {
            var $prev = this.getElementById("lg-prev");
            var $next = this.getElementById("lg-next");
            if (index + 1 === this.galleryItems.length) $next.attr("disabled", "disabled").addClass("disabled");
            else $next.removeAttr("disabled").removeClass("disabled");
            if (index === 0) $prev.attr("disabled", "disabled").addClass("disabled");
            else $prev.removeAttr("disabled").removeClass("disabled");
        }
    };
    LightGallery.prototype.setTranslate = function($el, xValue, yValue, scaleX, scaleY) {
        if (scaleX === void 0) scaleX = 1;
        if (scaleY === void 0) scaleY = 1;
        $el.css("transform", "translate3d(" + xValue + "px, " + yValue + "px, 0px) scale3d(" + scaleX + ", " + scaleY + ", 1)");
    };
    LightGallery.prototype.mousewheel = function() {
        var _this = this;
        var lastCall = 0;
        this.outer.on("wheel.lg", function(e) {
            if (!e.deltaY || _this.galleryItems.length < 2) return;
            e.preventDefault();
            var now = new Date().getTime();
            if (now - lastCall < 1000) return;
            lastCall = now;
            if (e.deltaY > 0) _this.goToNextSlide();
            else if (e.deltaY < 0) _this.goToPrevSlide();
        });
    };
    LightGallery.prototype.isSlideElement = function(target) {
        return target.hasClass("lg-outer") || target.hasClass("lg-item") || target.hasClass("lg-img-wrap");
    };
    LightGallery.prototype.isPosterElement = function(target) {
        var playButton = this.getSlideItem(this.index).find(".lg-video-play-button").get();
        return target.hasClass("lg-video-poster") || target.hasClass("lg-video-play-button") || playButton && playButton.contains(target.get());
    };
    /**
     * Maximize minimize inline gallery.
     * @category lGPublicMethods
     */ LightGallery.prototype.toggleMaximize = function() {
        var _this = this;
        this.getElementById("lg-maximize").on("click.lg", function() {
            _this.$container.toggleClass("lg-inline");
            _this.refreshOnResize();
        });
    };
    LightGallery.prototype.invalidateItems = function() {
        for(var index = 0; index < this.items.length; index++){
            var element = this.items[index];
            var $element = $68e3467541a0efeb$var$$LG(element);
            $element.off("click.lgcustom-item-" + $element.attr("data-lg-id"));
        }
    };
    LightGallery.prototype.trapFocus = function() {
        var _this = this;
        this.$container.get().focus({
            preventScroll: true
        });
        $68e3467541a0efeb$var$$LG(window).on("keydown.lg.global" + this.lgId, function(e) {
            if (!_this.lgOpened) return;
            var isTabPressed = e.key === "Tab" || e.keyCode === 9;
            if (!isTabPressed) return;
            var focusableEls = $68e3467541a0efeb$var$utils.getFocusableElements(_this.$container.get());
            var firstFocusableEl = focusableEls[0];
            var lastFocusableEl = focusableEls[focusableEls.length - 1];
            if (e.shiftKey) {
                if (document.activeElement === firstFocusableEl) {
                    lastFocusableEl.focus();
                    e.preventDefault();
                }
            } else if (document.activeElement === lastFocusableEl) {
                firstFocusableEl.focus();
                e.preventDefault();
            }
        });
    };
    LightGallery.prototype.manageCloseGallery = function() {
        var _this = this;
        if (!this.settings.closable) return;
        var mousedown = false;
        this.getElementById("lg-close").on("click.lg", function() {
            _this.closeGallery();
        });
        if (this.settings.closeOnTap) {
            // If you drag the slide and release outside gallery gets close on chrome
            // for preventing this check mousedown and mouseup happened on .lg-item or lg-outer
            this.outer.on("mousedown.lg", function(e) {
                var target = $68e3467541a0efeb$var$$LG(e.target);
                if (_this.isSlideElement(target)) mousedown = true;
                else mousedown = false;
            });
            this.outer.on("mousemove.lg", function() {
                mousedown = false;
            });
            this.outer.on("mouseup.lg", function(e) {
                var target = $68e3467541a0efeb$var$$LG(e.target);
                if (_this.isSlideElement(target) && mousedown) {
                    if (!_this.outer.hasClass("lg-dragging")) _this.closeGallery();
                }
            });
        }
    };
    /**
     * Close lightGallery if it is opened.
     *
     * @description If closable is false in the settings, you need to pass true via closeGallery method to force close gallery
     * @return returns the estimated time to close gallery completely including the close animation duration
     * @category lGPublicMethods
     * @example
     *  const plugin = lightGallery();
     *  plugin.closeGallery();
     *
     */ LightGallery.prototype.closeGallery = function(force) {
        var _this = this;
        if (!this.lgOpened || !this.settings.closable && !force) return 0;
        this.LGel.trigger($68e3467541a0efeb$var$lGEvents.beforeClose);
        if (this.settings.resetScrollPosition && !this.settings.hideScrollbar) $68e3467541a0efeb$var$$LG(window).scrollTop(this.prevScrollTop);
        var currentItem = this.items[this.index];
        var transform;
        if (this.zoomFromOrigin && currentItem) {
            var _a = this.mediaContainerPosition, top_4 = _a.top, bottom = _a.bottom;
            var _b = this.galleryItems[this.index], __slideVideoInfo = _b.__slideVideoInfo, poster = _b.poster;
            var imageSize = $68e3467541a0efeb$var$utils.getSize(currentItem, this.outer, top_4 + bottom, __slideVideoInfo && poster && this.settings.videoMaxSize);
            transform = $68e3467541a0efeb$var$utils.getTransform(currentItem, this.outer, top_4, bottom, imageSize);
        }
        if (this.zoomFromOrigin && transform) {
            this.outer.addClass("lg-closing lg-zoom-from-image");
            this.getSlideItem(this.index).addClass("lg-start-end-progress").css("transition-duration", this.settings.startAnimationDuration + "ms").css("transform", transform);
        } else {
            this.outer.addClass("lg-hide-items");
            // lg-zoom-from-image is used for setting the opacity to 1 if zoomFromOrigin is true
            // If the closing item doesn't have the lg-size attribute, remove this class to avoid the closing css conflicts
            this.outer.removeClass("lg-zoom-from-image");
        }
        // Unbind all events added by lightGallery
        // @todo
        //this.$el.off('.lg.tm');
        this.destroyModules();
        this.lGalleryOn = false;
        this.isDummyImageRemoved = false;
        this.zoomFromOrigin = this.settings.zoomFromOrigin;
        clearTimeout(this.hideBarTimeout);
        this.hideBarTimeout = false;
        $68e3467541a0efeb$var$$LG("html").removeClass("lg-on");
        this.outer.removeClass("lg-visible lg-components-open");
        // Resetting opacity to 0 isd required as  vertical swipe to close function adds inline opacity.
        this.$backdrop.removeClass("in").css("opacity", 0);
        var removeTimeout = this.zoomFromOrigin && transform ? Math.max(this.settings.startAnimationDuration, this.settings.backdropDuration) : this.settings.backdropDuration;
        this.$container.removeClass("lg-show-in");
        // Once the closign animation is completed and gallery is invisible
        setTimeout(function() {
            if (_this.zoomFromOrigin && transform) _this.outer.removeClass("lg-zoom-from-image");
            _this.$container.removeClass("lg-show");
            // Reset scrollbar
            _this.resetScrollBar();
            // Need to remove inline opacity as it is used in the stylesheet as well
            _this.$backdrop.removeAttr("style").css("transition-duration", _this.settings.backdropDuration + "ms");
            _this.outer.removeClass("lg-closing " + _this.settings.startClass);
            _this.getSlideItem(_this.index).removeClass("lg-start-end-progress");
            _this.$inner.empty();
            if (_this.lgOpened) _this.LGel.trigger($68e3467541a0efeb$var$lGEvents.afterClose, {
                instance: _this
            });
            if (_this.$container.get()) _this.$container.get().blur();
            _this.lgOpened = false;
        }, removeTimeout + 100);
        return removeTimeout + 100;
    };
    LightGallery.prototype.initModules = function() {
        this.plugins.forEach(function(module) {
            try {
                module.init();
            } catch (err) {
                console.warn("lightGallery:- make sure lightGallery module is properly initiated");
            }
        });
    };
    LightGallery.prototype.destroyModules = function(destroy) {
        this.plugins.forEach(function(module) {
            try {
                if (destroy) module.destroy();
                else module.closeGallery && module.closeGallery();
            } catch (err) {
                console.warn("lightGallery:- make sure lightGallery module is properly destroyed");
            }
        });
    };
    /**
     * Refresh lightGallery with new set of children.
     *
     * @description This is useful to update the gallery when the child elements are changed without calling destroy method.
     *
     * If you are using dynamic mode, you can pass the modified array of dynamicEl as the first parameter to refresh the dynamic gallery
     * @see <a href="/demos/dynamic-mode/">Demo</a>
     * @category lGPublicMethods
     * @example
     *  const plugin = lightGallery();
     *  // Delete or add children, then call
     *  plugin.refresh();
     *
     */ LightGallery.prototype.refresh = function(galleryItems) {
        if (!this.settings.dynamic) this.invalidateItems();
        if (galleryItems) this.galleryItems = galleryItems;
        else this.galleryItems = this.getItems();
        this.updateControls();
        this.openGalleryOnItemClick();
        this.LGel.trigger($68e3467541a0efeb$var$lGEvents.updateSlides);
    };
    LightGallery.prototype.updateControls = function() {
        this.addSlideVideoInfo(this.galleryItems);
        this.updateCounterTotal();
        this.manageSingleSlideClassName();
    };
    LightGallery.prototype.destroyGallery = function() {
        this.destroyModules(true);
        if (!this.settings.dynamic) this.invalidateItems();
        $68e3467541a0efeb$var$$LG(window).off(".lg.global" + this.lgId);
        this.LGel.off(".lg");
        this.$container.remove();
    };
    /**
     * Destroy lightGallery.
     * Destroy lightGallery and its plugin instances completely
     *
     * @description This method also calls CloseGallery function internally. Returns the time takes to completely close and destroy the instance.
     * In case if you want to re-initialize lightGallery right after destroying it, initialize it only once the destroy process is completed.
     * You can use refresh method most of the times.
     * @category lGPublicMethods
     * @example
     *  const plugin = lightGallery();
     *  plugin.destroy();
     *
     */ LightGallery.prototype.destroy = function() {
        var closeTimeout = this.closeGallery(true);
        if (closeTimeout) setTimeout(this.destroyGallery.bind(this), closeTimeout);
        else this.destroyGallery();
        return closeTimeout;
    };
    return LightGallery;
}();
function $68e3467541a0efeb$var$lightGallery(el, options) {
    return new $68e3467541a0efeb$var$LightGallery(el, options);
}
var $68e3467541a0efeb$export$2e2bcd8739ae039 = $68e3467541a0efeb$var$lightGallery;


/*!
 * lightgallery | 2.7.2 | September 20th 2023
 * http://www.lightgalleryjs.com/
 * Copyright (c) 2020 Sachin Neravath;
 * @license GPLv3
 */ /*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $161cbdbc36aa5086$var$__assign = function() {
    $161cbdbc36aa5086$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $161cbdbc36aa5086$var$__assign.apply(this, arguments);
};
/**
 * List of lightGallery events
 * All events should be documented here
 * Below interfaces are used to build the website documentations
 * */ var $161cbdbc36aa5086$var$lGEvents = {
    afterAppendSlide: "lgAfterAppendSlide",
    init: "lgInit",
    hasVideo: "lgHasVideo",
    containerResize: "lgContainerResize",
    updateSlides: "lgUpdateSlides",
    afterAppendSubHtml: "lgAfterAppendSubHtml",
    beforeOpen: "lgBeforeOpen",
    afterOpen: "lgAfterOpen",
    slideItemLoad: "lgSlideItemLoad",
    beforeSlide: "lgBeforeSlide",
    afterSlide: "lgAfterSlide",
    posterClick: "lgPosterClick",
    dragStart: "lgDragStart",
    dragMove: "lgDragMove",
    dragEnd: "lgDragEnd",
    beforeNextSlide: "lgBeforeNextSlide",
    beforePrevSlide: "lgBeforePrevSlide",
    beforeClose: "lgBeforeClose",
    afterClose: "lgAfterClose",
    rotateLeft: "lgRotateLeft",
    rotateRight: "lgRotateRight",
    flipHorizontal: "lgFlipHorizontal",
    flipVertical: "lgFlipVertical",
    autoplay: "lgAutoplay",
    autoplayStart: "lgAutoplayStart",
    autoplayStop: "lgAutoplayStop"
};
var $161cbdbc36aa5086$var$hashSettings = {
    hash: true,
    galleryId: "1",
    customSlideName: false
};
var $161cbdbc36aa5086$var$Hash = /** @class */ function() {
    function Hash(instance, $LG) {
        // get lightGallery core plugin instance
        this.core = instance;
        this.$LG = $LG;
        // extend module default settings with lightGallery core settings
        this.settings = $161cbdbc36aa5086$var$__assign($161cbdbc36aa5086$var$__assign({}, $161cbdbc36aa5086$var$hashSettings), this.core.settings);
        return this;
    }
    Hash.prototype.init = function() {
        var _this = this;
        if (!this.settings.hash) return;
        this.oldHash = window.location.hash;
        setTimeout(function() {
            _this.buildFromHash();
        }, 100);
        // Change hash value on after each slide transition
        this.core.LGel.on($161cbdbc36aa5086$var$lGEvents.afterSlide + ".hash", this.onAfterSlide.bind(this));
        this.core.LGel.on($161cbdbc36aa5086$var$lGEvents.afterClose + ".hash", this.onCloseAfter.bind(this));
        // Listen hash change and change the slide according to slide value
        this.$LG(window).on("hashchange.lg.hash.global" + this.core.lgId, this.onHashchange.bind(this));
    };
    Hash.prototype.onAfterSlide = function(event) {
        var slideName = this.core.galleryItems[event.detail.index].slideName;
        slideName = this.settings.customSlideName ? slideName || event.detail.index : event.detail.index;
        if (history.replaceState) history.replaceState(null, "", window.location.pathname + window.location.search + "#lg=" + this.settings.galleryId + "&slide=" + slideName);
        else window.location.hash = "lg=" + this.settings.galleryId + "&slide=" + slideName;
    };
    /**
     * Get index of the slide from custom slideName. Has to be a public method. Used in hash plugin
     * @param {String} hash
     * @returns {Number} Index of the slide.
     */ Hash.prototype.getIndexFromUrl = function(hash) {
        if (hash === void 0) hash = window.location.hash;
        var slideName = hash.split("&slide=")[1];
        var _idx = 0;
        if (this.settings.customSlideName) for(var index = 0; index < this.core.galleryItems.length; index++){
            var dynamicEl = this.core.galleryItems[index];
            if (dynamicEl.slideName === slideName) {
                _idx = index;
                break;
            }
        }
        else _idx = parseInt(slideName, 10);
        return isNaN(_idx) ? 0 : _idx;
    };
    // Build Gallery if gallery id exist in the URL
    Hash.prototype.buildFromHash = function() {
        // if dynamic option is enabled execute immediately
        var _hash = window.location.hash;
        if (_hash.indexOf("lg=" + this.settings.galleryId) > 0) {
            // This class is used to remove the initial animation if galleryId present in the URL
            this.$LG(document.body).addClass("lg-from-hash");
            var index = this.getIndexFromUrl(_hash);
            this.core.openGallery(index);
            return true;
        }
    };
    Hash.prototype.onCloseAfter = function() {
        // Reset to old hash value
        if (this.oldHash && this.oldHash.indexOf("lg=" + this.settings.galleryId) < 0) {
            if (history.replaceState) history.replaceState(null, "", this.oldHash);
            else window.location.hash = this.oldHash;
        } else if (history.replaceState) history.replaceState(null, document.title, window.location.pathname + window.location.search);
        else window.location.hash = "";
    };
    Hash.prototype.onHashchange = function() {
        if (!this.core.lgOpened) return;
        var _hash = window.location.hash;
        var index = this.getIndexFromUrl(_hash);
        // it galleryId doesn't exist in the url close the gallery
        if (_hash.indexOf("lg=" + this.settings.galleryId) > -1) this.core.slide(index, false, false);
        else if (this.core.lGalleryOn) this.core.closeGallery();
    };
    Hash.prototype.closeGallery = function() {
        if (this.settings.hash) this.$LG(document.body).removeClass("lg-from-hash");
    };
    Hash.prototype.destroy = function() {
        this.core.LGel.off(".lg.hash");
        this.core.LGel.off(".hash");
        this.$LG(window).off("hashchange.lg.hash.global" + this.core.lgId);
    };
    return Hash;
}();
var $161cbdbc36aa5086$export$2e2bcd8739ae039 = $161cbdbc36aa5086$var$Hash;


/*!
 * lightgallery | 2.7.2 | September 20th 2023
 * http://www.lightgalleryjs.com/
 * Copyright (c) 2020 Sachin Neravath;
 * @license GPLv3
 */ /*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $5d9aacf729fe2d6f$var$__assign = function() {
    $5d9aacf729fe2d6f$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5d9aacf729fe2d6f$var$__assign.apply(this, arguments);
};
var $5d9aacf729fe2d6f$var$thumbnailsSettings = {
    thumbnail: true,
    animateThumb: true,
    currentPagerPosition: "middle",
    alignThumbnails: "middle",
    thumbWidth: 100,
    thumbHeight: "80px",
    thumbMargin: 5,
    appendThumbnailsTo: ".lg-components",
    toggleThumb: false,
    enableThumbDrag: true,
    enableThumbSwipe: true,
    thumbnailSwipeThreshold: 10,
    loadYouTubeThumbnail: true,
    youTubeThumbSize: 1,
    thumbnailPluginStrings: {
        toggleThumbnails: "Toggle thumbnails"
    }
};
/**
 * List of lightGallery events
 * All events should be documented here
 * Below interfaces are used to build the website documentations
 * */ var $5d9aacf729fe2d6f$var$lGEvents = {
    afterAppendSlide: "lgAfterAppendSlide",
    init: "lgInit",
    hasVideo: "lgHasVideo",
    containerResize: "lgContainerResize",
    updateSlides: "lgUpdateSlides",
    afterAppendSubHtml: "lgAfterAppendSubHtml",
    beforeOpen: "lgBeforeOpen",
    afterOpen: "lgAfterOpen",
    slideItemLoad: "lgSlideItemLoad",
    beforeSlide: "lgBeforeSlide",
    afterSlide: "lgAfterSlide",
    posterClick: "lgPosterClick",
    dragStart: "lgDragStart",
    dragMove: "lgDragMove",
    dragEnd: "lgDragEnd",
    beforeNextSlide: "lgBeforeNextSlide",
    beforePrevSlide: "lgBeforePrevSlide",
    beforeClose: "lgBeforeClose",
    afterClose: "lgAfterClose",
    rotateLeft: "lgRotateLeft",
    rotateRight: "lgRotateRight",
    flipHorizontal: "lgFlipHorizontal",
    flipVertical: "lgFlipVertical",
    autoplay: "lgAutoplay",
    autoplayStart: "lgAutoplayStart",
    autoplayStop: "lgAutoplayStop"
};
var $5d9aacf729fe2d6f$var$Thumbnail = /** @class */ function() {
    function Thumbnail(instance, $LG) {
        this.thumbOuterWidth = 0;
        this.thumbTotalWidth = 0;
        this.translateX = 0;
        this.thumbClickable = false;
        // get lightGallery core plugin instance
        this.core = instance;
        this.$LG = $LG;
        return this;
    }
    Thumbnail.prototype.init = function() {
        // extend module default settings with lightGallery core settings
        this.settings = $5d9aacf729fe2d6f$var$__assign($5d9aacf729fe2d6f$var$__assign({}, $5d9aacf729fe2d6f$var$thumbnailsSettings), this.core.settings);
        this.thumbOuterWidth = 0;
        this.thumbTotalWidth = this.core.galleryItems.length * (this.settings.thumbWidth + this.settings.thumbMargin);
        // Thumbnail animation value
        this.translateX = 0;
        this.setAnimateThumbStyles();
        if (!this.core.settings.allowMediaOverlap) this.settings.toggleThumb = false;
        if (this.settings.thumbnail) {
            this.build();
            if (this.settings.animateThumb) {
                if (this.settings.enableThumbDrag) this.enableThumbDrag();
                if (this.settings.enableThumbSwipe) this.enableThumbSwipe();
                this.thumbClickable = false;
            } else this.thumbClickable = true;
            this.toggleThumbBar();
            this.thumbKeyPress();
        }
    };
    Thumbnail.prototype.build = function() {
        var _this = this;
        this.setThumbMarkup();
        this.manageActiveClassOnSlideChange();
        this.$lgThumb.first().on("click.lg touchend.lg", function(e) {
            var $target = _this.$LG(e.target);
            if (!$target.hasAttribute("data-lg-item-id")) return;
            setTimeout(function() {
                // In IE9 and bellow touch does not support
                // Go to slide if browser does not support css transitions
                if (_this.thumbClickable && !_this.core.lgBusy) {
                    var index = parseInt($target.attr("data-lg-item-id"));
                    _this.core.slide(index, false, true, false);
                }
            }, 50);
        });
        this.core.LGel.on($5d9aacf729fe2d6f$var$lGEvents.beforeSlide + ".thumb", function(event) {
            var index = event.detail.index;
            _this.animateThumb(index);
        });
        this.core.LGel.on($5d9aacf729fe2d6f$var$lGEvents.beforeOpen + ".thumb", function() {
            _this.thumbOuterWidth = _this.core.outer.get().offsetWidth;
        });
        this.core.LGel.on($5d9aacf729fe2d6f$var$lGEvents.updateSlides + ".thumb", function() {
            _this.rebuildThumbnails();
        });
        this.core.LGel.on($5d9aacf729fe2d6f$var$lGEvents.containerResize + ".thumb", function() {
            if (!_this.core.lgOpened) return;
            setTimeout(function() {
                _this.thumbOuterWidth = _this.core.outer.get().offsetWidth;
                _this.animateThumb(_this.core.index);
                _this.thumbOuterWidth = _this.core.outer.get().offsetWidth;
            }, 50);
        });
    };
    Thumbnail.prototype.setThumbMarkup = function() {
        var thumbOuterClassNames = "lg-thumb-outer ";
        if (this.settings.alignThumbnails) thumbOuterClassNames += "lg-thumb-align-" + this.settings.alignThumbnails;
        var html = '<div class="' + thumbOuterClassNames + '">\n        <div class="lg-thumb lg-group">\n        </div>\n        </div>';
        this.core.outer.addClass("lg-has-thumb");
        if (this.settings.appendThumbnailsTo === ".lg-components") this.core.$lgComponents.append(html);
        else this.core.outer.append(html);
        this.$thumbOuter = this.core.outer.find(".lg-thumb-outer").first();
        this.$lgThumb = this.core.outer.find(".lg-thumb").first();
        if (this.settings.animateThumb) this.core.outer.find(".lg-thumb").css("transition-duration", this.core.settings.speed + "ms").css("width", this.thumbTotalWidth + "px").css("position", "relative");
        this.setThumbItemHtml(this.core.galleryItems);
    };
    Thumbnail.prototype.enableThumbDrag = function() {
        var _this = this;
        var thumbDragUtils = {
            cords: {
                startX: 0,
                endX: 0
            },
            isMoved: false,
            newTranslateX: 0,
            startTime: new Date(),
            endTime: new Date(),
            touchMoveTime: 0
        };
        var isDragging = false;
        this.$thumbOuter.addClass("lg-grab");
        this.core.outer.find(".lg-thumb").first().on("mousedown.lg.thumb", function(e) {
            if (_this.thumbTotalWidth > _this.thumbOuterWidth) {
                // execute only on .lg-object
                e.preventDefault();
                thumbDragUtils.cords.startX = e.pageX;
                thumbDragUtils.startTime = new Date();
                _this.thumbClickable = false;
                isDragging = true;
                // ** Fix for webkit cursor issue https://code.google.com/p/chromium/issues/detail?id=26723
                _this.core.outer.get().scrollLeft += 1;
                _this.core.outer.get().scrollLeft -= 1;
                // *
                _this.$thumbOuter.removeClass("lg-grab").addClass("lg-grabbing");
            }
        });
        this.$LG(window).on("mousemove.lg.thumb.global" + this.core.lgId, function(e) {
            if (!_this.core.lgOpened) return;
            if (isDragging) {
                thumbDragUtils.cords.endX = e.pageX;
                thumbDragUtils = _this.onThumbTouchMove(thumbDragUtils);
            }
        });
        this.$LG(window).on("mouseup.lg.thumb.global" + this.core.lgId, function() {
            if (!_this.core.lgOpened) return;
            if (thumbDragUtils.isMoved) thumbDragUtils = _this.onThumbTouchEnd(thumbDragUtils);
            else _this.thumbClickable = true;
            if (isDragging) {
                isDragging = false;
                _this.$thumbOuter.removeClass("lg-grabbing").addClass("lg-grab");
            }
        });
    };
    Thumbnail.prototype.enableThumbSwipe = function() {
        var _this = this;
        var thumbDragUtils = {
            cords: {
                startX: 0,
                endX: 0
            },
            isMoved: false,
            newTranslateX: 0,
            startTime: new Date(),
            endTime: new Date(),
            touchMoveTime: 0
        };
        this.$lgThumb.on("touchstart.lg", function(e) {
            if (_this.thumbTotalWidth > _this.thumbOuterWidth) {
                e.preventDefault();
                thumbDragUtils.cords.startX = e.targetTouches[0].pageX;
                _this.thumbClickable = false;
                thumbDragUtils.startTime = new Date();
            }
        });
        this.$lgThumb.on("touchmove.lg", function(e) {
            if (_this.thumbTotalWidth > _this.thumbOuterWidth) {
                e.preventDefault();
                thumbDragUtils.cords.endX = e.targetTouches[0].pageX;
                thumbDragUtils = _this.onThumbTouchMove(thumbDragUtils);
            }
        });
        this.$lgThumb.on("touchend.lg", function() {
            if (thumbDragUtils.isMoved) thumbDragUtils = _this.onThumbTouchEnd(thumbDragUtils);
            else _this.thumbClickable = true;
        });
    };
    // Rebuild thumbnails
    Thumbnail.prototype.rebuildThumbnails = function() {
        var _this = this;
        // Remove transitions
        this.$thumbOuter.addClass("lg-rebuilding-thumbnails");
        setTimeout(function() {
            _this.thumbTotalWidth = _this.core.galleryItems.length * (_this.settings.thumbWidth + _this.settings.thumbMargin);
            _this.$lgThumb.css("width", _this.thumbTotalWidth + "px");
            _this.$lgThumb.empty();
            _this.setThumbItemHtml(_this.core.galleryItems);
            _this.animateThumb(_this.core.index);
        }, 50);
        setTimeout(function() {
            _this.$thumbOuter.removeClass("lg-rebuilding-thumbnails");
        }, 200);
    };
    // @ts-check
    Thumbnail.prototype.setTranslate = function(value) {
        this.$lgThumb.css("transform", "translate3d(-" + value + "px, 0px, 0px)");
    };
    Thumbnail.prototype.getPossibleTransformX = function(left) {
        if (left > this.thumbTotalWidth - this.thumbOuterWidth) left = this.thumbTotalWidth - this.thumbOuterWidth;
        if (left < 0) left = 0;
        return left;
    };
    Thumbnail.prototype.animateThumb = function(index) {
        this.$lgThumb.css("transition-duration", this.core.settings.speed + "ms");
        if (this.settings.animateThumb) {
            var position = 0;
            switch(this.settings.currentPagerPosition){
                case "left":
                    position = 0;
                    break;
                case "middle":
                    position = this.thumbOuterWidth / 2 - this.settings.thumbWidth / 2;
                    break;
                case "right":
                    position = this.thumbOuterWidth - this.settings.thumbWidth;
            }
            this.translateX = (this.settings.thumbWidth + this.settings.thumbMargin) * index - 1 - position;
            if (this.translateX > this.thumbTotalWidth - this.thumbOuterWidth) this.translateX = this.thumbTotalWidth - this.thumbOuterWidth;
            if (this.translateX < 0) this.translateX = 0;
            this.setTranslate(this.translateX);
        }
    };
    Thumbnail.prototype.onThumbTouchMove = function(thumbDragUtils) {
        thumbDragUtils.newTranslateX = this.translateX;
        thumbDragUtils.isMoved = true;
        thumbDragUtils.touchMoveTime = new Date().valueOf();
        thumbDragUtils.newTranslateX -= thumbDragUtils.cords.endX - thumbDragUtils.cords.startX;
        thumbDragUtils.newTranslateX = this.getPossibleTransformX(thumbDragUtils.newTranslateX);
        // move current slide
        this.setTranslate(thumbDragUtils.newTranslateX);
        this.$thumbOuter.addClass("lg-dragging");
        return thumbDragUtils;
    };
    Thumbnail.prototype.onThumbTouchEnd = function(thumbDragUtils) {
        thumbDragUtils.isMoved = false;
        thumbDragUtils.endTime = new Date();
        this.$thumbOuter.removeClass("lg-dragging");
        var touchDuration = thumbDragUtils.endTime.valueOf() - thumbDragUtils.startTime.valueOf();
        var distanceXnew = thumbDragUtils.cords.endX - thumbDragUtils.cords.startX;
        var speedX = Math.abs(distanceXnew) / touchDuration;
        // Some magical numbers
        // Can be improved
        if (speedX > 0.15 && thumbDragUtils.endTime.valueOf() - thumbDragUtils.touchMoveTime < 30) {
            speedX += 1;
            if (speedX > 2) speedX += 1;
            speedX = speedX + speedX * (Math.abs(distanceXnew) / this.thumbOuterWidth);
            this.$lgThumb.css("transition-duration", Math.min(speedX - 1, 2) + "settings");
            distanceXnew = distanceXnew * speedX;
            this.translateX = this.getPossibleTransformX(this.translateX - distanceXnew);
            this.setTranslate(this.translateX);
        } else this.translateX = thumbDragUtils.newTranslateX;
        if (Math.abs(thumbDragUtils.cords.endX - thumbDragUtils.cords.startX) < this.settings.thumbnailSwipeThreshold) this.thumbClickable = true;
        return thumbDragUtils;
    };
    Thumbnail.prototype.getThumbHtml = function(thumb, index, alt) {
        var slideVideoInfo = this.core.galleryItems[index].__slideVideoInfo || {};
        var thumbImg;
        if (slideVideoInfo.youtube) {
            if (this.settings.loadYouTubeThumbnail) thumbImg = "//img.youtube.com/vi/" + slideVideoInfo.youtube[1] + "/" + this.settings.youTubeThumbSize + ".jpg";
            else thumbImg = thumb;
        } else thumbImg = thumb;
        var altAttr = alt ? 'alt="' + alt + '"' : "";
        return '<div data-lg-item-id="' + index + '" class="lg-thumb-item ' + (index === this.core.index ? " active" : "") + '"\n        style="width:' + this.settings.thumbWidth + "px; height: " + this.settings.thumbHeight + ";\n            margin-right: " + this.settings.thumbMargin + 'px;">\n            <img ' + altAttr + ' data-lg-item-id="' + index + '" src="' + thumbImg + '" />\n        </div>';
    };
    Thumbnail.prototype.getThumbItemHtml = function(items) {
        var thumbList = "";
        for(var i = 0; i < items.length; i++)thumbList += this.getThumbHtml(items[i].thumb, i, items[i].alt);
        return thumbList;
    };
    Thumbnail.prototype.setThumbItemHtml = function(items) {
        var thumbList = this.getThumbItemHtml(items);
        this.$lgThumb.html(thumbList);
    };
    Thumbnail.prototype.setAnimateThumbStyles = function() {
        if (this.settings.animateThumb) this.core.outer.addClass("lg-animate-thumb");
    };
    // Manage thumbnail active calss
    Thumbnail.prototype.manageActiveClassOnSlideChange = function() {
        var _this = this;
        // manage active class for thumbnail
        this.core.LGel.on($5d9aacf729fe2d6f$var$lGEvents.beforeSlide + ".thumb", function(event) {
            var $thumb = _this.core.outer.find(".lg-thumb-item");
            var index = event.detail.index;
            $thumb.removeClass("active");
            $thumb.eq(index).addClass("active");
        });
    };
    // Toggle thumbnail bar
    Thumbnail.prototype.toggleThumbBar = function() {
        var _this = this;
        if (this.settings.toggleThumb) {
            this.core.outer.addClass("lg-can-toggle");
            this.core.$toolbar.append('<button type="button" aria-label="' + this.settings.thumbnailPluginStrings["toggleThumbnails"] + '" class="lg-toggle-thumb lg-icon"></button>');
            this.core.outer.find(".lg-toggle-thumb").first().on("click.lg", function() {
                _this.core.outer.toggleClass("lg-components-open");
            });
        }
    };
    Thumbnail.prototype.thumbKeyPress = function() {
        var _this = this;
        this.$LG(window).on("keydown.lg.thumb.global" + this.core.lgId, function(e) {
            if (!_this.core.lgOpened || !_this.settings.toggleThumb) return;
            if (e.keyCode === 38) {
                e.preventDefault();
                _this.core.outer.addClass("lg-components-open");
            } else if (e.keyCode === 40) {
                e.preventDefault();
                _this.core.outer.removeClass("lg-components-open");
            }
        });
    };
    Thumbnail.prototype.destroy = function() {
        if (this.settings.thumbnail) {
            this.$LG(window).off(".lg.thumb.global" + this.core.lgId);
            this.core.LGel.off(".lg.thumb");
            this.core.LGel.off(".thumb");
            this.$thumbOuter.remove();
            this.core.outer.removeClass("lg-has-thumb");
        }
    };
    return Thumbnail;
}();
var $5d9aacf729fe2d6f$export$2e2bcd8739ae039 = $5d9aacf729fe2d6f$var$Thumbnail;


function $943e46c78ee5d6e9$export$939e43573ccd2f80() {
    (0, $68e3467541a0efeb$export$2e2bcd8739ae039)(document.getElementById("gallery"), {
        plugins: [
            (0, $161cbdbc36aa5086$export$2e2bcd8739ae039),
            (0, $5d9aacf729fe2d6f$export$2e2bcd8739ae039)
        ],
        download: false
    });
}



function $170c8f98f34328e6$export$61fc7d43ac8f84b0(func, waitMilliseconds = 50, options = {
    isImmediate: false
}) {
    let timeoutId;
    return function(...args) {
        const context = this;
        const doLater = function() {
            timeoutId = undefined;
            if (!options.isImmediate) func.apply(context, args);
        };
        const shouldCallNow = options.isImmediate && timeoutId === undefined;
        if (timeoutId !== undefined) clearTimeout(timeoutId);
        timeoutId = setTimeout(doLater, waitMilliseconds);
        if (shouldCallNow) func.apply(context, args);
    };
}


// When loading responsive images, changing the screen orientation doesn't
// reload the images for the new screen size. Thus we need to force a re-render
// of all reponsive images so they fit the new screen size.
function $aae25f0ba88fec11$var$resizeHandler() {
    let images = document.querySelectorAll("img");
    for (let image of images){
        if (image.srcset === "") continue;
        image.srcset = image.srcset;
    }
}
window.addEventListener("resize", (0, $170c8f98f34328e6$export$61fc7d43ac8f84b0)($aae25f0ba88fec11$var$resizeHandler, 100));


var $bc6018afdbdde87a$exports = {};
"use strict";
Object.defineProperty($bc6018afdbdde87a$exports, "__esModule", {
    value: true
});
var $5f4dea19a9efdea8$exports = {};
"use strict";
Object.defineProperty($5f4dea19a9efdea8$exports, "__esModule", {
    value: true
});

const $5f4dea19a9efdea8$var$_left = "Left";
const $5f4dea19a9efdea8$var$_right = "Right";
class $5f4dea19a9efdea8$var$Either {
    constructor(value, tag){
        this.value = value;
        this.tag = tag;
        this.of = $5f4dea19a9efdea8$var$Either.of;
        this["fantasy-land/alt"] = this.alt;
        this["fantasy-land/of"] = this.of;
        this["fantasy-land/ap"] = this.ap;
        this["fantasy-land/chain"] = this.chain;
        this["fantasy-land/reduce"] = this.reduce;
        this["fantasy-land/map"] = this.map;
        this["fantasy-land/extend"] = this.extend;
        this["fantasy-land/equals"] = this.equals;
        this["fantasy-land/bimap"] = this.bimap;
    }
    asLeft() {
        return this;
    }
    asRight() {
        return this;
    }
    isLeft_() {
        return this.isLeft();
    }
    isRight_() {
        return this.isRight();
    }
    static of(value) {
        return $5f4dea19a9efdea8$exports.Right(value);
    }
    static lefts(list) {
        return list.filter((x)=>x.isLeft()).map((x)=>x.asLeft().value);
    }
    static rights(list) {
        return list.filter((x)=>x.isRight()).map((x)=>x.asRight().value);
    }
    static encase(throwsF) {
        try {
            return $5f4dea19a9efdea8$exports.Right(throwsF());
        } catch (e) {
            return $5f4dea19a9efdea8$exports.Left(e);
        }
    }
    isLeft() {
        return this.tag === $5f4dea19a9efdea8$var$_left;
    }
    isRight() {
        return this.tag === $5f4dea19a9efdea8$var$_right;
    }
    toJSON() {
        return this.value;
    }
    inspect() {
        return `${this.tag}(${JSON.stringify(this.value)})`;
    }
    toString() {
        return this.inspect();
    }
    bimap(f, g) {
        return this.isLeft_() ? $5f4dea19a9efdea8$exports.Left(f(this.asLeft().value)) : $5f4dea19a9efdea8$exports.Right(g(this.asRight().value));
    }
    map(f) {
        return this.bimap((x)=>x, f);
    }
    mapLeft(f) {
        return this.bimap(f, (x)=>x);
    }
    ap(other) {
        return other.isLeft_() ? other.asLeft() : this.map(other.asRight().value);
    }
    equals(other) {
        if (this.isLeft_() && other.isLeft_()) return this.value === other.value;
        if (this.isRight_() && other.isRight_()) return this.value === other.value;
        return false;
    }
    chain(f) {
        return this.isLeft_() ? this.asLeft() : f(this.asRight().value);
    }
    join() {
        return this.chain((x)=>x);
    }
    alt(other) {
        return this.isRight_() ? this : other;
    }
    reduce(reducer, initialValue) {
        return this.isLeft_() ? initialValue : reducer(initialValue, this.asRight().value);
    }
    extend(f) {
        return this.isLeft_() ? this.asLeft() : $5f4dea19a9efdea8$exports.Right(f(this));
    }
    unsafeCoerce() {
        return this.isLeft_() ? (()=>{
            throw new Error("Either got coerced to a Left");
        })() : this.asRight().value;
    }
    caseOf(patterns) {
        if ("_" in patterns) return patterns._();
        else return this.isLeft_() ? patterns.Left(this.asLeft().value) : patterns.Right(this.asRight().value);
    }
    leftOrDefault(defaultValue) {
        return this.isLeft_() ? this.asLeft().value : defaultValue;
    }
    orDefault(defaultValue) {
        return this.isRight_() ? this.asRight().value : defaultValue;
    }
    orDefaultLazy(getDefaultValue) {
        return this.isRight_() ? this.asRight().value : getDefaultValue();
    }
    leftOrDefaultLazy(getDefaultValue) {
        return this.isLeft_() ? this.asLeft().value : getDefaultValue();
    }
    ifLeft(effect) {
        return this.isLeft_() ? (effect(this.asLeft().value), this) : this;
    }
    ifRight(effect) {
        return this.isLeft_() ? this : (effect(this.asRight().value), this);
    }
    toMaybe() {
        return this.isLeft_() ? $bc6018afdbdde87a$exports.Nothing : $bc6018afdbdde87a$exports.Just(this.asRight().value);
    }
    leftToMaybe() {
        return this.isLeft_() ? $bc6018afdbdde87a$exports.Just(this.asLeft().value) : $bc6018afdbdde87a$exports.Nothing;
    }
    either(ifLeft, ifRight) {
        return this.isLeft_() ? ifLeft(this.asLeft().value) : ifRight(this.asRight().value);
    }
    extract() {
        return this.value;
    }
}
$5f4dea19a9efdea8$exports.Either = $5f4dea19a9efdea8$var$Either;
$5f4dea19a9efdea8$exports.Left = (value)=>new $5f4dea19a9efdea8$var$Either(value, $5f4dea19a9efdea8$var$_left);
$5f4dea19a9efdea8$exports.Right = (value)=>new $5f4dea19a9efdea8$var$Either(value, $5f4dea19a9efdea8$var$_right);


class $bc6018afdbdde87a$var$Maybe {
    constructor(value){
        this.value = value;
        this.of = $bc6018afdbdde87a$var$Maybe.of;
        this.zero = $bc6018afdbdde87a$var$Maybe.zero;
        this.empty = $bc6018afdbdde87a$var$Maybe.empty;
        this["fantasy-land/alt"] = this.alt;
        this["fantasy-land/of"] = this.of;
        this["fantasy-land/ap"] = this.ap;
        this["fantasy-land/chain"] = this.chain;
        this["fantasy-land/reduce"] = this.reduce;
        this["fantasy-land/map"] = this.map;
        this["fantasy-land/zero"] = this.zero;
        this["fantasy-land/extend"] = this.extend;
        this["fantasy-land/empty"] = this.empty;
        this["fantasy-land/equals"] = this.equals;
    }
    static of(value) {
        return $bc6018afdbdde87a$exports.Just(value);
    }
    static fromNullable(value) {
        return value == null ? $bc6018afdbdde87a$exports.Nothing : $bc6018afdbdde87a$exports.Just(value);
    }
    static fromFalsy(value) {
        return value ? $bc6018afdbdde87a$exports.Just(value) : $bc6018afdbdde87a$exports.Nothing;
    }
    static fromPredicate(pred, value) {
        switch(arguments.length){
            case 1:
                return (value)=>$bc6018afdbdde87a$var$Maybe.fromPredicate(pred, value);
            default:
                return pred(value) ? $bc6018afdbdde87a$exports.Just(value) : $bc6018afdbdde87a$exports.Nothing;
        }
    }
    static empty() {
        return $bc6018afdbdde87a$exports.Nothing;
    }
    static zero() {
        return $bc6018afdbdde87a$exports.Nothing;
    }
    static catMaybes(list) {
        return list.filter((x)=>x.isJust()).map((x)=>x.value);
    }
    static mapMaybe(f, list) {
        switch(arguments.length){
            case 1:
                return (list)=>$bc6018afdbdde87a$var$Maybe.mapMaybe(f, list);
            default:
                return $bc6018afdbdde87a$var$Maybe.catMaybes(list.map(f));
        }
    }
    static encase(thunk) {
        try {
            return $bc6018afdbdde87a$exports.Just(thunk());
        } catch (_a) {
            return $bc6018afdbdde87a$exports.Nothing;
        }
    }
    isJust() {
        return this.value !== null;
    }
    isNothing() {
        return this.value == null;
    }
    inspect() {
        return this.value === null ? "Nothing" : `Just(${this.value})`;
    }
    toString() {
        return this.inspect();
    }
    toJSON() {
        return this.value;
    }
    equals(other) {
        return this.value === other.value;
    }
    map(f) {
        return this.isNothing() ? $bc6018afdbdde87a$exports.Nothing : $bc6018afdbdde87a$exports.Just(f(this.value));
    }
    ap(maybeF) {
        return maybeF.isNothing() ? $bc6018afdbdde87a$exports.Nothing : this.map(maybeF.value);
    }
    alt(other) {
        return this.isNothing() ? other : this;
    }
    chain(f) {
        return this.isNothing() ? $bc6018afdbdde87a$exports.Nothing : f(this.value);
    }
    join() {
        return this.chain((x)=>x);
    }
    reduce(reducer, initialValue) {
        return this.isNothing() ? initialValue : reducer(initialValue, this.value);
    }
    extend(f) {
        return this.isNothing() ? $bc6018afdbdde87a$exports.Nothing : $bc6018afdbdde87a$exports.Just(f(this));
    }
    unsafeCoerce() {
        return this.isNothing() ? (()=>{
            throw new Error("Maybe got coerced to a null");
        })() : this.value;
    }
    caseOf(patterns) {
        if ("_" in patterns) return patterns._();
        else return this.isNothing() ? patterns.Nothing() : patterns.Just(this.value);
    }
    orDefault(defaultValue) {
        return this.isNothing() ? defaultValue : this.value;
    }
    orDefaultLazy(getDefaultValue) {
        return this.isNothing() ? getDefaultValue() : this.value;
    }
    toList() {
        return this.isNothing() ? [] : [
            this.value
        ];
    }
    mapOrDefault(f, defaultValue) {
        return this.map(f).orDefault(defaultValue);
    }
    extract() {
        return this.value;
    }
    toEither(left) {
        return this.isNothing() ? $5f4dea19a9efdea8$exports.Left(left) : $5f4dea19a9efdea8$exports.Right(this.value);
    }
    ifJust(effect) {
        return this.isJust() ? (effect(this.value), this) : this;
    }
    ifNothing(effect) {
        return this.isNothing() ? (effect(), this) : this;
    }
    filter(pred) {
        if (this.isNothing()) return $bc6018afdbdde87a$exports.Nothing;
        return pred(this.value) ? $bc6018afdbdde87a$exports.Just(this.value) : $bc6018afdbdde87a$exports.Nothing;
    }
}
$bc6018afdbdde87a$exports.Maybe = $bc6018afdbdde87a$var$Maybe;
$bc6018afdbdde87a$exports.Just = (value)=>new $bc6018afdbdde87a$var$Maybe(value);
$bc6018afdbdde87a$exports.Nothing = new $bc6018afdbdde87a$var$Maybe(null);


function $7865c307dafc1c96$export$d2cf6cd1dc7067d3(el, className) {
    el.classList.add(className);
}
function $7865c307dafc1c96$export$4ea3d958472af68f(el, className) {
    return el.classList.contains(className);
}
function $7865c307dafc1c96$export$c2255604a80b4506(el, className) {
    el.classList.remove(className);
}


const $5e59ca6648b2e921$var$$nav = (0, $bc6018afdbdde87a$exports.Maybe).fromNullable(document.querySelector("nav .nav__mobile .dropdown"));
const $5e59ca6648b2e921$var$$open = (0, $bc6018afdbdde87a$exports.Maybe).fromNullable(document.querySelector("nav .nav__mobile .nav__button a"));
const $5e59ca6648b2e921$var$$close = (0, $bc6018afdbdde87a$exports.Maybe).fromNullable(document.querySelector("nav .nav__mobile .close"));
function $5e59ca6648b2e921$var$measureScrollbar() {
    return (0, $bc6018afdbdde87a$exports.Maybe).fromNullable(document.querySelector("body")).map(($body)=>{
        const scrollDiv = document.createElement("div");
        scrollDiv.className = "scrollbar-measure";
        $body.append(scrollDiv);
        const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
        $body.removeChild(scrollDiv);
        return scrollbarWidth;
    });
}
function $5e59ca6648b2e921$var$enableBodyScroll() {
    (0, $bc6018afdbdde87a$exports.Maybe).fromNullable(document.querySelector("html")).map(($html)=>{
        $html.style.overflow = "";
        $html.style.paddingRight = "";
    });
}
function $5e59ca6648b2e921$var$disableBodyScroll() {
    (0, $bc6018afdbdde87a$exports.Maybe).fromNullable(document.querySelector("html")).map(($html)=>{
        let windowWidth = window.innerWidth;
        if (!windowWidth && document.documentElement !== null) {
            const documentElementRect = document.documentElement.getBoundingClientRect();
            windowWidth = documentElementRect.right - Math.abs(documentElementRect.left);
        }
        const isOverflowing = document.body.clientWidth < windowWidth;
        const scrollbarWidth = $5e59ca6648b2e921$var$measureScrollbar();
        $html.style.overflow = "hidden";
        if (isOverflowing) scrollbarWidth.map((w)=>$html.style.paddingRight = w + "px");
    });
}
function $5e59ca6648b2e921$var$close() {
    $5e59ca6648b2e921$var$enableBodyScroll();
    $5e59ca6648b2e921$var$$nav.map(($nav)=>$7865c307dafc1c96$export$d2cf6cd1dc7067d3($nav, "hide"));
    $5e59ca6648b2e921$var$$nav.map(($nav)=>$7865c307dafc1c96$export$c2255604a80b4506($nav, "nav__open"));
}
function $5e59ca6648b2e921$var$open() {
    $5e59ca6648b2e921$var$disableBodyScroll();
    $5e59ca6648b2e921$var$$nav.map(($nav)=>$7865c307dafc1c96$export$c2255604a80b4506($nav, "hide"));
    $5e59ca6648b2e921$var$$nav.map(($nav)=>$7865c307dafc1c96$export$d2cf6cd1dc7067d3($nav, "nav__open"));
}
$5e59ca6648b2e921$var$$open.map(($open)=>{
    $open.addEventListener("click", (e)=>{
        e.preventDefault();
        e.stopPropagation();
        $5e59ca6648b2e921$var$open();
    });
});
$5e59ca6648b2e921$var$$close.map(($close)=>{
    $close.addEventListener("click", (e)=>{
        e.preventDefault();
        e.stopPropagation();
        $5e59ca6648b2e921$var$close();
    });
});


// Configure position-sticky polyfill
const $6bcee6a4989673ce$var$navMain = document.querySelector("#nav-main");
if ($6bcee6a4989673ce$var$navMain !== null) (0, (/*@__PURE__*/$parcel$interopDefault($300c07af15a0d4e3$exports))).add($6bcee6a4989673ce$var$navMain);
// Configure object-fit polyfill
(0, (/*@__PURE__*/$parcel$interopDefault($069407aaccc90e9d$exports)))();
// Cookie consent
window.addEventListener("load", ()=>{
    window.cookieconsent.initialise({
        animateRevokable: false,
        position: "top",
        static: true,
        content: {
            message: "Mit der Nutzung dieser Website erkl\xe4ren Sie sich mit dem Einsatz von Cookies einverstanden.",
            dismiss: "Verstanden",
            link: "Zur Datenschutzerkl\xe4rung",
            href: "http://freitach4u.de/datenschutz"
        }
    });
});
// Initialize gallery
if (document.querySelectorAll("#gallery").length > 0) (0, $943e46c78ee5d6e9$export$939e43573ccd2f80)();


//# sourceMappingURL=main.db554039.js.map
